/* eslint-disable default-case */
import {
	Box,
	Checkbox,
	Divider,
	FormControl,
	FormControlLabel,
	FormLabel,
	Modal,
	Radio,
	RadioGroup,
	Typography,
	createFilterOptions,
} from "@mui/material";
import MuiAccordion from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import { styled } from "@mui/material/styles";
import React from "react";
import Close from "../../Components/Icons/Close";
import cssClasses from "./AgreementKYC.module.css";
import Button from "../../Subcomponents/Button";
import { makeStyles } from "@mui/styles";
import CustomInput from "../../Subcomponents/CustomInput";
import { useState } from "react";
import { getAadharCardDetails, getPAN_cardDetails } from "../../Services/SurepassApi";
import { dismissLoader, presentLoader } from "../../Services/loader";
import DropDown from "../../Subcomponents/DropDown";
import { useEffect, useRef } from "react";
import { errorTost, successTost } from "../../Services/Toast";
import ConfirmationAlert from "../../Subcomponents/ConfirmationAlert";
import LeadStatusChip from "../../Subcomponents/LeadStatusChip";
import AllotmentBuildingIcon from "../../Assets/Images/Common/AllotmentBuildingIcon.svg";
import Dot from "../../Components/Icons/Dot";
import AddApplicantIcon from "../../Assets/Images/Common/addApplicant.svg";
import ExpandedIcon from "../../Assets/Images/Common/chevron-right.svg";
import {
	addCRMLogs,
	changeApplicantReq,
	deleteApplicant,
	getCompanyDetails,
	getAgreement,
	getBankList,
	getBookingForm,
	getNBFCList,
	getPincodeData,
	getPincodes,
	submitAgreementForm,
	updateAgreement,
	updateAgreementInsertApplicantForm,
	updateAllotmentPaymentAgreement,
} from "../../Services/Agreement";
import PhoneInput, { parsePhoneNumber } from "react-phone-number-input";
import { isValidPhoneNumber } from "react-phone-number-input";
import CountdownTimer from "../../Subcomponents/CountDownTimer";
import { CheckCircleSharp } from "@mui/icons-material";
import { sendOTPMessageMail, sendOTPMessagePhone } from "../../Services/SmsService";
import CryptoJS from "crypto-js";
import { debounce } from "lodash";
import CustomAutoComplete from "../../Subcomponents/CustomAutoComplete";
import { supabase } from "../../supabaseClient";
import { useSelector } from "react-redux";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import DocumentPDFIcon from "../../Assets/Images/Common/Pdf.svg";
import PreviewModal from "../PreviewModal/PreviewModal";
import ImgIcon from "../../Assets/Images/Common/ImageIcon.svg";
import AgreementTermsAndConditions from "../AgreementTermsAndConditions/AgreementTermsAndConditions";
import Crm2BankBlock, { EMPTY_BANK, checkBank } from "../../Components/Home/Crm2/Crm2BankBlock";
import { isCrm2DocRef, crm2DocLink } from "../../Services/Crm2Portal";

const useStyles = makeStyles((theme) => ({
	closeIcon: {
		cursor: "pointer",
		position: "absolute",
		right: "0.7rem",
		top: "0.2rem",
	},
	stepper: {
		"& .MuiLinearProgress-root": {
			backgroundColor: "rgba(82, 108, 130, 0.1) !important",
			height: "0.8rem !important",
			borderRadius: "5rem !important",
			width: "100% !important",
			"& .MuiLinearProgress-bar": {
				backgroundColor: "#155EEF !important",
			},
		},
	},
}));

const Accordion = styled((props) => <MuiAccordion disableGutters elevation={0} square {...props} />)(({ theme }) => ({
	border: 0,
	borderRadius: "1.2rem",
	background: "#fff",
	padding: "0.6rem 1.6rem",
	width: "100%",
	boxSizing: "border-box",
	// "&:not(:last-child)": {
	// 	borderBottom: 0,
	// },
	"&:before": {
		display: "none",
	},
}));

const AccordionSummary = styled((props) => (
	<MuiAccordionSummary expandIcon={<img className={cssClasses.accordianExpandImg} src={ExpandedIcon} alt="expand" />} {...props} />
))(({ theme }) => ({
	padding: "0",
	flexDirection: "row",
	minHeight: "3.6rem",
	width: "100%",
	"& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
		transform: "rotate(90deg)",
		borderRadius: "0.8rem",
		border: "0.1rem solid #eaecf0",
		background: "#fff",
	},
	"& .MuiAccordionSummary-content": {
		// marginLeft: theme.spacing(1),
	},
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
	padding: 0,
	display: "flex",
	flexDirection: "column",
	gap: "1.6rem",
	alignItems: "flex-start",
}));

// crm2 (CRM 2.0 bookings only, M3-F3/F5): { submit(formState) } — the save goes to the server
// (routes/crm2Portal.js), files through the server, plus the bank block; old bookings never pass it.
const AgreementKYC = ({ open, handleClose, allotment, edit, crm2 }) => {
	const labelStyle = {
		fontFamily: "Inter-Medium",
		fontStyle: "normal",
		fontWeight: 500,
		fontSize: "1.4rem",
		lineHeight: "2rem",
		color: "#344054",
		marginBottom: "0.6rem",
	};
	function selectFiles(id, data, e, poaChange, type, loanSanction = false) {
		if (addBtnDisable && !poaChange && !loanSanction) {
			return;
		} else {
			let htmlElement = document.createElement("input");
			htmlElement.type = "file";
			htmlElement.accept = type === "pdf" ? "application/pdf,image/*" : "image/*";
			htmlElement.multiple = true;
			htmlElement.click();
			htmlElement.onchange = (e) => {
				onChangeSelectImage(id, data, e, poaChange);
			};
		}
	}
	function onChangeSelectImage(id, key, e, poaChange) {
		let _files = Object.keys(e.target.files).map((m) => e.target.files[m]);
		if (!_files.some((s) => !s.type.includes("pdf") && !s.type.includes("image"))) {
			if (_files[0].size > 52428800) {
				errorTost("Cannot not upload file size larger than 50MB");
			} else {
				handleAgreementChange(id, key, _files, poaChange);
			}
		} else {
			errorTost("Please select only PDF or image files.");
		}
	}
	function DeleteDoc(id, data, e, poaChange, loanSanction = false) {
		if (addBtnDisable && !poaChange && !loanSanction) {
			return;
		} else {
			handleAgreementChange(id, data, e, poaChange);
		}
	}
	const handleOpenPreviewModal = (value) => {
		// CRM 2.0 (M3.51): saved files are "crm2doc:<id>/<name>" in private storage → 10-minute link
		if (allotment?.isCrm2 && isCrm2DocRef(value?.value)) {
			crm2DocLink(allotment.allotmentPaymentId, value.value)
				.then((link) => {
					setSelectedFile({ ...value, value: link.url });
					setShowPreviewModal(true);
				})
				.catch((err) => errorTost(err.message));
			return;
		}
		setShowPreviewModal(true);
		setSelectedFile(value);
	};
	const classes = useStyles();
	let loggedInUser = useSelector((state) => state.Auth.user);
	const [agreementKYCs, setAgreementKYC] = useState([
		{
			panNumber: "",
			nameAsperPAN: "",
			aadharNumber: "",
			salutation: "",
			firstName: "",
			lastName: "",
			middleName: "",
			leadDob: "",
			age: "",
			gender: "",
			occupation: "",
			otherOccupation: "",
			contactNumber: "",
			email: "",
			addressLine1: "",
			addressLine2: "",
			addressLine3: "",
			pincode: "",
			country: "",
			state: "",
			aadharFileUrl: { url1: "", url2: "", type: "pdf" },
			panFileUrl: { url: "", type: "pdf" },
			city: "",
			countryCode: "IN",
			addressAsPrimaryApplicant: false,
			loanSanctionUrl: { url: "", type: "pdf" },
			poa: false,
			poaData: {
				panNumber: "",
				nameAsperPAN: "",
				aadharNumber: "",
				salutation: "",
				firstName: "",
				lastName: "",
				middleName: "",
				age: "",
				gender: "",
				occupation: "",
				otherOccupation: "",
				addressLine1: "",
				addressLine2: "",
				addressLine3: "",
				pincode: "",
				country: "",
				state: "",
				city: "",
				contactNumber: "",
				email: "",
				aadharFileUrl: { url1: "", url2: "", type: "pdf" },
				panFileUrl: { url: "", type: "pdf" },
			},
			applicantId: "",
			agreementFormId: "",
		},
	]);
	const [helperText, setHelperText] = useState([
		{
			panNumber: "",
			nameAsperPAN: "",
			aadharNumber: "",
			salutation: "",
			firstName: "",
			middleName: "",
			lastName: "",
			leadDob: "",
			age: "",
			gender: "",
			occupation: "",
			otherOccupation: "",
			contactNumber: "",
			email: "",
			addressLine1: "",
			addressLine2: "",
			addressLine3: "",
			pincode: "",
			aadharFileUrl: "",
			panFileUrl: "",
			poa: false,
			poaData: {
				panNumber: "",
				nameAsperPAN: "",
				aadharNumber: "",
				salutation: "",
				firstName: "",
				middleName: "",
				lastName: "",
				age: "",
				gender: "",
				occupation: "",
				otherOccupation: "",
				contactNumber: "",
				email: "",
				addressLine1: "",
				addressLine2: "",
				addressLine3: "",
				pincode: "",
				aadharFileUrl: "",
				panFileUrl: "",
			},
		},
	]);
	const [panSuccess, setPanSuccess] = useState({
		pan0: false,
		pan1: false,
		pan2: false,
		pan3: false,
	});
	const [panSuccessPOA, setPanSuccessPOA] = useState({
		pan0: false,
		pan1: false,
		pan2: false,
		pan3: false,
	});
	const [openConfirmationModal, setOpenConfirmationModal] = useState(false);
	const [openChangeReqConfirmationModal, setOpenChangeReqConfirmationModal] = useState(false);
	const [name, setName] = useState({ index: 0, name: "", poaData: false });
	const [addBtnDisable, setAddBtnDisable] = useState(true);
	const [addApplicantDisable, setAddApplicantDisable] = useState(true);
	const [aadharSuccess, setAadharSuccess] = useState({
		aadhar0: false,
		aadhar1: false,
		aadhar2: false,
		aadhar3: false,
	});
	const [aadharSuccessPOA, setAadharSuccessPOA] = useState({
		aadhar0: false,
		aadhar1: false,
		aadhar2: false,
		aadhar3: false,
	});
	const [pincodes, setPincodes] = useState([]);
	const [bankList, setBankList] = useState([]);
	// const [nbfcList, setNBFCList] = useState([]);
	const [value, setValue] = useState("yes");
	const [selfFundedValue, setSelfFundedValue] = useState("bank");
	const [expanded, setExpanded] = useState(false);
	const [pincodeInput, setPincodeInput] = useState({
		pin0: "",
		pin1: "",
		pin2: "",
		pin3: "",
	});
	const [poaPincodeInput, setPoaPincodeInput] = useState({
		pin0: "",
		pin1: "",
		pin2: "",
		pin3: "",
	});
	const [showHelperText, setShowHelperText] = useState(false);
	const [emailLabelText, setEmailLabelText] = useState("");
	const [updateProfile, setUpdateProfile] = useState({
		email: "",
		contactNumber: "",
	});
	const [loanData, setLoanData] = useState("");
	const [otherBank, setOtherBank] = useState("");
	const [loanSource, setLoanSource] = useState(""); // "VJ" | "Other"
	const verifiedPhoneNumber = useRef(false);
	const verifyingNumber = useRef(false);
	const verifiedEmail = useRef(false);
	const [otptimerEmail, setOtpTimerEmail] = useState(false);
	const [showEmailOtp, setShowEmailOtp] = useState(false);
	const [emailState, setEmailState] = useState({
		otp1: "",
		otp2: "",
		otp3: "",
		otp4: "",
	});
	const [recievedEmailOtp, setRecievedEmailOtp] = useState(null);
	// ------------------------Phone number otp
	const [showOtp, setShowOtp] = useState(false);
	const [isInterNational, setIsInterNational] = useState(false);
	const [resendButton, setResendButton] = useState(false);
	const [otptimer, setOtpTimer] = useState(false);
	const [state, setState] = useState({
		otp1: "",
		otp2: "",
		otp3: "",
		otp4: "",
	});
	const [recievedOtp, setRecievedOtp] = useState(null);
	const [changeReqApproved, setChangeReqApproved] = useState({
		agreementFormId: "",
		status: null,
	});
	const [deleteUsers, setDeleteUsers] = useState([]);
	// CRM 2.0 (M3.2): bank account in the Agreement KYC
	const [crm2Bank, setCrm2Bank] = useState({ ...EMPTY_BANK });
	const [crm2BankErrors, setCrm2BankErrors] = useState({});
	const [companyDetails, setCompanyDetails] = useState({ name: "" });
	const [showAgreementTerms, setShowAgreementTerms] = useState(false);

	const OccupationList = ["Service", "Business", "Housewife", "Self Employed", "Other"];
	const [docUrl, setDocUrl] = useState([]);
	const [selectedFile, setSelectedFile] = useState({ value: "", type: "" });
	const [showPreviewModal, setShowPreviewModal] = useState(false);
	const [filesToDelete, setFilesToDelete] = useState([]);
	const salutationList = ["Mr.", "Mrs.", "Miss.", "Ms."];
	const [bankerDetails, setBankerDetails] = useState({
		name: "",
		contactNumber: "",
	});
	const [bankerDetailsHelperText, setBankerDetailsHelperText] = useState({
		name: "",
		contactNumber: "",
	});

	async function fetchData() {
		await getPincodes().then((pin) => {
			setPincodes(
				pin.map((m) => {
					return m.pincode.toString();
				})
			);
		});
		await getBankList().then((resp) => {
			setBankList(resp);
		});
		// await getNBFCList().then((resp) => {
		// 	setNBFCList(resp);
		// });
		const buId = allotment?.inventoryMergedId
			? allotment?.inventoryMergedId?.unit1Id?.projectId?.buId
			: allotment?.unitId?.projectId?.buId;
		if (buId) {
			const companyName = await getCompanyDetails(buId);
			if (companyName) {
				setCompanyDetails({ name: companyName });
			}
		}
	}

	function calculateAge(birthTimeEpoch) {
		var currentTimeEpoch = Date.now();

		var differenceInMillis = currentTimeEpoch - birthTimeEpoch;

		var age = Math.floor(differenceInMillis / (1000 * 60 * 60 * 24 * 365.25));

		return age;
	}

	function convertTimeStamptoDate(date) {
		let newdate = new Date(date);
		let formattedDate = newdate.getFullYear() + "-";

		if (newdate.getMonth() < 9) {
			formattedDate += "0";
		}
		formattedDate += newdate.getMonth() + 1;
		formattedDate += "-";

		if (newdate.getDate() < 10) {
			formattedDate += "0";
		}
		formattedDate += newdate.getDate();
		return formattedDate;
	}

	const get18YearsAgoDate = () => {
		const today = new Date();
		today.setFullYear(today.getFullYear() - 18);
		return today.toISOString().split('T')[0]; // Format as YYYY-MM-DD
	};
	async function getFormData() {
		return await getBookingForm(allotment?.bookingFormId)
			.then((resp) => {
				if (resp[0]) {
					dismissLoader();
					return resp[0];
				} else {
					dismissLoader();
					errorTost("Could not get Booking Form Details!");
					return null;
				}
			})
			.catch((err) => {
				console.error(err);
				dismissLoader();
				errorTost("Could not get Booking Form Details!");
				return null;
			});
	}
	function rearrangeByType(data) {
		const typeOrder = ["first", "second", "third", "fourth"];

		return data.sort((a, b) => {
			return typeOrder.indexOf(a.type) - typeOrder.indexOf(b.type);
		});
	}
	async function getBookingData() {
		presentLoader();
		let bookingFormData = typeof allotment?.bookingFormId === "object" ? allotment?.bookingFormId : await getFormData();
		setAgreementKYC([
			{
				panNumber: bookingFormData?.panNumber?.toUpperCase(),
				nameAsperPAN: bookingFormData?.firstName + " " + bookingFormData?.middleName + " " + bookingFormData?.lastName,
				salutation: bookingFormData?.salutation ? (!bookingFormData?.salutation.endsWith(".") ? bookingFormData?.salutation : bookingFormData?.salutation + ".") : "",
				firstName: bookingFormData?.firstName,
				middleName: bookingFormData?.middleName,
				lastName: bookingFormData?.lastName,
				leadDob: bookingFormData?.leadDob ? convertTimeStamptoDate(bookingFormData?.leadDob) : "",
				age: bookingFormData?.leadDob ? calculateAge(bookingFormData?.leadDob) : "",
				gender: bookingFormData?.gender ? bookingFormData?.gender : "",
				occupation: "",
				otherOccupation: "",
				contactNumber: bookingFormData?.contactNumber,
				email: bookingFormData?.email,
				poa: false,
				aadharNumber: bookingFormData?.aadharNumber ? bookingFormData?.aadharNumber : "",
				addressLine1: bookingFormData?.addressLine1 ? bookingFormData?.addressLine1 : "",
				addressLine2: bookingFormData?.addressLine2 ? bookingFormData?.addressLine2 : "",
				addressLine3: bookingFormData?.addressLine3 ? bookingFormData?.addressLine3 : "",
				pincode: bookingFormData?.pincode ? bookingFormData?.pincode : "",
				country: bookingFormData?.country ? bookingFormData?.country : "",
				state: bookingFormData?.state ? bookingFormData?.state : "",
				city: bookingFormData?.city ? bookingFormData?.city : "",
				aadharFileUrl: { url1: "", url2: "", type: "pdf" },
				panFileUrl: { url: "", type: "pdf" },
				countryCode: "IN",
				addressAsPrimaryApplicant: false,
				loanSanctionUrl: { url: "", type: "pdf" },
				poaData: {
					panNumber: "",
					nameAsperPAN: "",
					salutation: "",
					firstName: "",
					lastName: "",
					middleName: "",
					age: "",
					gender: "",
					occupation: "",
					otherOccupation: "",
					contactNumber: "",
					addressLine1: "",
					addressLine2: "",
					addressLine3: "",
					country: "",
					pincode: "",
					state: "",
					city: "",
					email: "",
					aadharNumber: "",
					aadharFileUrl: { url1: "", url2: "", type: "pdf" },
					panFileUrl: { url: "", type: "pdf" },
				},
				applicantId: "",
				agreementFormId: "",
			},
		]);
		setPanSuccess({
			...panSuccess,
			pan0: true,
		});
		setAddBtnDisable(false);
		setAddApplicantDisable(false);
		verifiedPhoneNumber.current = bookingFormData?.contactNumber ? true : false;
		verifiedEmail.current = bookingFormData?.email ? true : false;
		setUpdateProfile({
			email: bookingFormData?.email ? bookingFormData?.email : "",
			contactNumber: bookingFormData?.contactNumber ? bookingFormData?.contactNumber : "",
		});
		dismissLoader();
	}

	useEffect(() => {
		presentLoader();
		const lists = fetchData();
		if (!edit && allotment?.bookingFormId && !allotment?.isCrm2) {
			getBookingData();
		} else {
			// CRM 2.0 new KYC (no booking form prefill): open the empty form for typing (the prefill does this in the old
			// flow) and hide the loader once the lists are in
			if (!edit) {
				setAddBtnDisable(false);
				setAddApplicantDisable(false);
				lists
					.catch((err) => console.error("[crm2][AgreementKYC] lists not loaded", err))
					.finally(() => dismissLoader());
			}
			if (edit) {
				getAgreement(allotment?.allotmentPaymentId)
					.then((resp) => {
						if (resp) {
							const data = rearrangeByType(resp.applicant.data);
							setValue(resp.agreementForm?.isSelfFunded ? "no" : "yes");
							setSelfFundedValue(resp.agreementForm?.isSelfFunded ? "bank" : resp.agreementForm?.bankType);
							if (allotment?.isCrm2 && resp.agreementForm?.customerBankDetails) setCrm2Bank({ ...EMPTY_BANK, ...resp.agreementForm.customerBankDetails });
							setLoanData(resp.agreementForm?.bankId ? resp.agreementForm?.bankId : "Other");
							setOtherBank(resp.agreementForm?.otherBank ? resp.agreementForm?.otherBank : "");
							//  setLoanData(
							// 	!resp.agreementForm?.isSelfFunded && resp.agreementForm?.bankType === "nbfc"
							// 		? resp.agreementForm?.nbfcId
							// 		: resp.agreementForm?.bankId
							// );
							setChangeReqApproved({
								agreementFormId: resp.agreementForm?.agreementFormId,
								status: resp.agreementForm?.ChangeApplicantRequests[resp.agreementForm?.ChangeApplicantRequests?.length - 1]?.status,
							});
							setBankerDetails({
								name: resp.agreementForm?.loanDetails?.name ? resp.agreementForm?.loanDetails?.name : "",
								contactNumber: resp.agreementForm?.loanDetails?.contactNumber ? resp.agreementForm?.loanDetails?.contactNumber : ""
							})
							setLoanSource(resp.agreementForm?.loanDetails?.loanSource ? resp.agreementForm?.loanDetails?.loanSource : "Other");
							let array = [];
							let helperObj = {
								panNumber: "",
								nameAsperPAN: "",
								aadharNumber: "",
								salutation: "",
								firstName: "",
								middleName: "",
								lastName: "",
								leadDob: "",
								age: "",
								gender: "",
								occupation: "",
								otherOccupation: "",
								contactNumber: "",
								email: "",
								poa: false,
								addressLine1: "",
								addressLine2: "",
								addressLine3: "",
								pincode: "",
								aadharFileUrl: "",
								panFileUrl: "",
								poaData: {
									panNumber: "",
									nameAsperPAN: "",
									aadharNumber: "",
									salutation: "",
									firstName: "",
									middleName: "",
									lastName: "",
									age: "",
									gender: "",
									occupation: "",
									otherOccupation: "",
									contactNumber: "",
									email: "",
									addressLine1: "",
									addressLine2: "",
									addressLine3: "",
									pincode: "",
									aadharFileUrl: "",
									panFileUrl: "",
								},
							};
							let helperArray = [];
							let panSuccessObj = {
								pan0: false,
								pan1: false,
								pan2: false,
								pan3: false,
							};
							let panSuccessPOAObj = {
								pan0: false,
								pan1: false,
								pan2: false,
								pan3: false,
							};
							let aadharSuccessObj = {
								aadhar0: false,
								aadhar1: false,
								aadhar2: false,
								aadhar3: false,
							};
							let aadharSuccessPOAObj = {
								aadhar0: false,
								aadhar1: false,
								aadhar2: false,
								aadhar3: false,
							};
							data.map((value, i) => {
								let obj = {
									...value.applicant,
									panNumber: value.applicant.panNumber.toUpperCase(),
									nameAsperPAN: value?.applicant.nameAsperPAN
										? value?.applicant.nameAsperPAN
										: value.applicant.firstName + " " + value.applicant.middleName + " " + value.applicant.lastName,
									aadharNumber: value.applicant.aadharNumber ? value.applicant.aadharNumber : "",
									addressLine1: value.applicant.addressLine1 ? value.applicant.addressLine1 : "",
									addressLine2: value.applicant.addressLine2 ? value.applicant.addressLine2 : "",
									addressLine3: value.applicant.addressLine3 ? value.applicant.addressLine3 : "",
									pincode: value.applicant.pincode ? value.applicant.pincode : "",
									country: value.applicant.country ? value.applicant.country : "",
									state: value.applicant.state ? value.applicant.state : "",
									city: value.applicant.city ? value.applicant.city : "",
									leadDob: value.applicant.leadDob ? convertTimeStamptoDate(value.applicant.leadDob) : "",
									otherOccupation: value.applicant.otherOccupation ? value.applicant.otherOccupation : "",
									aadharFileUrl: value?.applicant?.aadharFileUrl
										? typeof value?.applicant?.aadharFileUrl !== "object"
											? { url1: value?.applicant?.aadharFileUrl, url2: "", type: "pdf" }
											: value?.applicant?.aadharFileUrl
										: { url1: "", url2: "", type: "pdf" },
									panFileUrl: value?.applicant?.panFileUrl
										? typeof value?.applicant?.panFileUrl !== "object"
											? { url: value?.applicant?.panFileUrl, type: "pdf" }
											: value?.applicant?.panFileUrl
										: { url: "", type: "pdf" },
									loanSanctionUrl: value?.applicant?.loanSanctionUrl
										? typeof value?.applicant?.loanSanctionUrl !== "object"
											? { url: value?.applicant?.loanSanctionUrl, type: "pdf" }
											: value?.applicant?.loanSanctionUrl : { url: "", type: "pdf" },
									countryCode: value?.applicant?.countryCode ? value?.applicant?.countryCode : "IN",
									addressAsPrimaryApplicant: value.applicant.addressAsPrimaryApplicant ? value.applicant.addressAsPrimaryApplicant : false,
									salutation: !value.applicant?.salutation ? "" : value.applicant.salutation.endsWith(".") ? value.applicant.salutation : value.applicant.salutation + ".",
									poaData:
										value.POA !== null
											? {
												...value.POA,
												panNumber: value.POA.panNumber.toUpperCase(),
												nameAsperPAN: value?.POA.nameAsperPAN
													? value?.POA.nameAsperPAN
													: value.POA.firstName + " " + value.POA.middleName + " " + value.POA.lastName,
												aadharFileUrl: value.POA.aadharFileUrl
													? typeof value?.POA?.aadharFileUrl !== "object"
														? { url1: value?.POA?.aadharFileUrl, url2: "", type: "pdf" }
														: value?.POA?.aadharFileUrl
													: { url1: "", url2: "", type: "pdf" },
												panFileUrl: value.POA.panFileUrl
													? typeof value?.POA?.panFileUrl !== "object"
														? { url: value?.POA?.panFileUrl, type: "pdf" }
														: value?.POA?.panFileUrl
													: { url: "", type: "pdf" },
												salutation: !value.POA?.salutation ? "" : value.POA.salutation.endsWith(".") ? value.POA.salutation : value.POA.salutation + ".",
											}
											: {
												panNumber: "",
												nameAsperPAN: "",
												salutation: "",
												firstName: "",
												lastName: "",
												middleName: "",
												age: "",
												gender: "",
												occupation: "",
												otherOccupation: "",
												contactNumber: "",
												email: "",
												aadharNumber: "",
												addressLine1: "",
												addressLine2: "",
												addressLine3: "",
												pincode: "",
												aadharFileUrl: { url1: "", url2: "", type: "pdf" },
												panFileUrl: { url: "", type: "pdf" },
											},
									poa: value.POA?.salutation?.length > 0 ? true : false,
									applicantId: value.applicantId,
									agreementFormId: value.agreementFormId,
								};
								array.push(obj);
								helperArray.push(JSON.parse(JSON.stringify(helperObj)));
								panSuccessObj[`pan${i}`] = true;
								aadharSuccessObj[`aadhar${i}`] = true;
								if (value.POA !== null) {
									panSuccessPOAObj[`pan${i}`] = true;
									aadharSuccessPOAObj[`aadhar${i}`] = true;
								}
							});
							verifiedPhoneNumber.current = true;
							verifiedEmail.current = true;
							setUpdateProfile({
								email: data[0].applicant.email,
								contactNumber: data[0].applicant.contactNumber,
							});
							setAgreementKYC(array);
							setHelperText(helperArray);
							setPanSuccess(panSuccessObj);
							setPanSuccessPOA(panSuccessPOAObj);
							setAadharSuccess(aadharSuccessObj);
							setAadharSuccessPOA(aadharSuccessPOAObj);
							if (allotment?.isCrm2) {
								// CRM 2.0 (DC-86): applicants are added / removed in the form until Final Review approval
								setAddApplicantDisable(data.length >= 4);
								setAddBtnDisable(false);
							} else if (allotment?.CRM[0]?.crmStatusId < 2 || allotment?.CRM?.length === 0) {
								if (data.length < 4) {
									setAddApplicantDisable(false);
									setAddBtnDisable(false);
								} else {
									setAddBtnDisable(false);
								}
							} else if (
								allotment?.CRM[0]?.crmStatusId >= 2 &&
								resp.agreementForm?.ChangeApplicantRequests[resp.agreementForm?.ChangeApplicantRequests?.length - 1]?.status ===
								"accepted" &&
								!allotment?.CRM[0]?.isChangeApplicantRaised
							) {
								if (data.length < 4) {
									setAddApplicantDisable(false);
									setAddBtnDisable(false);
								} else {
									setAddBtnDisable(false);
								}
							} else {
								setAddApplicantDisable(true);
								setAddBtnDisable(true);
							}
							dismissLoader();
						} else {
							errorTost("Could not get Agreement Details!");
							dismissLoader();
						}
					})
					.catch((err) => {
						errorTost("Could not get Agreement Details!");
						dismissLoader();
					});
			}
		}
	}, []);

	useEffect(() => {
		if (changeReqApproved.agreementFormId !== "") {
			let updateChangeApplicantReqListener = supabase
				.from(`ChangeApplicantRequests:agreementFormId=eq.${changeReqApproved.agreementFormId}`)
				.on("UPDATE", (handleRecordUpdated) => {
					console.log(handleRecordUpdated);
					setChangeReqApproved({
						...changeReqApproved,
						status: handleRecordUpdated.new.status,
					});
				})
				.subscribe((status) => {
					console.log("status: ", status);
				});
			return () => {
				if (updateChangeApplicantReqListener) {
					supabase.removeSubscription(updateChangeApplicantReqListener);
					updateChangeApplicantReqListener = null;
				}
			};
		}
	}, [changeReqApproved]);

	function closeModal() {
		handleClose();
	}

	function applicantType(i) {
		switch (i) {
			case 0:
				return "first";
			case 1:
				return "second";
			case 2:
				return "third";
			case 3:
				return "fourth";
		}
	}
	function validateData(assignData, agreement, i, flag) {
		Object.keys(agreement).forEach(function (data) {
			const e = agreement[data];

			if (
				!e ||
				e === "" ||
				data === "poaData" ||
				assignData[data] !== "" ||
				data === "panFileUrl" ||
				data === "aadharFileUrl" ||
				data === "leadDob" ||
				data === "age" ||
				data === "loanSanctionUrl"
			) {
				switch (data) {
					case "salutation":
						if (!e || e === "") {
							flag = false;
							assignData[data] = "Please Select Salutation";
						}
						break;
					case "firstName":
						if (!e || e === "") {
							flag = false;
							assignData[data] = "Please Enter First Name";
						}
						break;
					case "lastName":
						if (!e || e === "") {
							flag = false;
							assignData[data] = "Please Enter Last Name";
						}
						break;
					case "age":
						if (e < 18) {
							flag = false;
							assignData[data] = "Applicant must be at least 18 years old.";
						} else if (e === "" || !e) {
							flag = false;
							assignData[data] = "Please Enter Age";
						} else {
							flag = flag;
							assignData[data] = "";
						}

						break;
					case "gender":
						if (!e || e === "") {
							flag = false;
							assignData[data] = "Please Select Gender";
						}
						break;
					case "occupation":
						if (!e || e === "") {
							flag = false;
							assignData[data] = "Please Select Occupation";
						}
						break;
					case "contactNumber":
						if (!e || e === "") {
							flag = false;
							assignData[data] = "Please Enter Contact Number";
						}
						break;
					case "email":
						if (!e || e === "") {
							flag = false;
							assignData[data] = "Please Enter Email Id";
						}
						break;
					case "panNumber":
						if (!e || e === "") {
							flag = false;
							assignData[data] = "Please Enter Pan Card Number";
						}
						break;
					case "aadharNumber":
						if (!e || e === "") {
							flag = false;
							assignData[data] = "Please Enter Aadhar Number";
						}
						break;
					case "addressLine1":
						if (!e || e === "") {
							flag = false;
							assignData[data] = "Please Enter Address Line 1";
						}
						break;
					case "addressLine2":
						if (!e || e === "") {
							flag = false;
							assignData[data] = "Please Enter Address Line 2";
						}
						break;
					case "addressLine3":
						if (!e || e === "") {
							flag = false;
							assignData[data] = "Please Enter Address Line 3";
						}
						break;
					case "pincode":
						if (!e || e === "") {
							flag = false;
							assignData[data] = "Please Select Pincode";
						}
						break;
					case "poaData":
						if (agreement.poa) {
							const obj = validateData(assignData[data], e, i, flag);
							assignData[data] = obj.assignData;
							flag = obj.flag;
						}
						break;
					case "leadDob":
						const birthdateDate = new Date(e);
						const today = new Date();
						const age = today.getFullYear() - birthdateDate.getFullYear();
						const monthDifference = today.getMonth() - birthdateDate.getMonth();
						const isBirthdayPassed = monthDifference > 0 || (monthDifference === 0 && today.getDate() >= birthdateDate.getDate());
						if (age < 18 || (age === 18 && !isBirthdayPassed)) {
							flag = false;
							assignData[data] = "Applicant must be at least 18 years old.";
						} else if (!e || e === "") {
							flag = false;
							assignData[data] = "Please Enter Date of Birth";
						} else {
							flag = flag;
							assignData[data] = "";
						}

						break;
					case "otherOccupation":
						if (agreement.occupation === "Other") {
							flag = false;
							assignData[data] = "Please Enter Other Occupation";
						}
						break;
					case "aadharFileUrl":
						if (e.url1 === "" && e.type === "pdf") {
							flag = false;
							assignData[data] = "Please add Aadhar Card document";
						} else if ((e.url1 === "" || e.url2 === "") && e.type !== "pdf") {
							flag = false;
							assignData[data] = "Please add Aadhar Card document";
						} else {
							flag = flag;
						}
						break;
					case "panFileUrl":
						if (e.url === "") {
							flag = false;
							assignData[data] = "Please add Pan Card document";
						}
						break;
					case "loanSanctionUrl":
						if (e.url === "" && i === 0 && value === "yes") {
							flag = false;
							assignData[data] = "Please upload Loan Sanction Letter";
						}
						break;
				}
			}
			if (i === 0) {
				switch (data) {
					case "contactNumber":
						if (!verifiedPhoneNumber.current) {
							flag = false;
							if (updateProfile.contactNumber) {
								assignData[data] = "Please Verify Contact Number";
							} else {
								assignData[data] = "Please Enter Contact Number";
							}
						}
						break;
					case "email":
						if (!verifiedEmail.current) {
							flag = false;
							if (updateProfile.email) {
								assignData[data] = "Please Verify Email Id";
							} else {
								assignData[data] = "Please Enter Email Id";
							}
						}
						break;
				}
			}
		});
		return { assignData, flag };
	}

	function validateForm() {
		let flag = true;
		let myObj = [...helperText];
		let validArray = [];
		agreementKYCs.map((agreement, i) => {
			const validObj = validateData(myObj[i], agreement, i, flag);
			validArray.push(validObj.assignData);
			flag = validObj.flag;
		});
		setHelperText(validArray);
		return flag;
	}
	const validateLaonData = () => {
		let flag = false;
		if (value === "yes") {
			if (loanData) {
				flag = true;
			} else {
				setShowHelperText(true);
			}
			if (bankerDetails.contactNumber === "") {
				flag = false;
				setBankerDetailsHelperText((pre) => {
					pre.contactNumber = "Please Enter Banker Contact Number";
					return { ...pre };
				});
			} else if (bankerDetails.contactNumber.length !== 10) {
				flag = false;
				setBankerDetailsHelperText((pre) => {
					pre.contactNumber = "Contact number should be 10 digits";
					return { ...pre };
				});
			} else {
				flag = true;
				setBankerDetailsHelperText((pre) => {
					pre.contactNumber = "";
					return { ...pre };
				});
			}
			if (bankerDetails.name === "") {
				flag = false;
				setBankerDetailsHelperText((pre) => {
					pre.name = "Please Enter Banker Name";
					return { ...pre };
				});
			} else {
				flag = true;
				setBankerDetailsHelperText((pre) => {
					pre.name = "";
					return { ...pre };
				});
			}
			if (!loanSource) {
				flag = false;
				setShowHelperText(true);
			}
		} else {
			flag = true;
		}
		return flag;
	};

	function handleSaveClick() {
		const flag = validateForm();
		const loanFlag = validateLaonData();
		if (allotment?.isCrm2) {
			const bankErr = checkBank(crm2Bank, agreementKYCs[0]);
			setCrm2BankErrors(bankErr);
			if (Object.keys(bankErr).length) {
				errorTost(Object.values(bankErr)[0]);
				return;
			}
		}
		if (flag && loanFlag) {
			if (allotment?.isCrm2 && crm2?.beforeSave) crm2.beforeSave(() => saveForm(), () => setShowAgreementTerms(true));
			else setShowAgreementTerms(true);
		}
	}

	async function saveForm() {
		const flag = validateForm();
		const loanFlag = validateLaonData();
		if (!allotment?.CRM[0]?.sentForAgreement) {
			if (flag && loanFlag) {
				presentLoader();
				let applicantsData = [];
				agreementKYCs.map((agreement, i) => {
					let obj = {
						type: applicantType(i),
						agreementFormId: agreementKYCs[0]?.agreementFormId,
						applicant: {
							salutation: agreement.salutation,
							firstName: agreement.firstName,
							middleName: agreement.middleName,
							lastName: agreement.lastName,
							leadDob: Date.parse(agreement.leadDob),
							age: agreement.age,
							gender: agreement.gender,
							occupation: agreement.occupation,
							otherOccupation: agreement.otherOccupation,
							contactNumber: agreement.contactNumber,
							email: agreement.email,
							panNumber: agreement.panNumber,
							nameAsperPAN: agreement.nameAsperPAN,
							aadharNumber: agreement.aadharNumber,
							addressLine1: agreement.addressLine1,
							addressLine2: agreement.addressLine2,
							addressLine3: agreement.addressLine3,
							pincode: agreement.pincode,
							country: agreement.country,
							state: agreement.state,
							city: agreement.city,
							aadharFileUrl: agreement.aadharFileUrl,
							panFileUrl: agreement.panFileUrl,
							loanSanctionUrl: agreement.loanSanctionUrl,
							addressAsPrimaryApplicant: agreement.addressAsPrimaryApplicant
						},
						POA: agreement.poa
							? {
								salutation: agreement.poaData.salutation,
								firstName: agreement.poaData.firstName,
								middleName: agreement.poaData.middleName,
								lastName: agreement.poaData.lastName,
								age: agreement.poaData.age,
								gender: agreement.poaData.gender,
								occupation: agreement.poaData.occupation,
								otherOccupation: agreement.poaData.otherOccupation,
								contactNumber: agreement.poaData.contactNumber,
								email: agreement.poaData.email,
								panNumber: agreement.poaData.panNumber,
								nameAsperPAN: agreement.poaData.nameAsperPAN,
								aadharNumber: agreement.poaData.aadharNumber,
								addressLine1: agreement.addressLine1,
								addressLine2: agreement.addressLine2,
								addressLine3: agreement.addressLine3,
								pincode: agreement.poaData.pincode,
								country: agreement.poaData.country,
								state: agreement.poaData.state,
								city: agreement.poaData.city,
								aadharFileUrl: agreement.poaData.aadharFileUrl,
								panFileUrl: agreement.poaData.panFileUrl,
							}
							: null,
					};
					applicantsData.push(obj);
				});
				// CRM 2.0 (M3-F3 / F5): the server saves everything in one go; old bookings continue below
				if (allotment?.isCrm2 && crm2) {
					await crm2.submit({ applicantsData, agreementKYCs, deleteUsers, value, selfFundedValue, loanData, otherBank, bankerDetails, loanSource, bank: crm2Bank });
					return;
				}
				if (edit) {
					let errorOccure = false;
					let data = [];
					let ObjData = {
						allotmentPaymentId: allotment.allotmentPaymentId,
						isSelfFunded: value === "no" ? true : false,
						bankType: value === "yes" ? selfFundedValue : null,
						applicants: applicantsData,
						loanDetails: { ...bankerDetails, loanSource: value === "yes" ? loanSource : null }
					};
					if (value === "yes") {
						if (selfFundedValue === "bank") {
							if (loanData !== "Other") {
							ObjData.bankId = loanData;
							} else {
								ObjData.bankId = null;
								ObjData.otherBank = otherBank;
							}
						}
						// else {
						// 	ObjData.nbfcId = loanData;
						// }
					}

					for (let i = 0; i < agreementKYCs.length; i++) {
						const agreement = agreementKYCs[i];
						// console.log(errorOccure, agreement);

						// Exit early if error occurred
						if (errorOccure) {
							console.log("Error occurred, exiting loop early");
							break;
						}

						let obj = {
							type: applicantType(i),
							agreementFormId: agreementKYCs[0].agreementFormId,
							applicant: {
								salutation: agreement.salutation,
								firstName: agreement.firstName,
								middleName: agreement.middleName,
								lastName: agreement.lastName,
								leadDob: Date.parse(agreement.leadDob),
								age: agreement.age,
								gender: agreement.gender,
								occupation: agreement.occupation,
								otherOccupation: agreement.otherOccupation,
								contactNumber: agreement.contactNumber,
								email: agreement.email,
								panNumber: agreement.panNumber,
								nameAsperPAN: agreement.nameAsperPAN,
								aadharNumber: agreement.aadharNumber,
								addressLine1: agreement.addressLine1,
								addressLine2: agreement.addressLine2,
								addressLine3: agreement.addressLine3,
								pincode: agreement.pincode,
								country: agreement.country,
								state: agreement.state,
								city: agreement.city,
								aadharFileUrl: agreement.aadharFileUrl,
								panFileUrl: agreement.panFileUrl,
								loanSanctionUrl: agreement.loanSanctionUrl,
								addressAsPrimaryApplicant: agreement.addressAsPrimaryApplicant
							},
							POA: agreement.poa
								? {
									salutation: agreement.poaData.salutation,
									firstName: agreement.poaData.firstName,
									middleName: agreement.poaData.middleName,
									lastName: agreement.poaData.lastName,
									age: agreement.poaData.age,
									gender: agreement.poaData.gender,
									occupation: agreement.poaData.occupation,
									otherOccupation: agreement.poaData.otherOccupation,
									contactNumber: agreement.poaData.contactNumber,
									email: agreement.poaData.email,
									panNumber: agreement.poaData.panNumber,
									nameAsperPAN: agreement.poaData.nameAsperPAN,
									aadharNumber: agreement.poaData.aadharNumber,
									addressLine1: agreement.addressLine1,
									addressLine2: agreement.addressLine2,
									addressLine3: agreement.addressLine3,
									pincode: agreement.poaData.pincode,
									country: agreement.poaData.country,
									state: agreement.poaData.state,
									city: agreement.poaData.city,
									aadharFileUrl: agreement.poaData.aadharFileUrl,
									panFileUrl: agreement.poaData.panFileUrl,
								}
								: null,
						};

						if (agreement.applicantId === "") {
							data.push(obj);
						} else {
							const unitCost = allotment?.CRM[0]?.newUnitCost
								? allotment?.CRM[0]?.newUnitCost
								: allotment?.CRM[0]?.oldUnitCost;
							const payload = { bsp: unitCost?.bsp, gst: unitCost?.gst };

							// Calculation for SDR
							payload.sdr =
								allotment?.isBucketingApplied && allotment?.CRM[0]?.isChangeApplicantRaised !== null
									? (Math.ceil((Math.round((Number(unitCost?.bsp) * (Number(allotment?.CRM[0]?.sdrPercentage) + 1)) / 100)) / 100) * 100) +
										(Number(unitCost?.bsp) > 3000000
										? Math.ceil(Number(allotment?.unitId?.projectId?.registrationCharges / 100) * 100)
										: Math.ceil(Number(unitCost?.bsp / 100) / 100) * 100) +
									allotment?.unitId?.projectId?.legalCharges
									: unitCost?.sdr;

							payload.total = payload.bsp + payload.gst + payload.sdr;

							try {
								const formRes = await updateAgreement(
								ObjData,
								agreementKYCs[0].agreementFormId,
								obj,
								agreement.applicantId,
								changeReqApproved.status === "accepted",
								allotment?.allotmentPaymentId,
								payload,
								allotment?.isBucketingApplied && allotment?.CRM[0]?.isChangeApplicantRaised !== null
									? Number(allotment?.CRM[0]?.sdrPercentage) + 1
									: allotment?.CRM[0]?.sdrPercentage,
								filesToDelete,
								loggedInUser.personId.name
								);
								if (formRes && formRes?.success) {
										setFilesToDelete([]);
										if (i === agreementKYCs.length - 1 && data.length === 0) {
											if (deleteUsers?.length > 0) {
												deleteUsers.forEach((ele, index) => {
													deleteApplicant(ele)
														.then((res) => {
															console.log(res);
														})
														.catch((deleteErr) => {
															console.log(deleteErr);
														});
												});
											}
											if (changeReqApproved.status === "accepted") {
												let obj = {
													allotmentPaymentId: allotment?.allotmentPaymentId,
													crmStatus: "Applicant Changed",
													message: `Applicant changed for allotment unit ${allotment?.unitId?.unitNo} of project ${allotment?.unitId?.projectId?.projectName} by the customer`,
												};
												addCRMLogs(obj)
													.then((leadLog) => {
														console.log(leadLog);
													})
													.catch((err) => {
														console.log("CRMlog", err);
													});
											}
											dismissLoader();
											handleClose();
											successTost("Agreement KYC form submitted successfully!");
										}
									} else {
										dismissLoader();
										handleClose();
										errorTost("Error in submitting agreement KYC form. Try again later!");
									}
							} catch (err) {
								errorOccure = true;
									dismissLoader();
									handleClose();
									if (err?.error?.error === "InvalidKey") {
										errorTost(`Invalid filename { ${err?.error?.message.split("/")[1]} }. Please rename the file which contain only alphabets and numbers, and try uploading again!`);
									} else {
									errorTost("Error in submitting agreement KYC form. Try again later!");
									}
								console.log(errorOccure);
								break; // Break out of the loop on error
						}
						}
					}

					if (data.length > 0) {
						if (errorOccure) {
							return;
						}
						const unitCost = allotment?.CRM[0]?.newUnitCost ? allotment?.CRM[0]?.newUnitCost : allotment?.CRM[0]?.oldUnitCost;
						const payload = { bsp: unitCost?.bsp, gst: unitCost?.gst };
						payload.sdr =
							allotment?.isBucketingApplied && allotment?.CRM[0]?.isChangeApplicantRaised !== null
								? ((Math.ceil((Math.round((Number(unitCost?.bsp) * (Number(allotment?.CRM[0]?.sdrPercentage) + 1)) / 100)) / 100) * 100) +
									(Number(unitCost?.bsp) > 3000000
										? (Math.ceil(Number(allotment?.unitId?.projectId?.registrationCharges / 100) * 100))
										: (Math.ceil(Number(unitCost?.bsp / 100) / 100) * 100)) +
									allotment?.unitId?.projectId?.legalCharges)
								: unitCost?.sdr;
						payload.total = payload.bsp + payload.gst + payload.sdr;
						await updateAgreementInsertApplicantForm(
							ObjData,
							data,
							agreementKYCs[0].agreementFormId,
							changeReqApproved.status === "accepted",
							allotment?.allotmentPaymentId,
							payload,
							allotment?.isBucketingApplied && allotment?.CRM[0]?.isChangeApplicantRaised !== null
								? Number(allotment?.CRM[0]?.sdrPercentage) + 1
								: allotment?.CRM[0]?.sdrPercentage,
							filesToDelete,
							loggedInUser.personId.name
						)
							.then((formRes) => {
								if (formRes && formRes?.success) {
									setFilesToDelete([]);
									if (deleteUsers?.length > 0) {
										deleteUsers.forEach((ele, index) => {
											deleteApplicant(ele)
												.then((res) => {
													console.log(res);
												})
												.catch((deleteErr) => {
													console.log(deleteErr);
												});
										});
									}
									if (changeReqApproved.status === "accepted") {
										let obj = {
											allotmentPaymentId: allotment?.allotmentPaymentId,
											crmStatus: "Applicant Changed",
											message: `Applicant changed for allotment unit ${allotment?.unitId?.unitNo} of project ${allotment?.unitId?.projectId?.projectName} by the customer`,
										};
										addCRMLogs(obj)
											.then((leadLog) => {
												console.log(leadLog);
											})
											.catch((err) => {
												console.log("CRMlog", err);
											});
									}
									dismissLoader();
									handleClose();
									successTost("Agreement KYC form submitted successfully!");
								} else {
									dismissLoader();
									handleClose();
									errorTost("Error in submitting agreement KYC form. Try again later!");
								}
							})
							.catch((err) => {
								dismissLoader();
								handleClose();
								if (err?.error?.error === "InvalidKey") {
									errorTost(`Invalid filename { ${err?.error?.message.split("/")[1]} }. Please rename the file which contain only alphabets and numbers, and try uploading again!`);
								} else {
									errorTost("Error in submitting agEreement KYC form. Try again later!");
								}
							});
					}
				} else {
					let Obj = {
						allotmentPaymentId: allotment.allotmentPaymentId,
						isSelfFunded: value === "no" ? true : false,
						bankType: value === "yes" ? selfFundedValue : null,
						applicants: applicantsData,
						loanDetails: { ...bankerDetails, loanSource: value === "yes" ? loanSource : null }
					};
					if (value === "yes") {
						if (selfFundedValue === "bank") {
							if (loanData !== "Other") {
							Obj.bankId = loanData;
							} else {
								Obj.bankId = null;
								Obj.otherBank = otherBank;
							}
						}

						// else {
						// 	Obj.nbfcId = loanData;
						// }
					}
					submitAgreementForm(Obj, agreementKYCs, loggedInUser.personId.name, allotment.allotmentPaymentId)
						.then((formRes) => {
							if (formRes && formRes?.success) {
								let obj = {
									allotmentPaymentId: allotment?.allotmentPaymentId,
									crmStatus: "Agreement confirmation form filled",
									message: `Agreement confirmation form is filled by the ${loggedInUser.personId.name} for allotment unit ${allotment?.unitId?.unitNo} of project ${allotment?.unitId?.projectId?.projectName}`,
								};
								addCRMLogs(obj)
									.then((leadLog) => {
										console.log(leadLog);
									})
									.catch((err) => {
										console.log("CRMlog", err);
									});
								dismissLoader();
								handleClose();
								successTost("Agreement KYC form submitted successfully!");

							} else {
								dismissLoader();
								handleClose();
								errorTost("Error in submitting agreement KYC form. Try again later!");
							}
						})
						.catch((err) => {
							dismissLoader();
							handleClose();
							if (err?.error?.error === "InvalidKey") {
								errorTost(`Invalid filename { ${err?.error?.message.split("/")[1]} }. Please rename the file which contain only alphabets and numbers, and try uploading again!`);
							} else {
								errorTost("Error in submitting agEreement KYC form. Try again later!");
							}
						});
				}
			}
		}
	}

	function ModalResp(e) {
		if (e === "confirmed") {
			const agreementKYC = [...agreementKYCs];
			const helperArray = [...helperText];
			const names = name.name;
			const index = name.index;
			if (name.name.split(" ").length > 2) {
				if (name.poaData) {
					agreementKYC[index]["poaData"]["firstName"] = names.split(" ")[0];
					agreementKYC[index]["poaData"]["middleName"] = names.split(" ")[1];
					agreementKYC[index]["poaData"]["lastName"] = names.split(" ")[2];
					helperArray[index].poaData.firstName = "";
					helperArray[index].poaData.middleName = "";
					helperArray[index].poaData.lastName = "";
				} else {
					agreementKYC[index]["firstName"] = names.split(" ")[0];
					agreementKYC[index]["middleName"] = names.split(" ")[1];
					agreementKYC[index]["lastName"] = names.split(" ")[2];
					helperArray[index].firstName = "";
					helperArray[index].middleName = "";
					helperArray[index].lastName = "";
				}
			} else if (name.name.split(" ").length > 1){
				if (name.poaData) {
					agreementKYC[index]["poaData"]["firstName"] = names.split(" ")[0];
					agreementKYC[index]["poaData"]["middleName"] = "";
					agreementKYC[index]["poaData"]["lastName"] = names.split(" ")[1];
					helperArray[index].poaData.firstName = "";
					helperArray[index].poaData.middleName = "";
					helperArray[index].poaData.lastName = "";
				} else {
					agreementKYC[index]["firstName"] = names.split(" ")[0];
					agreementKYC[index]["middleName"] = "";
					agreementKYC[index]["lastName"] = names.split(" ")[1];
					helperArray[index].firstName = "";
					helperArray[index].middleName = "";
					helperArray[index].lastName = "";
				}
			} else {
				if (name.poaData) {
					agreementKYC[index]["poaData"]["firstName"] = names.split(" ")[0];
					agreementKYC[index]["poaData"]["middleName"] = "";
					agreementKYC[index]["poaData"]["lastName"] = "";
					helperArray[index].poaData.firstName = "";
					helperArray[index].poaData.middleName = "";
					helperArray[index].poaData.lastName = "";
				} else {
					agreementKYC[index]["firstName"] = names.split(" ")[0];
					agreementKYC[index]["middleName"] = "";
					agreementKYC[index]["lastName"] = "";
					helperArray[index].firstName = "";
					helperArray[index].middleName = "";
					helperArray[index].lastName = "";
				}
			}
			setAgreementKYC(agreementKYC);
			setHelperText(helperArray);
			setOpenConfirmationModal(false);
		}
	}

	function addHelperText() {
		setHelperText([
			...helperText,
			{
				panNumber: "",
				nameAsperPAN: "",
				aadharNumber: "",
				salutation: "",
				firstName: "",
				middleName: "",
				lastName: "",
				leadDob: "",
				age: "",
				gender: "",
				occupation: "",
				otherOccupation: "",
				contactNumber: "",
				email: "",
				addressLine1: "",
				addressLine2: "",
				addressLine3: "",
				pincode: "",
				aadharFileUrl: "",
				panFileUrl: "",
				poa: false,
				poaData: {
					panNumber: "",
					nameAsperPAN: "",
					aadharNumber: "",
					salutation: "",
					firstName: "",
					middleName: "",
					lastName: "",
					age: "",
					gender: "",
					occupation: "",
					otherOccupation: "",
					contactNumber: "",
					email: "",
					addressLine1: "",
					addressLine2: "",
					addressLine3: "",
					pincode: "",
					aadharFileUrl: "",
					panFileUrl: "",
				},
			},
		]);
	}

	const handleAddApplicant = () => {
		if (agreementKYCs.length !== 4) {
			setAgreementKYC([
				...agreementKYCs,
				{
					panNumber: "",
					nameAsperPAN: "",
					salutation: "",
					firstName: "",
					lastName: "",
					leadDob: "",
					middleName: "",
					age: "",
					gender: "",
					occupation: "",
					otherOccupation: "",
					contactNumber: "",
					email: "",
					poa: false,
					aadharNumber: "",
					addressLine1: "",
					addressLine2: "",
					addressLine3: "",
					pincode: "",
					aadharFileUrl: { url1: "", url2: "", type: "pdf" },
					panFileUrl: { url: "", type: "pdf" },
					countryCode: "IN",
					poaData: {
						panNumber: "",
						nameAsperPAN: "",
						salutation: "",
						firstName: "",
						lastName: "",
						middleName: "",
						age: "",
						gender: "",
						occupation: "",
						otherOccupation: "",
						contactNumber: "",
						email: "",
						aadharNumber: "",
						addressLine1: "",
						addressLine2: "",
						addressLine3: "",
						pincode: "",
						aadharFileUrl: { url1: "", url2: "", type: "pdf" },
						panFileUrl: { url: "", type: "pdf" },
					},
					applicantId: "",
					agreementFormId: "",
				},
			]);
			addHelperText();
			agreementKYCs.length === 3 && setAddApplicantDisable(true);
		}
	};

	const handleAgreementChange = (id, data, e, poaChange) => {
		let panNumberIncorrect = false;
		let nameRegex = "^[a-zA-Z]+$";
		let d = [...helperText];
		const newState = agreementKYCs.map((obj, i) => {
			// const name = obj.firstName.toLowerCase() + obj.middleName.toLowerCase() + obj.lastName.toLowerCase().split(" ").join("");
			// const poaName =
			// 	obj.poaData.firstName.toLowerCase() + obj.poaData.middleName.toLowerCase() + obj.poaData.lastName.toLowerCase().split(" ").join("");

			if (i === id) {
				let ObjData = { ...obj };
				let myObj = poaChange ? { ...ObjData["poaData"] } : ObjData;
				switch (data) {
					case "email":
						myObj[data] = e.replaceAll(" ", "");
						break;
					case "panNumber":
						// myObj["firstName"] = "";
						// myObj["middleName"] = "";
						// myObj["lastName"] = "";
						// myObj[data] = e.toUpperCase();
						let updatePANNumber = false;
						if (e !== "") {
							let regex = new RegExp(/^[a-zA-Z0-9_]+$/);
							if (poaChange) {
								d[i]["poaData"]["panNumber"] = "";
							} else {
								d[i].panNumber = "";
							}
							setHelperText(d);
							if (regex.test(e.toUpperCase()) && e.length <= 10) {
								updatePANNumber = true;
								if (e.length === 10) {
									let samePAN = false;
									samePAN = agreementKYCs.some((applicant) => {
										const applicantPAN = applicant.panNumber;
										const applicantPOAPAN = applicant.poaData.panNumber;
										if (!samePAN && applicantPAN.length === 10 && e.toUpperCase() === applicantPAN.toUpperCase()) {
											return true;
										}
										if (!samePAN && applicantPOAPAN.length === 10 && e.toUpperCase() === applicantPOAPAN.toUpperCase()) {
											return true;
										}
									});

									if (!samePAN) {
										presentLoader();
										getPAN_cardDetails(e)
											.then((resp) => {
												// console.log(resp);
												if (resp?.data?.message_code && resp?.data?.message_code === "success") {
													poaChange
														? setPanSuccessPOA({
															...panSuccessPOA,
															[`pan${i}`]: true,
														})
														: setPanSuccess({
															...panSuccess,
															[`pan${i}`]: true,
														});
													const name = resp.data.data.full_name.trim();
													myObj["nameAsperPAN"] = resp.data.data.full_name;
													let nameNotMatch = false;
													const helperArray = [...helperText];
													if (poaChange) {
														helperArray[i].poaData.panNumber = "";
													} else {
														helperArray[i].panNumber = "";
													}
													if (resp.data.data.full_name.split(" ").length > 2) {
														if (
															myObj["firstName"]?.toLowerCase() !== name.split(" ")[0].toLowerCase() &&
															myObj["firstName"]?.trim() !== ""
														) {
															nameNotMatch = true;
														} else if (
															myObj["middleName"]?.toLowerCase() !== name.split(" ")[1]?.toLowerCase() &&
															myObj["middleName"]?.trim() !== ""
														) {
															nameNotMatch = true;
														} else if (
															myObj["lastName"]?.toLowerCase() !== name.split(" ")[2]?.toLowerCase() &&
															myObj["lastName"]?.trim() !== ""
														) {
															nameNotMatch = true;
														} else {
															myObj["firstName"] = name.split(" ")[0];
															myObj["middleName"] = name.split(" ")[1];
															myObj["lastName"] = name.split(" ")[2];
															if (poaChange) {
																helperArray[i].poaData.firstName = "";
																helperArray[i].poaData.middleName = "";
																helperArray[i].poaData.lastName = "";
															} else {
																helperArray[i].firstName = "";
																helperArray[i].middleName = "";
																helperArray[i].lastName = "";
															}
														}
													} else {
														if (
															myObj["firstName"]?.toLowerCase() !== name.split(" ")[0].toLowerCase() &&
															myObj["firstName"]?.trim() !== ""
														) {
															nameNotMatch = true;
														} else if (
															myObj["lastName"]?.toLowerCase() !== name.split(" ")[1]?.toLowerCase() &&
															myObj["lastName"]?.trim() !== ""
														) {
															nameNotMatch = true;
														} else {
															myObj["firstName"] = name.split(" ")[0];
															myObj["lastName"] = name.split(" ")[1];
															if (poaChange) {
																helperArray[i].poaData.firstName = "";
																helperArray[i].poaData.lastName = "";
															} else {
																helperArray[i].firstName = "";
																helperArray[i].lastName = "";
															}
														}
													}
													if (nameNotMatch) {
														setHelperText(helperArray);
														setOpenConfirmationModal(true);
														poaChange
															? setName({ index: i, name: name, poaData: true })
															: setName({
																index: i,
																name: name,
																poaData: false,
															});
													} else {
														setHelperText(helperArray);
													}
													panNumberIncorrect = true;
													dismissLoader();
												} else if (resp?.response?.status === 422) {
													if (poaChange) {
														d[i]["poaData"]["panNumber"] = "Please Enter Valid PAN Number";
													} else {
														d[i].panNumber = "Please Enter Valid PAN Number";
													}
													setHelperText(d);
													dismissLoader();
												} else {
													dismissLoader();
													if (poaChange) {
														d[i]["poaData"]["panNumber"] = "Error while fetching PAN details";
													} else {
														d[i].panNumber = "Error while fetching PAN details";
													}
													setHelperText(d);
												}
											})
											.catch((err) => {
												console.log(err);
												dismissLoader();
												let d = [...helperText];
												if (poaChange) {
													d[i]["poaData"]["panNumber"] = "Error while fetching PAN details";
												} else {
													d[i].panNumber = "Error while fetching PAN details";
												}
												setHelperText(d);
											});
									} else {
										if (poaChange) {
											d[i]["poaData"]["panNumber"] = "This PAN Number Already Exists";
										} else {
											d[i].panNumber = "This PAN Number Already Exists";
										}
										setHelperText(d);
										updatePANNumber = true;
									}
								} else {
									if (poaChange) {
										d[i]["poaData"]["panNumber"] = "Please Enter Valid Pan Card Number";
									} else {
										d[i].panNumber = "Please Enter Valid Pan Card Number";
									}
									setHelperText(d);
									updatePANNumber = true;
								}
							} else if (e.length > 10) {
								if (poaChange) {
									d[i]["poaData"]["panNumber"] = "Pan Number Should Be 10 Digits";
								} else {
									d[i].panNumber = "Pan Number Should Be 10 Digits";
								}
								setHelperText(d);
								updatePANNumber = false;
							} else {
								if (poaChange) {
									d[i]["poaData"]["panNumber"] = "";
								} else {
									d[i].panNumber = "";
								}
								setHelperText(d);
							}
						} else {
							if (poaChange) {
								d[i]["poaData"]["panNumber"] = "Please Enter Pan Card Number";
							} else {
								d[i].panNumber = "Please Enter Pan Card Number";
							}
							setHelperText(d);
							updatePANNumber = true;
						}
						if (updatePANNumber) {
							myObj[data] = e.toUpperCase();
							if (poaChange) {
								setPanSuccessPOA({
									...panSuccessPOA,
									[`pan${i}`]: false,
								});
							} else {
								setPanSuccess({
									...panSuccess,
									[`pan${i}`]: false,
								});
							}
						}
						break;
					case "aadharNumber":
						poaChange
							? setAadharSuccessPOA({
								...aadharSuccessPOA,
								[`aadhar${i}`]: false,
							})
							: setAadharSuccess({
								...aadharSuccess,
								[`aadhar${i}`]: false,
							});

						let regex = new RegExp("^[0-9]+$");
						let valueAadhar = e.replaceAll(" ", "");
						if (e) {
							if (regex.test(valueAadhar) && valueAadhar.length <= 12) {
								myObj[data] = valueAadhar;
							}
						} else {
							myObj[data] = valueAadhar;
						}

						if (e === "") {
							let d = [...helperText];
							if (poaChange) {
								d[i]["poaData"]["aadharNumber"] = "";
							} else {
								d[i].aadharNumber = "";
							}
							setHelperText(d);
						} else {
							let sameAadhar = false;
							sameAadhar = agreementKYCs.some((applicant) => {
								const applicantAadhar = applicant.aadharNumber;
								const applicantPOAAadhar = applicant.poaData.aadharNumber;
								if (!sameAadhar && applicantAadhar.length === 12 && valueAadhar === applicantAadhar) {
									return true;
								}
								if (!sameAadhar && applicantPOAAadhar.length === 12 && valueAadhar === applicantPOAAadhar) {
									return true;
								}
							});

							if (!sameAadhar) {
								if (e.replaceAll(" ", "").length === 12) {
									presentLoader();
									getAadharCardDetails(e.replaceAll(" ", ""))
										.then((resp) => {
											if (resp.data.message_code === "success") {
												let d = [...helperText];
												if (poaChange) {
													d[i]["poaData"]["aadharNumber"] = "";
													d[i]["poaData"]["age"] = "";
													d[i]["poaData"]["gender"] = "";
												} else {
													d[i].aadharNumber = "";
													d[i].age = "";
													d[i].gender = "";
												}
												setHelperText(d);
												myObj["gender"] = resp.data.data.gender === "F" ? "Female" : "Male";
												// myObj["salutation"] = resp.data.data.gender === "F" ? "Mrs" : "Mr";
												if (
													myObj["age"] < parseInt(resp.data.data.age_range.split("-")[0]) ||
													myObj["age"] > parseInt(resp.data.data.age_range.split("-")[1])
												) {
													myObj["age"] = parseInt(resp.data.data.age_range.split("-")[0]);
												}

												poaChange
													? setAadharSuccessPOA({
														...aadharSuccessPOA,
														[`aadhar${i}`]: true,
													})
													: setAadharSuccess({
														...aadharSuccess,
														[`aadhar${i}`]: true,
													});
												dismissLoader();
											} else {
												if (poaChange) {
													d[i]["poaData"]["aadharNumber"] = "Incorrect Aadhar Card Number";
												} else {
													d[i].aadharNumber = "Incorrect Aadhar Card Number";
												}
												setHelperText(d);
											}
										})
										.catch((err) => {
											dismissLoader();
											console.log("err", err);
											if (err?.response?.data?.message === "Verification Failed.") {
												let d = [...helperText];
												if (poaChange) {
													d[i]["poaData"]["aadharNumber"] = "Incorrect Aadhar Card Number";
												} else {
													d[i].aadharNumber = "Incorrect Aadhar Card Number";
												}
												setHelperText(d);
											} else {
												let d = [...helperText];
												if (poaChange) {
													d[i]["poaData"]["aadharNumber"] = "Something went wrong.Please try again later";
												} else {
													d[i].aadharNumber = "Something went wrong.Please try again later";
												}
												setHelperText(d);
											}
										});
								} else {
									let d = [...helperText];
									if (poaChange) {
										d[i]["poaData"]["aadharNumber"] = "Aadhar Card Number should be 12 digits";
									} else {
										d[i].aadharNumber = "Aadhar Card Number should be 12 digits";
									}
									setHelperText(d);
								}
							} else {
								if (poaChange) {
									d[i]["poaData"]["aadharNumber"] = "This Aadhar Number Already Exists";
								} else {
									d[i].aadharNumber = "This Aadhar Number Already Exists";
								}
								setHelperText(d);
							}
						}
						break;
					case "pincode":

						if (myObj["addressAsPrimaryApplicant"] && !poaChange) {
							myObj["addressAsPrimaryApplicant"] = false
						}
						myObj[data] = e;
						if (poaChange) {
							d[i]["poaData"]["pincode"] = "";
						} else {
							d[i].pincode = "";
						}
						setHelperText(d);
						if (!e || e === "") {
							let d = [...helperText];
							if (poaChange) {
								d[i]["poaData"]["pincode"] = "Please Select Pincode";
							} else {
								d[i].pincode = "Please Select Pincode";
							}
							setHelperText(d);
							myObj["country"] = "";
							myObj["state"] = "";
							myObj["city"] = "";
						} else if (e.length === 6) {
							presentLoader();
							getPincodeData(e)
								.then((resp) => {
									if (resp.length > 0) {
										let d = [...helperText];
										d[i].pincode = "";
										setHelperText(d);
										myObj["country"] = resp[0].country.toUpperCase();
										myObj["state"] = resp[0].state.toUpperCase();
										myObj["city"] = resp[0].city.toUpperCase();
										dismissLoader();
									} else {
										dismissLoader();
										let d = [...helperText];
										d[i].pincode = "Could not find pincode in database!";
										setHelperText(d);
									}
								})
								.catch((err) => {
									console.log(err);
									dismissLoader();
									let d = [...helperText];
									d[i].pincode = "Error while fetching details from database!";
									setHelperText(d);
								});
						} else {
							let d = [...helperText];
							d[i].pincode = "Pincode should be 6 digits";
							setHelperText(d);
						}
						break;
					case "age":
						let agerex = new RegExp("^[1-9][0-9]?$|^100$");
						if (e) {
							if (agerex.test(e)) {
								myObj[data] = e;
							}
						} else {
							myObj[data] = e;
						}
						break;
					case "firstName":
						if (e === "") {
							if (poaChange) {
								d[i]["poaData"]["firstName"] = "Please Enter First Name";
							} else {
								d[i].firstName = "Please Enter First Name";
							}
							myObj[data] = e.toUpperCase();
						} else if (e.match(nameRegex)) {
							let firstChangeName = poaChange;
							// 	? e.toLowerCase() + obj.poaData.middleName.toLowerCase() + obj.poaData.lastName.toLowerCase().split(" ").join("")
							// 	: e.toLowerCase() + obj.middleName.toLowerCase() + obj.lastName.toLowerCase().split(" ").join("");
							// console.log(firstChangeName, name, poaName);
							// if (firstChangeName === name || firstChangeName === poaName) {
							// 	if (poaChange) {
							// 		d[i]["poaData"]["firstName"] = "This Name Is Already Exists";
							// 	} else {
							// 		d[i].firstName = "This Name Is Already Exists";
							// 	}
							// } else {
							if (poaChange) {
								d[i]["poaData"]["firstName"] = "";
							} else {
								d[i].firstName = "";
							}
							// }
							myObj[data] = e.toUpperCase();
						} else {
							if (poaChange) {
								d[i]["poaData"]["firstName"] = "";
							} else {
								d[i].firstName = "";
							}
						}
						setHelperText(d);
						break;
					case "middleName":
						if (e === "") {
							if (poaChange) {
								d[i]["poaData"]["middleName"] = "";
							} else {
								d[i].middleName = "";
							}
							myObj[data] = e.toUpperCase();
						} else if (e !== "" && e.match(nameRegex)) {
							// const middleChangeName = poaChange
							// 	? obj.poaData.firstName.toLowerCase() + e.toLowerCase() + obj.poaData.lastName.toLowerCase().split(" ").join("")
							// 	: obj.firstName.toLowerCase() + e.toLowerCase() + obj.lastName.toLowerCase().split(" ").join("");
							// if (middleChangeName === name || middleChangeName === poaName) {
							// 	let d = [...helperText];
							// 	if (poaChange) {
							// 		d[i]["poaData"]["middleName"] = "This Name Is Already Exists";
							// 	} else {
							// 		d[i].middleName = "This Name Is Already Exists";
							// 	}
							// } else {
							let d = [...helperText];
							if (poaChange) {
								d[i]["poaData"]["middleName"] = "";
							} else {
								d[i].middleName = "";
							}
							// }
							myObj[data] = e.toUpperCase();
						} else {
							if (poaChange) {
								d[i]["poaData"]["middleName"] = "";
							} else {
								d[i].middleName = "";
							}
						}
						setHelperText(d);
						break;
					case "lastName":
						if (e === "") {
							if (poaChange) {
								d[i]["poaData"]["lastName"] = "Please Enter Last Name";
							} else {
								d[i].lastName = "Please Enter Last Name";
							}
							myObj[data] = e.toUpperCase();
						} else if (e.match(nameRegex)) {
							// const lastChangeName = poaChange
							// 	? obj.poaData.firstName.toLowerCase() + obj.poaData.middleName.toLowerCase() + e.toLowerCase().split(" ").join("")
							// 	: obj.firstName.toLowerCase() + obj.middleName.toLowerCase() + e.toLowerCase().split(" ").join("");

							// if (lastChangeName === name || lastChangeName === poaName) {
							// 	let d = [...helperText];
							// 	if (poaChange) {
							// 		d[i]["poaData"]["lastName"] = "This Name Is Already Exists";
							// 	} else {
							// 		d[i].lastName = "This Name Is Already Exists";
							// 	}
							// } else {
							let d = [...helperText];
							if (poaChange) {
								d[i]["poaData"]["lastName"] = "";
							} else {
								d[i].lastName = "";
							}
							// }
							myObj[data] = e.toUpperCase();
						} else {
							if (poaChange) {
								d[i]["poaData"]["lastName"] = "";
							} else {
								d[i].lastName = "";
							}
						}
						setHelperText(d);
						break;
					case "leadDob":
						myObj[data] = e;
						break;
					case "salutation":
						myObj[data] = e;
						myObj["gender"] = e === "Mr." ? "Male" : "Female";
						break;
					case "gender":
						myObj[data] = e;
						// myObj["salutation"] = e === "Male" ? "Mr" : "Mrs";
						break;
					case "occupation":
						myObj[data] = e;

						if (e !== "other") {
							myObj["otherOccupation"] = "";
							let d = [...helperText];
							if (poaChange) {
								d[i]["poaData"]["otherOccupation"] = "";
							} else {
								d[i].otherOccupation = "";
							}
							setHelperText(d);
						}
						break;
					case "aadharFileUrl":
						if (!e[0].type.includes("pdf")) {
							if (!myObj[data]["url1"]) {
								myObj[data]["url1"] = e[0];
							} else {
								myObj[data]["url2"] = e[0];
							}
							myObj[data]["type"] = "image";
						} else {
							myObj[data]["url1"] = e[0];
							myObj[data]["url2"] = "";
							myObj[data]["type"] = "pdf";
						}
						break;
					case "panFileUrl":
						myObj[data]["url"] = e[0];
						myObj[data]["type"] = e[0].type.includes("pdf") ? "pdf" : "image";
						break;
					case "deleteAadharFileUrl1":
						setFilesToDelete([...filesToDelete, myObj["aadharFileUrl"]["url1"]]);
						myObj["aadharFileUrl"]["url1"] = "";
						if (!myObj["aadharFileUrl"]["url2"]) {
							myObj["aadharFileUrl"]["type"] = "pdf";
						}

						break;
					case "deleteAadharFileUrl2":
						setFilesToDelete([...filesToDelete, myObj["aadharFileUrl"]["url2"]]);
						myObj["aadharFileUrl"]["url2"] = "";
						if (!myObj["aadharFileUrl"]["url1"]) {
							myObj["aadharFileUrl"]["type"] = "pdf";
						}
						break;
					case "deletePanFileUrl":
						setFilesToDelete([...filesToDelete, myObj["panFileUrl"]["url"]]);
						myObj["panFileUrl"]["url"] = "";
						myObj["panFileUrl"]["type"] = "pdf";
						break;
					case "loanSanctionUrl":
						myObj[data]["url"] = e[0];
						myObj[data]["type"] = e[0].type.includes("pdf") ? "pdf" : "image";
						break;
					case "deleteloanSanctionUrl":
						setFilesToDelete([...filesToDelete, myObj["loanSanctionUrl"]["url"]]);
						myObj["loanSanctionUrl"]["url"] = "";
						myObj["loanSanctionUrl"]["type"] = "pdf";
						break;
					case "addressAsPrimaryApplicant":
						myObj[data] = e
						if (e) {
							myObj["addressLine1"] = agreementKYCs[0]?.addressLine1
							myObj["addressLine2"] = agreementKYCs[0]?.addressLine2
							myObj["addressLine3"] = agreementKYCs[0]?.addressLine3
							myObj["country"] = agreementKYCs[0]?.country
							myObj["state"] = agreementKYCs[0]?.state
							myObj["city"] = agreementKYCs[0]?.city
							myObj["pincode"] = agreementKYCs[0]?.pincode
						} else {
							myObj["addressLine1"] = ""
							myObj["addressLine2"] = ""
							myObj["addressLine3"] = ""
							myObj["country"] = ""
							myObj["state"] = ""
							myObj["city"] = ""
							myObj["pincode"] = ""
						}
						break;
					case "addressLine1":
						if (myObj["addressAsPrimaryApplicant"] && !poaChange) {
							myObj["addressAsPrimaryApplicant"] = false
						}
						myObj[data] = e;
						break;
					case "addressLine2":
						if (myObj["addressAsPrimaryApplicant"] && !poaChange) {
							myObj["addressAsPrimaryApplicant"] = false
						}
						myObj[data] = e;
						break;
					case "addressLine3":
						if (myObj["addressAsPrimaryApplicant"] && !poaChange) {
							myObj["addressAsPrimaryApplicant"] = false
						}
						myObj[data] = e;
						break;
					default:
						myObj[data] = e;
						break;
				}

				if (poaChange) {
					ObjData["poaData"] = myObj;
					return ObjData;
				} else {
					return myObj;
				}
			}

			return obj;
		});
		const helpeNewState = helperText.map((obj, i) => {
			if (i === id) {
				let ObjData = { ...obj };
				let myObj = poaChange ? { ...ObjData["poaData"] } : ObjData;
				switch (data) {
					case "salutation":
						if (e === "") {
							myObj[data] = "Please Eelect Salutation";
						} else {
							myObj[data] = "";
						}
						break;
					case "age":
						if (e === "") {
							myObj[data] = "Please Enter Age";
						} else {
							let regex = "^[0-9]*$";
							if (e.match(regex)) {
								if (e < 18) {
									myObj[data] = "Applicant must be at least 18 years old.";
								} else {
									myObj[data] = "";
								}
							} else {
								myObj[data] = "Please Enter valid Age";
							}
						}
						break;
					case "gender":
						if (e === "") {
							myObj[data] = "Please Select Gender";
						} else {
							myObj[data] = "";
						}
						break;
					case "occupation":
						if (e === "") {
							myObj[data] = "Please Select Occupation";
						} else {
							myObj[data] = "";
						}
						break;
					case "contactNumber":
						if (e === "") {
							myObj[data] = "Please enter contact number";
						} else if (e.length !== 10) {
							myObj[data] = "Contact number should be 10 digits";
						} else {
							myObj[data] = "";
						}
						break;
					case "email":
						var validRegex =
							/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
						if (e === "") {
							myObj[data] = "Please Enter Email Id";
						} else if (!e.replaceAll(" ", "").match(validRegex)) {
							myObj[data] = "Please Enter Valid Email Id";
						} else {
							myObj[data] = "";
						}
						break;
					case "poa":
						myObj[data] = e;
						break;
					case "addressLine1":
						if (e === "") {
							myObj[data] = "Please Enter Address Line1";
						} else {
							myObj[data] = "";
						}
						break;
					case "addressLine2":
						if (e === "") {
							myObj[data] = "Please enter Address Line2";
						} else {
							myObj[data] = "";
						}
						break;
					case "addressLine3":
						if (e === "") {
							myObj[data] = "Please enter Address Line3";
						} else {
							myObj[data] = "";
						}
						break;
					case "pincode":
						if (!e || e === "") {
							myObj[data] = "Please Select Pincode";
						} else {
							myObj[data] = "";
						}
						break;
					case "leadDob":
						if (e === "") {
							myObj[data] = "Please Enter Date of Birth";
						} else {
							const birthdateDate = new Date(e);
							const today = new Date();
							const age = today.getFullYear() - birthdateDate.getFullYear();
							const monthDifference = today.getMonth() - birthdateDate.getMonth();
							const isBirthdayPassed = monthDifference > 0 || (monthDifference === 0 && today.getDate() >= birthdateDate.getDate());

							if (age < 18 || (age === 18 && !isBirthdayPassed)) {
								myObj[data] = "Applicant must be at least 18 years old.";
							} else {
								myObj[data] = "";
							}
						}
						break;
					case "otherOccupation":
						if (e === "") {
							myObj[data] = "Please Enter Other Occupation";
						} else {
							myObj[data] = "";
						}
						break;
					case "nameAsperPAN":
						if (e === "") {
							myObj[data] = "Please Enter Name As Per PAN";
						} else {
							myObj[data] = "";
						}
						break;
					case "aadharFileUrl":
						if (!e || (e.url1 === "" && e.type === "pdf") || (e.url1 === "" && e.type !== "pdf" && e.url2 === "")) {
							myObj[data] = "Please add Aadhar Card document";
						} else {
							myObj[data] = "";
						}
						break;
					case "panFileUrl":
						if (e.url === "") {
							myObj[data] = "Please add Pan Card document";
						} else {
							myObj[data] = "";
						}
						break;
					case "addressAsPrimaryApplicant":
						myObj[data] = e;
						break;
					case "loanSanctionUrl":
						if (e.url === "") {
							myObj[data] = "Please upload Loan Sanction Letter";
						} else {
							myObj[data] = "";
						}
						break;
				}
				if (poaChange) {
					ObjData["poaData"] = myObj;
					return ObjData;
				} else {
					return myObj;
				}
			}

			return obj;
		});
		setHelperText(helpeNewState);
		setAgreementKYC(newState);
	};

	const handleChange = (event) => {
		setValue(event.target.value);
		agreementKYCs[0].loanSanctionUrl = { url: "", type: "pdf" }
	};

	const handleSelfFundedValueChange = (event) => {
		setSelfFundedValue(event.target.value);
		setLoanData("");
		setOtherBank("");
	};

	const handleAccordianChange = (panel) => (event, isExpanded) => {
		setExpanded(isExpanded ? panel : false);
	};

	function optChange(value1, event) {
		event.preventDefault();
		if (event.target.value.length <= 1) {
			setState((pre) => {
				pre[value1] = event.target.value;
				return Object.assign({}, pre);
			});
		}
	}

	const inputfocus = (elmnt) => {
		if (elmnt.key === "Delete" || elmnt.key === "Backspace") {
			// const next = elmnt.target.tabIndex - 2;
			// if (next > -1) {
			// 	// elmnt.target.form.elements[next].focus();
			// 	if (elmnt.target.nextSibling) elmnt.target.nextSibling.focus();
			// }
		} else {
			// const next = elmnt.target.tabIndex + 1;
			const next = parseInt(elmnt.target.id.split("-")[1]) + 1;
			if (next < 5) {
				// elmnt.target.form.elements[next].focus();
				if (elmnt.target.nextSibling) elmnt.target.nextSibling.focus();
			}
		}
	};

	function submitOtp() {
		let finalValue = state.otp1 + state.otp2 + state.otp3 + state.otp4;
		console.log(finalValue, "recievedOtp", recievedOtp);
		if (finalValue == recievedOtp) {
			verifiedPhoneNumber.current = true;
			setShowOtp(false);
			setOtpTimer(false);
			let helperData = [...helperText];
			helperData[0] = {
				...helperData[0],
				contactNumber: "",
			};
			setHelperText(helperData);
			let updatedAgreementKYC = agreementKYCs.map((agreement, i) => {
				if (i === 0) {
					return { ...agreement, contactNumber: updateProfile.contactNumber };
				}
				return agreement;
			});
			setAgreementKYC(updatedAgreementKYC);
		} else {
			setState((pre) => {
				pre.otp1 = "";
				pre.otp2 = "";
				pre.otp3 = "";
				pre.otp4 = "";
				return { ...pre };
			});
			errorTost("OTP Doesnt Match.Please Enter Valid OTP");
		}
	}

	const IsNumberBlackListed = debounce((e, i) => {
		verifyingNumber.current = true;

		let helperData = [...helperText];
		helperData[i] = {
			...helperData[i],
			contactNumber: "",
		};
		setHelperText(helperData);
		verifyingNumber.current = false;
	}, 800);

	// function smsApiCall() {
	// 	setResendButton(false);
	// 	setState((pre) => {
	// 		pre.otp1 = "";
	// 		pre.otp2 = "";
	// 		pre.otp3 = "";
	// 		pre.otp4 = "";
	// 		return { ...pre };
	// 	});
	// 	if (agreementKYCs[0].countryCode == "IN") {
	// 		let body = {
	// 			number: updateProfile.contactNumber,
	// 			isInterNational: isInterNational,
	// 		};
	// 		sendOTPMessagePhone(body)
	// 			.then((resp) => {
	// 				if (resp?.data?.success && resp?.data?.data?.MessageData?.length > 0) {
	// 					var bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
	// 					var originalText = bytes.toString(CryptoJS.enc.Utf8);
	// 					// console.log("Updated OTP", parseInt(originalText));
	// 					setRecievedOtp(parseInt(originalText));
	// 					// 900000 ;15 min
	// 					const myTimeout = setTimeout(smsTimeOut, 900000);
	// 					setShowOtp(true);
	// 				} else {
	// 					if (resp?.data?.error?.ErrorMessage) {
	// 						// errorTost(resp?.data?.error?.ErrorMessage);
	// 						let helperData = [...helperText];
	// 						helperData[0] = {
	// 							...helperData[0],
	// 							contactNumber: resp?.data?.error?.ErrorMessage,
	// 						};
	// 						setHelperText(helperData);
	// 						setShowOtp(false);
	// 					} else {
	// 						let helperData = [...helperText];
	// 						helperData[0] = {
	// 							...helperData[0],
	// 							contactNumber: "Please Enter Valid Contact",
	// 						};
	// 						setHelperText(helperData);
	// 						setShowOtp(false);
	// 					}
	// 				}
	// 			})
	// 			.catch((err) => {
	// 				console.log(err);
	// 				setShowOtp(false);
	// 			});
	// 	} else {
	// 		let body = {
	// 			email: loggedInUser?.personId?.email,
	// 		};
	// 		sendOTPMessageMail(body)
	// 			.then((resp) => {
	// 				if (resp.data.success) {
	// 					var bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
	// 					var originalText = bytes.toString(CryptoJS.enc.Utf8);
	// 					setRecievedOtp(parseInt(originalText));
	// 					console.log("Updated OTP", parseInt(originalText))
	// 					// 900000 ;15 min
	// 					const myTimeout = setTimeout(smsTimeOut, 900000);
	// 					setShowOtp(true);
	// 				} else {
	// 					if (resp?.data?.error?.ErrorMessage) {
	// 						// errorTost(resp?.data?.error?.ErrorMessage);
	// 						let helperData = [...helperText];
	// 						helperData[0] = {
	// 							...helperData[0],
	// 							contactNumber: resp?.data?.error?.ErrorMessage,
	// 						};
	// 						setHelperText(helperData);
	// 						setShowOtp(false);
	// 					} else {
	// 						let helperData = [...helperText];
	// 						helperData[0] = {
	// 							...helperData[0],
	// 							contactNumber: "Please Enter Valid Contact",
	// 						};
	// 						setHelperText(helperData);
	// 						setShowOtp(false);
	// 					}
	// 				}
	// 			})
	// 			.catch((err) => {
	// 				console.log(err);
	// 				setShowOtp(false);
	// 			});
	// 	}
	// }
function smsApiCall() {
	setResendButton(false);

	// Clear OTP input boxes
	setState((pre) => ({
		...pre,
		otp1: "",
		otp2: "",
		otp3: "",
		otp4: "",
	}));

	const isIndian = agreementKYCs[0]?.countryCode === "IN";

	const body = isIndian
		? {
				number: updateProfile.contactNumber,
				isInterNational: isInterNational,
		  }
		: {
				email: loggedInUser?.personId?.email,
		  };

	const sendOtpFunction = isIndian ? sendOTPMessagePhone : sendOTPMessageMail;

	sendOtpFunction(body)
		.then((resp) => {
			// console.log("📦 Full OTP Response:", resp);

			const encryptedOtp = resp?.data?.otp;

			if (!resp?.data?.success || !encryptedOtp) {
				const errorMsg = resp?.data?.error?.ErrorMessage || "Failed to send OTP.";
				console.error("❌ OTP send error:", errorMsg);

				let helperData = [...helperText];
				helperData[0] = {
					...helperData[0],
					contactNumber: errorMsg,
				};
				setHelperText(helperData);
				setShowOtp(false);
				return;
			}

			try {
				let decryptedOtp;

				// ✅ Case 1: Plain OTP
				if (/^\d{4,6}$/.test(encryptedOtp)) {
					// console.log("ℹ️ Plain OTP received:", encryptedOtp);
					decryptedOtp = encryptedOtp.trim();
				}
				// ✅ Case 2: Indian - Base64 encoded AES binary (requires atob)
				else if (isIndian) {
					// console.log("📦 Encrypted OTP for Indian (Base64):", encryptedOtp);
					const base64Decoded = atob(encryptedOtp); // decode base64 string
					// console.log("🔒 Ciphertext (binary):", base64Decoded);

					const bytes = CryptoJS.AES.decrypt(base64Decoded, "hts secret key");
					decryptedOtp = bytes.toString(CryptoJS.enc.Utf8).trim();

					if (!decryptedOtp) throw new Error("Decryption failed for Indian OTP");
					// console.log("🔓 Decrypted Indian OTP:", decryptedOtp);
				}
				// ✅ Case 3: International - direct AES (passphrase-based)
				else {
					// console.log("📦 Encrypted OTP for International:", encryptedOtp);
					const bytes = CryptoJS.AES.decrypt(
						encryptedOtp,
						process.env.REACT_APP_CRYPTO_SECRET_KEY
					);
					decryptedOtp = bytes.toString(CryptoJS.enc.Utf8).trim();

					if (!decryptedOtp) throw new Error("Decryption failed for International OTP");
					// console.log("🔓 Decrypted International OTP:", decryptedOtp);
				}

				setRecievedOtp(decryptedOtp);
				setTimeout(smsTimeOut, 900000); // 15 minutes
				setShowOtp(true);
			} catch (error) {
				console.error("❌ OTP decryption error:", error);
				errorTost("OTP decryption failed. Please try again.");
				setShowOtp(false);
			}
		})
		.catch((err) => {
			console.error("❌ OTP API Error:", err);
			errorTost("Something went wrong while sending OTP.");
			setShowOtp(false);
		});
}

	function smsTimeOut() {
		if (verifiedPhoneNumber.current === false) {
			let helperData = [...helperText];
			helperData[0] = {
				...helperData[0],
				contactNumber: "Otp has expired.Please resend otp",
			};
			setHelperText(helperData);
			verifiedPhoneNumber.current = false;
			setShowOtp(true);
			setResendButton(true);
			setOtpTimer(true);
			// setShowEmailOtp(false);
			setState((pre) => {
				pre.otp1 = "";
				pre.otp2 = "";
				pre.otp3 = "";
				pre.otp4 = "";
				return { ...pre };
			});
			setRecievedOtp(null);
		}
	}
	
	function optEmailChange(value1, event) {
		event.preventDefault();
		if (event.target.value.length <= 1) {
			setEmailState((pre) => {
				pre[value1] = event.target.value;
				return Object.assign({}, pre);
			});
		}
	}
	const checkEmailExists = debounce(async (e) => {
		let helperData = [...helperText];
		helperData[0] = {
			...helperData[0],
			email: "",
		};
		setHelperText(helperData);
		setEmailLabelText("Send Otp");
	}, 900);

	function sendOtpToVerifyEmail() {
		let helperData = [...helperText];
		helperData[0] = {
			...helperData[0],
			email: "",
		};
		setHelperText(helperData);
		setEmailLabelText("");
		let body = {
			email: updateProfile.email,
		};
		sendOTPMessageMail(body)
			.then((resp) => {
				if (resp.data.success) {
					var bytes = CryptoJS.AES.decrypt(resp.data.otp, "hts secret key");
					var originalText = bytes.toString(CryptoJS.enc.Utf8);
					// local testing only (npm start): never in a production build
					if (process.env.NODE_ENV === "development") console.log("[dev] Agreement KYC email OTP", parseInt(originalText));
					setRecievedEmailOtp(parseInt(originalText));
					// 900000 ;15 min
					const myTimeout = setTimeout(smsTimeOutForEmailVerify, 900000);
					setShowEmailOtp(true);
					setOtpTimerEmail(true);
				} else {
					console.log(resp);
					if (resp?.data?.error?.ErrorMessage) {
						errorTost(resp?.data?.error?.ErrorMessage);
					} else if (resp?.data?.err?.response?.text) {
						const errText = JSON.parse(resp?.data?.err?.response?.text);
						if (errText.message && errText.message.includes("email is not valid")) {
							let helperData = [...helperText];
							helperData[0] = {
								...helperData[0],
								email: "Please Enter Valid Email",
							};
							setHelperText(helperData);
							setEmailLabelText("");
						} else {
							let helperData = [...helperText];
							helperData[0] = {
								...helperData[0],
								email: errText.message,
							};
							setHelperText(helperData);
							setEmailLabelText("");
						}
					} else {
						let helperData = [...helperText];
						helperData[0] = {
							...helperData[0],
							email: "Something went wrong",
						};
						setHelperText(helperData);
						setEmailLabelText("");
					}
				}
			})
			.catch((err) => {
				console.log(err);
				setEmailLabelText("");
			});
	}

	function smsTimeOutForEmailVerify() {
		if (verifiedEmail === false) {
			let helperData = [...helperText];
			helperData[0] = {
				...helperData[0],
				email: "Otp has expired.Please resend otp",
			};
			setHelperText(helperData);
			setEmailLabelText("Resend Otp");
			setOtpTimerEmail(false);
			// setVerifiedEmail(false);
			verifiedEmail.current = false;
		} else {
			setShowEmailOtp(true);
			setOtpTimerEmail(true);
			setEmailState((pre) => {
				pre.otp1 = "";
				pre.otp2 = "";
				pre.otp3 = "";
				pre.otp4 = "";
				return { ...pre };
			});
			setRecievedEmailOtp(null);
		}
	}

	function submitEmailOtp() {
		let finalValue = emailState.otp1 + emailState.otp2 + emailState.otp3 + emailState.otp4;
		console.log(finalValue, "recievedEmailOtp", recievedEmailOtp);
		if (finalValue == recievedEmailOtp) {
			let updatedAgreementKYC = agreementKYCs.map((agreement, i) => {
				if (i === 0) {
					return { ...agreement, email: updateProfile.email };
				}
				return agreement;
			});
			setAgreementKYC(updatedAgreementKYC);
			verifiedEmail.current = true;
			setShowEmailOtp(false);
			setOtpTimerEmail(false);
			setEmailLabelText("");
			setEmailState((pre) => {
				pre.otp1 = "";
				pre.otp2 = "";
				pre.otp3 = "";
				pre.otp4 = "";
				return { ...pre };
			});
		} else {
			setEmailState((pre) => {
				pre.otp1 = "";
				pre.otp2 = "";
				pre.otp3 = "";
				pre.otp4 = "";
				return { ...pre };
			});
			errorTost("OTP doesnt match.Please enter valid otp");
		}
	}

	function ChangeModalResp(e) {
		if (e === "confirmed") {
			setOpenChangeReqConfirmationModal(false);
			if (!allotment?.CRM[0]?.sentForAgreement) {
				presentLoader();
				changeApplicantReq(
					allotment?.CRM[0]?.crmUserId,
					allotment.allotmentPaymentId,
					agreementKYCs[0].agreementFormId,
					allotment?.CRM[0]?.crmStatusId
				)
					.then((resp) => {
						if (resp.success) {
							let obj = {
								allotmentPaymentId: allotment?.allotmentPaymentId,
								crmStatus: "Change applicant requested",
								message: `Change applicant requested for allotment unit ${allotment?.unitId?.unitNo} of project ${allotment?.unitId?.projectId?.projectName} by customer`,
							};
							addCRMLogs(obj)
								.then((leadLog) => {
									console.log(leadLog);
								})
								.catch((err) => {
									console.log(err);
								});
							successTost("Change Applicant Request Raised Successfully");
							handleClose();
						} else {
							errorTost("Could not Send Change Request");
							handleClose();
						}
						dismissLoader();
					})
					.catch((err) => {
						console.log(err);
						dismissLoader();
						errorTost("Could not Send Change Request");
					});
			}
		}
	}

	const handleDeleteApplicant = (i) => {
		setAgreementKYC((agreement) => agreement.filter((s, index) => index !== i));
		setHelperText((helperText) => helperText.filter((s, index) => index !== i));
	};

	return (
		<>
			<Modal
				open={open}
				onClose={(_, reason) => {
					if (reason !== "backdropClick") {
						closeModal();
					}
				}}
				aria-labelledby="modal-modal-title"
				aria-describedby="modal-modal-description"
				sx={[
					{
						".MuiBackdrop-root": {
							background: "rgba(52, 64, 84, 0.7)",
						},
					},
				]}
				disableAutoFocus={true}
			>
				<Box>
					<Box className={cssClasses.modalWrapper}>
						<div className={cssClasses.wrapperContent}>
							<div className={cssClasses.wrapperHeader}>
								<span className={classes.closeIcon} onClick={closeModal} tabIndex={0}>
									<Close width={"1.2rem"} height={"1.2rem"} />
								</span>
								<div className={cssClasses.allotmentCardHeader}>
									<div className={cssClasses.allotmentTokenNumWrap}>
										<div className={cssClasses.allotmentImg}>
											<img src={AllotmentBuildingIcon} alt="allotment" />
										</div>
										<div className={cssClasses.allotmentProjectDetail}>
											<div className={cssClasses.allotmentProjectDetailFirst}>
												<span>
													{allotment?.unitId && (
														<span>
															{allotment?.unitId.wingId.displayName
																? allotment?.unitId.wingId.displayName
																: allotment?.unitId.wingId.wingName}{" "}
															- {allotment?.unitId.unitNo}
														</span>
													)}
													{allotment?.inventoryMergedId &&
														((allotment?.inventoryMergedId.unit1Id.wingId.wingId ===
															allotment?.inventoryMergedId.unit2Id.wingId.wingId && (
																<span>
																	{allotment?.inventoryMergedId.unit1Id.wingId.displayName
																		? allotment?.inventoryMergedId.unit1Id.wingId.displayName
																		: allotment?.inventoryMergedId.unit1Id.wingId.wingName}{" "}
																	- {allotment?.inventoryMergedId.unit1Id.unitNo} &{" "}
																	{allotment?.inventoryMergedId.unit2Id.unitNo}{" "}
																</span>
															)) ||
															(allotment?.inventoryMergedId.unit1Id.wingId.wingId !==
																allotment?.inventoryMergedId.unit2Id.wingId.wingId && (
																	<span>
																		{allotment?.inventoryMergedId.unit1Id.wingId.displayName
																			? allotment?.inventoryMergedId.unit1Id.wingId.displayName
																			: allotment?.inventoryMergedId.unit1Id.wingId.wingName}{" "}
																		- {allotment?.inventoryMergedId.unit1Id.unitNo} &{" "}
																		{allotment?.inventoryMergedId.unit2Id.wingId.displayName
																			? allotment?.inventoryMergedId.unit2Id.wingId.displayName
																			: allotment?.inventoryMergedId.unit2Id.wingId.wingName}{" "}
																		- {allotment?.inventoryMergedId.unit2Id.unitNo}{" "}
																	</span>
																)))}
												</span>
												<div className={cssClasses.tokenStatus}>
													{allotment?.unitCost?.sdr - allotment?.paidAmt?.sdr > 0 ? (
														<LeadStatusChip
															label={"SDR Pending"}
															icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
															style={{
																color: "#B54708",
																backgroundColor: "#FFFAEB",
															}}
														/>
													) : (
														<LeadStatusChip
															label={"SDR Complete"}
															icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
															style={{
																color: "#027A48",
																backgroundColor: "#ECFDF3",
															}}
														/>
													)}
													{changeReqApproved.status === "pending" && (
														<LeadStatusChip
															label={"Change Applicant Request Pending"}
															icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
															style={{
																color: "#B54708",
																backgroundColor: "#FFFAEB",
															}}
														/>
													)}
													{changeReqApproved.status === "accepted" && !allotment?.CRM[0].isChangeApplicantRaised && (
														<LeadStatusChip
															label={"change applicant request Approved"}
															icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
															style={{
																color: "#027A48",
																backgroundColor: "#ECFDF3",
															}}
														/>
													)}
													{changeReqApproved.status === "rejected" && (
														<LeadStatusChip
															label={"Change Applicant Request Rejected"}
															icon={<Dot width={"0.5rem"} height={"0.5rem"} />}
															style={{
																color: "#B54708",
																backgroundColor: "#FFFAEB",
															}}
														/>
													)}
												</div>
											</div>
											<div className={cssClasses.allotmentProjectName}>
												{allotment?.unitId && <span>{allotment?.unitId.projectId.projectName}</span>}
												{allotment?.inventoryMergedId && <span>{allotment?.inventoryMergedId.projectId.projectName}</span>}
											</div>
										</div>
									</div>
								</div>
							</div>

							{/* CRM 2.0 (M3-F5, DC-76): rules / correction note at the top of the form */}
							{crm2?.topNote}
							<div className={cssClasses.cardBody}>
								<div className={cssClasses.cardContentData}>
									{agreementKYCs.map(
										(agreementKYC, i) =>
											i === 0 && (
												<div key={i} className={cssClasses.inputFieldsMainContent}>
													<div className={cssClasses.cardBodyHeader}>
														<div>Primary Applicant</div>
														<div className={cssClasses.addApplicantContent}>
															{!allotment?.isCrm2 && (
<div>
																<Button
																	disable={
																		!edit ||
																		(edit &&
																			(allotment?.CRM.length === 0 ||
																				allotment?.CRM[0]?.crmStatusId < 2 ||
																				(changeReqApproved.status === "accepted" &&
																					!allotment?.CRM[0].isChangeApplicantRaised) ||
																				(allotment?.CRM[0]?.crmStatusId === 3 &&
																					!allotment?.CRM[0].isChangeApplicantRaised)))
																	}
																	btnName={"Change Applicant Request"}
																	clicked={() => {
																		setOpenChangeReqConfirmationModal(true);
																	}}
																	style={{
																		color: "#fff",
																		backgroundColor:
																			!edit ||
																				(edit &&
																					(allotment?.CRM.length === 0 ||
																						allotment?.CRM[0]?.crmStatusId < 2 ||
																						(changeReqApproved.status === "accepted" &&
																							!allotment?.CRM[0].isChangeApplicantRaised) ||
																						(allotment?.CRM[0]?.crmStatusId === 3 &&
																							!allotment?.CRM[0].isChangeApplicantRaised)))
																				? "#98A2B3"
																				: "rgb(21, 112, 239)",
																		fontSize: "1.6rem",
																		lineHeight: "2.4rem",
																		fontFamily: "Inter-Regular !important",
																	}}
																/>
															</div>
)}
															<div>
																<Button
																	disable={addApplicantDisable}
																	btnIcon={
																		<img
																			style={{
																				width: "2.4rem",
																				height: "2.4rem",
																			}}
																			src={AddApplicantIcon}
																			alt="add"
																		/>
																	}
																	iconPosition={"left"}
																	btnName={"Add New Applicant"}
																	clicked={() => {
																		handleAddApplicant();
																	}}
																	style={{
																		color: "#fff",
																		backgroundColor: addApplicantDisable ? "#98A2B3" : "rgb(21, 112, 239)",
																		fontSize: "1.6rem",
																		lineHeight: "2.4rem",
																		fontFamily: "Inter-Regular !important",
																	}}
																/>
																<div className={cssClasses.limitApplicantText}>*Limit: 4 Applicants</div>
															</div>
														</div>
													</div>

													<div className={cssClasses.inputFieldsContent}>
														<div className={cssClasses.inputWrapper}>
															<DropDown
																disable={addBtnDisable}
																list={salutationList}
																label={"Salutation"}
																placeHolder={"salutation"}
																mandatory={true}
																selectedValue={agreementKYC.salutation}
																helperText={helperText[i].salutation}
																onChangeSelect={(e) => {
																	handleAgreementChange(i, "salutation", e, false);
																}}
																style={{
																	background: "#FCFCFD",
																	borderRadius: "0.8rem",
																	border: "1px solid  #D0D5DD",
																	boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																}}
															/>
														</div>
														<div className={cssClasses.inputWrapper}>
															<CustomInput
																disabled={addBtnDisable}
																placeholder={"First Name"}
																label={"First Name"}
																inputType={"text"}
																mandatory={true}
																value={agreementKYC.firstName}
																helperText={helperText[i].firstName}
																style={{
																	background: "#FCFCFD",
																	borderRadius: "0.8rem",
																	border: "1px solid  #D0D5DD",
																	boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																	textTransform: "uppercase"
																}}
																handleChange={(e) => {
																	handleAgreementChange(i, "firstName", e, false);
																}}
															/>
														</div>
														<div className={cssClasses.inputWrapper}>
															<CustomInput
																disabled={addBtnDisable}
																placeholder={"Middle Name"}
																label={"Middle Name"}
																inputType={"text"}
																mandatory={false}
																value={agreementKYC.middleName}
																helperText={helperText[i].middleName}
																style={{
																	background: "#FCFCFD",
																	borderRadius: "0.8rem",
																	border: "1px solid  #D0D5DD",
																	boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																	textTransform: "uppercase"
																}}
																handleChange={(e) => {
																	handleAgreementChange(i, "middleName", e, false);
																}}
															/>
														</div>
														<div className={cssClasses.inputWrapper}>
															<CustomInput
																disabled={addBtnDisable}
																placeholder={"Last Name"}
																label={"Last Name"}
																inputType={"text"}
																mandatory={true}
																value={agreementKYC.lastName}
																helperText={helperText[i].lastName}
																style={{
																	background: "#FCFCFD",
																	borderRadius: "0.8rem",
																	border: "1px solid  #D0D5DD",
																	boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																	textTransform: "uppercase"
																}}
																handleChange={(e) => {
																	handleAgreementChange(i, "lastName", e, false);
																}}
															/>
														</div>
													</div>
													<div className={cssClasses.inputFieldsContent}>
														<div style={{ position: "relative", width: "30%" }} className={cssClasses.inputWrapper}>
															<div className={cssClasses.blockLabel}>
																Date of Birth <span style={{ color: "red" }}> *</span>
															</div>
															<input
																className={cssClasses.dateInput}
																type="date"
																value={agreementKYC.leadDob}
																onChange={(e) => handleAgreementChange(i, "leadDob", e.target.value, false)}
																name="DOB"
																disabled={addBtnDisable}
																onKeyDown={(event) => {
																	event.preventDefault();
																}}
																max={get18YearsAgoDate()}
															/>
															<p
																style={{
																	color: "#d32f2f",
																	fontSize: "1.4rem",
																	lineHeight: "1.66",
																}}
															>
																{helperText[i].leadDob}
															</p>
														</div>
														<div className={cssClasses.inputWrapper} style={{ width: "20%" }}>
															<CustomInput
																disabled={addBtnDisable}
																placeholder={"Age"}
																label={"Age"}
																inputType={"number"}
																mandatory={true}
																value={agreementKYC.age}
																helperText={helperText[i].age}
																style={{
																	background: "#FCFCFD",
																	borderRadius: "0.8rem",
																	border: "1px solid  #D0D5DD",
																	boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																}}
																handleChange={(e) => {
																	handleAgreementChange(i, "age", e, false);
																}}
															/>
														</div>
														<div className={cssClasses.inputWrapper} style={{ width: "auto" }}>
															<DropDown
																disable={addBtnDisable}
																list={["Male", "Female"]}
																label={"Gender"}
																placeHolder={"Gender"}
																mandatory={true}
																selectedValue={agreementKYC.gender}
																helperText={helperText[i].gender}
																onChangeSelect={(e) => {
																	handleAgreementChange(i, "gender", e, false);
																}}
																style={{
																	background: "#FCFCFD",
																	borderRadius: "0.8rem",
																	border: "1px solid  #D0D5DD",
																	boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																}}
															/>
														</div>
														<div className={cssClasses.inputWrapper} style={{ width: "30%" }}>
															<DropDown
																list={OccupationList}
																label={"Occupation"}
																placeHolder={"Occupation"}
																mandatory={true}
																selectedValue={agreementKYC.occupation}
																helperText={helperText[i].occupation}
																onChangeSelect={(e) => {
																	handleAgreementChange(i, "occupation", e, false);
																}}
																style={{
																	background: "#FCFCFD",
																	borderRadius: "0.8rem",
																	border: "1px solid  #D0D5DD",
																	boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																}}
															/>
															{agreementKYC.occupation === "Other" && (
																<CustomInput
																	label="Other Occupation"
																	mandatory
																	helperText={helperText[i].otherOccupation}
																	placeholder={"Occupation"}
																	inputType={"text"}
																	value={agreementKYC.otherOccupation}
																	style={{
																		background: "#FCFCFD",
																		borderRadius: "0.8rem",
																		border: "1px solid  #D0D5DD",
																		boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																	}}
																	handleChange={(e) => {
																		const hasNumbers = /\d/.test(e);
																		if (!hasNumbers) {
																			handleAgreementChange(i, "otherOccupation", e, false);
																		}
																	}}
																/>
															)}
														</div>
													</div>
													<div className={cssClasses.inputFieldsContent}>
														<div className={cssClasses.inputWrapper}></div>
													</div>
													<div className={cssClasses.inputFieldsContent}>
														<div
															className={cssClasses.inputWrapper}
															style={{
																width: window.innerWidth > 1366 ? "50%" : "100%",
															}}
														>
															<CustomInput
																disabled={addBtnDisable}
																handleChange={(e) => {
																	handleAgreementChange(i, "aadharNumber", e, false);
																}}
																greenTick={aadharSuccess[`aadhar${i}`]}
																placeholder={"Aadhar Card Number"}
																label={"Aadhar Card Number"}
																inputType={"text"}
																mandatory={true}
																helperText={helperText[i].aadharNumber}
																value={agreementKYC.aadharNumber}
																style={{
																	background: "#FCFCFD",
																	borderRadius: "0.8rem",
																	border: "1px solid  #D0D5DD",
																	boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																}}
															/>
														</div>
														<div
															className={cssClasses.inputWrapper}
															style={{
																width: window.innerWidth > 1366 ? "50%" : "100%",
															}}
														>
															<CustomInput
																disabled={addBtnDisable}
																style={{
																	textTransform: "capitalize",
																	background: "#FCFCFD",
																	borderRadius: "0.8rem",
																	border: "1px solid  #D0D5DD",
																	boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																}}
																handleChange={(e) => {
																	handleAgreementChange(i, "panNumber", e, false);
																}}
																greenTick={panSuccess[`pan${i}`]}
																placeholder={"Pan Card Number"}
																label={"Pan Card Number"}
																inputType={"text"}
																mandatory={true}
																helperText={helperText[i].panNumber}
																value={agreementKYC.panNumber}
															/>
														</div>
														{panSuccess[`pan${i}`] && (
															<div
																className={cssClasses.inputWrapper}
																style={{
																	width: window.innerWidth > 1366 ? "50%" : "100%",
																}}
															>
																<CustomInput
																	disabled={true}
																	style={{
																		textTransform: "capitalize",
																		background: "#FCFCFD",
																		borderRadius: "0.8rem",
																		border: "1px solid  #D0D5DD",
																		boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																	}}
																	handleChange={(e) => {
																		handleAgreementChange(i, "nameAsperPAN", e, false);
																	}}
																	placeholder={"Name as per PAN"}
																	label={"Name as per PAN"}
																	inputType={"text"}
																	mandatory={true}
																	helperText={helperText[i].nameAsperPAN}
																	value={agreementKYC.nameAsperPAN}
																/>
															</div>
														)}
													</div>
													<div className={cssClasses.inputFieldsContent}>
														<div className={cssClasses.inputWrapper} style={{ width: "100%" }}>
															<CustomInput
																handleChange={(e) => {
																	handleAgreementChange(i, "addressLine1", e.toUpperCase(), false);
																}}
																placeholder={"Flat/House No. Appartment"}
																label={"Address Line 1"}
																inputType={"text"}
																mandatory={true}
																helperText={helperText[i].addressLine1}
																value={agreementKYC.addressLine1}
																style={{
																	background: "#FCFCFD",
																	borderRadius: "0.8rem",
																	border: "1px solid  #D0D5DD",
																	boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																	textTransform: "uppercase",
																}}
															/>
														</div>
													</div>
													<div className={cssClasses.inputFieldsContent}>
														<div className={cssClasses.inputWrapper} style={{ width: "100%" }}>
															<CustomInput
																handleChange={(e) => {
																	handleAgreementChange(i, "addressLine2", e.toUpperCase(), false);
																}}
																placeholder={"Area ,Street ,Sector, Village"}
																label={"Address Line 2"}
																inputType={"text"}
																mandatory={true}
																helperText={helperText[i].addressLine2}
																value={agreementKYC.addressLine2}
																style={{
																	background: "#FCFCFD",
																	borderRadius: "0.8rem",
																	border: "1px solid  #D0D5DD",
																	boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																	textTransform: "uppercase",
																}}
															/>
														</div>
													</div>
													<div className={cssClasses.inputFieldsContent}>
														<div className={cssClasses.inputWrapper} style={{ width: "100%" }}>
															<CustomInput
																handleChange={(e) => {
																	handleAgreementChange(i, "addressLine3", e.toUpperCase(), false);
																}}
																placeholder={"Landmark"}
																label={"Address Line 3"}
																inputType={"text"}
																mandatory={true}
																helperText={helperText[i].addressLine3}
																value={agreementKYC.addressLine3}
																style={{
																	background: "#FCFCFD",
																	borderRadius: "0.8rem",
																	border: "1px solid  #D0D5DD",
																	boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																	textTransform: "uppercase",
																}}
															/>
														</div>
													</div>
													<div className={cssClasses.inputFieldsContent}>
														<div
															className={cssClasses.inputWrapper}
															style={{
																width: window.innerWidth > 1366 ? "50%" : "100%",
															}}
														>
															<div className={cssClasses.blockLabel}>
																Pincode <span style={{ color: "red" }}> *</span>
															</div>
															<CustomAutoComplete
																style={{
																	background: "#FCFCFD",
																	borderRadius: "0.8rem",
																	border: "1px solid  #D0D5DD",
																	boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																}}
																placeholder={"Pincode"}
																NoOptionsText={"Pincode Not Found"}
																list={pincodes}
																disable={false}
																helperText={helperText[i].pincode}
																value={agreementKYC?.pincode}
																InitialValue={(e) => {
																	handleAgreementChange(i, "pincode", e, false);
																}}
																SecondInputValue={pincodeInput[`pin${i}`]}
																OnInputChange={(e, value) => {
																	var numbers = new RegExp("^[0-9]{1,6}$");
																	if (value) {
																		if (numbers.test(value)) {
																			setPincodeInput({
																				...pincodeInput,
																				[`pin${i}`]: value,
																			});
																		}
																	} else {
																		setPincodeInput({
																			...pincodeInput,
																			[`pin${i}`]: "",
																		});
																		handleAgreementChange(i, "pincode", e, false);
																	}
																}}
																filterOptions={createFilterOptions({
																	matchFrom: "start",
																	limit: 10,
																})}
																renderOption={(props, option) => {
																	return (
																		<span {...props} style={{ backgroundColor: "#FCFCFD" }}>
																			{option}
																		</span>
																	);
																}}
															/>
														</div>
														<div
															className={cssClasses.inputWrapper}
															style={{
																width: window.innerWidth > 1366 ? "50%" : "100%",
															}}
														>
															<CustomInput
																placeholder={"Country"}
																label={"Country"}
																inputType={"text"}
																mandatory={true}
																disabled={true}
																value={agreementKYC.country}
																style={{
																	background: "#FCFCFD",
																	borderRadius: "0.8rem",
																	border: "1px solid  #D0D5DD",
																	boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																	textTransform: "uppercase",
																}}
															/>
														</div>
													</div>
													<div className={cssClasses.inputFieldsContent}>
														<div
															className={cssClasses.inputWrapper}
															style={{
																width: window.innerWidth > 1366 ? "50%" : "100%",
															}}
														>
															<CustomInput
																placeholder={"State"}
																label={"State"}
																inputType={"text"}
																mandatory={true}
																disabled={true}
																value={agreementKYC.state}
																style={{
																	background: "#FCFCFD",
																	borderRadius: "0.8rem",
																	border: "1px solid  #D0D5DD",
																	boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																	textTransform: "uppercase",
																}}
															/>
														</div>
														<div
															className={cssClasses.inputWrapper}
															style={{
																width: window.innerWidth > 1366 ? "50%" : "100%",
															}}
														>
															<CustomInput
																placeholder={"City"}
																label={"City"}
																inputType={"text"}
																mandatory={true}
																disabled={true}
																value={agreementKYC.city}
																style={{
																	background: "#FCFCFD",
																	borderRadius: "0.8rem",
																	border: "1px solid  #D0D5DD",
																	boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																	textTransform: "uppercase",
																}}
															/>
														</div>
													</div>
													<div className={cssClasses.inputFieldsContent}>
														<div
															className={cssClasses.inputWrapper}
															style={{
																width: window.innerWidth > 1366 ? "50%" : "100%",
															}}
														>
															<div style={{ position: "relative" }}>
																<div className={cssClasses.blockLabel}>
																	Contact Number <span style={{ color: "red" }}> *</span>
																</div>
																<PhoneInput
																	disabled={verifyingNumber.current}
																	className={cssClasses.PhoneInput}
																	style={{
																		background: "#FCFCFD !important",
																		borderRadius: "0.8rem",
																		border: "1px solid  #D0D5DD",
																		boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		input: {
																			background: "#FCFCFD !important",
																		},
																	}}
																	defaultCountry={agreementKYC.countryCode ? "IN" : agreementKYC.countryCode}
																	placeholder="Contact Number"
																	value={
																		agreementKYC?.contactNumber?.toString().length <= 10
																			? "+91" + agreementKYC?.contactNumber
																			: agreementKYC?.contactNumber
																	}
																	onCountryChange={(country) => {
																		if (!country) {
																			handleAgreementChange(i, "countryCode", "IN", false)
																		}
																		else {
																			handleAgreementChange(i, "countryCode", country, false)

																		}

																	}}
																	onChange={(phone) => {
																		setUpdateProfile((pre) => {
																			pre.contactNumber = phone;
																			return { ...pre };
																		});
																		if (phone !== undefined) {
																			verifiedPhoneNumber.current = false;
																			if (phone.length >= 1) {
																				if (isValidPhoneNumber(phone) === false) {
																					verifiedPhoneNumber.current = false;
																					let helperData = [...helperText];
																					helperData[i] = {
																						...helperData[i],
																						contactNumber: "Please Enter valid Phone Number",
																					};
																					setHelperText(helperData);
																					setShowOtp(false);
																				} else {
																					let helperData = [...helperText];
																					helperData[i] = {
																						...helperData[i],
																						contactNumber: "Verifying...",
																					};
																					setHelperText(helperData);
																					if (phone?.substring(0, 3) === "+91") {
																						setIsInterNational(false);
																					} else {
																						setIsInterNational(true);
																					}
																					verifyingNumber.current = true;
																					IsNumberBlackListed(phone, i);
																				}
																			}
																		} else {
																			verifiedPhoneNumber.current = false;
																			let helperData = [...helperText];
																			helperData[i] = {
																				...helperData[i],
																				contactNumber: "Please Enter Contact Number",
																			};
																			setHelperText(helperData);
																			setShowOtp(false);
																		}
																	}}
																/>
																<p
																	style={{
																		color: "#d32f2f",
																		fontSize: "1.4rem",
																		lineHeight: "1.66",
																	}}
																>
																	{helperText[i].contactNumber}
																</p>
																{helperText[i].contactNumber === "" &&
																	// agreementKYC.contactNumber !== "" &&
																	verifiedPhoneNumber.current === false &&
																	otptimer === false &&
																	showOtp === false &&
																	updateProfile.contactNumber !== "" && (
																		<div
																			className={cssClasses.verifyOtp}
																			onClick={() => {
																				smsApiCall(i);
																			}}
																		>
																			Verify Otp
																		</div>
																	)}
																{verifiedPhoneNumber.current === false &&
																	showOtp === true &&
																	resendButton === true && (
																		<div
																			className={cssClasses.verifyOtp}
																			onClick={() => {
																				let d = [...helperText];
																				d[i].contactNumber = "";
																				setHelperText(d);

																				if (resendButton) {
																					smsApiCall();
																					// successTost("Otp has been sent");
																				} else {
																					console.log("Please wait for 3 min");
																				}
																			}}
																		>
																			Resend Otp
																		</div>
																	)}
																{verifiedPhoneNumber.current === false &&
																	showOtp === true &&
																	resendButton === false && (
																		<div className={cssClasses.resendOtp}>
																			Resend Otp in{" "}
																			{/* <Countdown date={startDate.current + 180000} renderer={renderer} /> */}
																			<CountdownTimer
																				startFrom={180}
																				onComplete={() => {
																					setResendButton(true);
																					setRecievedOtp(null);
																				}}
																				timeFormatter={(time) => {
																					return (
																						<span>
																							{`0${Math.floor(time / 60)}`.slice(-2)}:
																							{`0${time % 60}`.slice(-2)}
																						</span>
																					);
																				}}
																			/>
																		</div>
																	)}
																{helperText[i].contactNumber === "" &&
																	verifiedPhoneNumber.current &&
																	otptimer === false && (
																		<div className={cssClasses.verifyOtp}>
																			<CheckCircleSharp
																				style={{
																					fontSize: "2.5rem",
																					marginRight: "1rem",
																				}}
																				color={"success"}
																			/>
																		</div>
																	)}
																{showOtp && (
																	<div className={cssClasses.otpContainer}>
																		<input
																			className={cssClasses.otpInput}
																			name="otp1"
																			type="number"
																			autoComplete="off"
																			value={state.otp1}
																			// onKeyPress={keyPressed}
																			onChange={(e) => optChange("otp1", e)}
																			tabIndex="1"
																			maxLength="1"
																			onKeyUp={(e) => inputfocus(e)}
																			id="opt-0"
																			inputMode="numeric"
																			pattern="[0-9]*"
																		/>
																		<input
																			name="otp2"
																			type="number"
																			autoComplete="off"
																			className={cssClasses.otpInput}
																			value={state.otp2}
																			onChange={(e) => optChange("otp2", e)}
																			tabIndex="2"
																			maxLength="1"
																			onKeyUp={(e) => inputfocus(e)}
																			id="opt-1"
																			inputMode="numeric"
																			pattern="[0-9]*"
																		/>
																		<input
																			name="otp3"
																			type="number"
																			autoComplete="off"
																			className={cssClasses.otpInput}
																			value={state.otp3}
																			onChange={(e) => optChange("otp3", e)}
																			tabIndex="3"
																			maxLength="1"
																			onKeyUp={(e) => inputfocus(e)}
																			id="opt-2"
																			inputMode="numeric"
																			pattern="[0-9]*"
																		/>
																		<input
																			name="otp4"
																			type="number"
																			autoComplete="off"
																			className={cssClasses.otpInput}
																			value={state.otp4}
																			onChange={(e) => optChange("otp4", e)}
																			tabIndex="4"
																			maxLength="1"
																			onKeyUp={(e) => inputfocus(e)}
																			id="opt-3"
																			inputMode="numeric"
																			pattern="[0-9]*"
																		/>

																		<div>
																			<Button
																				tabIndex={5}
																				style={{
																					color: "#ffffff",
																					backgroundColor: "#155EEF",
																					fontSize: "1.4rem",
																					lineHeight: "2rem",
																				}}
																				btnName={"Submit OTP"}
																				clicked={submitOtp}
																			/>
																		</div>
																	</div>
																)}
															</div>
														</div>
														<div
															className={cssClasses.inputWrapper}
															style={{
																width: window.innerWidth > 1366 ? "50%" : "100%",
															}}
														>
															<CustomInput
																clicked={(e) => {
																	if (e === "Send Otp") {
																		sendOtpToVerifyEmail(e);
																	} else if (e === "Resend Otp") {
																		sendOtpToVerifyEmail(e);
																	}
																}}
																handleChange={(newValue) => {
																	setEmailLabelText("");
																	newValue = newValue.trimStart();
																	const emailIDCond = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
																	let helperData = [...helperText];
																	verifiedEmail.current = false;
																	if (!newValue.trim()) {
																		setEmailLabelText("");
																		helperData[i] = {
																			...helperData[i],
																			email: "Please Enter Email Id",
																		};
																		setHelperText(helperData);
																	} else if (!newValue.match(emailIDCond)) {
																		setEmailLabelText("");
																		helperData[i] = {
																			...helperData[i],
																			email: "Please Enter Email in Proper Format",
																		};
																		setHelperText(helperData);
																	} else {
																		setEmailLabelText("");
																		helperData[i] = {
																			...helperData[i],
																			email: "Verifying...",
																		};
																		setHelperText(helperData);
																		if (newValue !== "") {
																			checkEmailExists(newValue);
																		} else if (newValue === "") {
																			setEmailLabelText("");
																		}
																	}
																	if (newValue.length <= 100) {
																		setUpdateProfile((pre) => {
																			pre.email = newValue;
																			return { ...pre };
																		});
																	}
																}}
																placeholder={"Email"}
																label={"Email"}
																inputType={"label"}
																position={"end"}
																greenTick={verifiedEmail.current === true}
																labelText={emailLabelText}
																mandatory={true}
																helperText={helperText[i].email}
																// value={agreementKYC.email}
																value={updateProfile?.email}
																// style={{
																// 	color: "#667085",
																// 	background: "#FCFCFD",
																// }}
																style={{
																	background: "#FCFCFD",
																	borderRadius: "0.8rem",
																	border: "1px solid  #D0D5DD",
																	boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																}}
															/>
															{otptimerEmail && (
																<div className={cssClasses.resendOtp}>
																	{" "}
																	Resend Otp in{" "}
																	<CountdownTimer
																		startFrom={180}
																		onComplete={() => {
																			setEmailLabelText("Resend Otp");
																			setOtpTimerEmail(false);
																			setRecievedEmailOtp(null);
																		}}
																		timeFormatter={(time) => {
																			return (
																				<span>
																					{`0${Math.floor(time / 60)}`.slice(-2)}:
																					{`0${time % 60}`.slice(-2)}
																				</span>
																			);
																		}}
																	/>
																</div>
															)}
															{showEmailOtp && (
																<div className={cssClasses.otpContainer}>
																	<input
																		className={cssClasses.otpInput}
																		name="otp1"
																		type="number"
																		autoComplete="off"
																		value={emailState.otp1}
																		onChange={(e) => optEmailChange("otp1", e)}
																		tabIndex="1"
																		maxLength="1"
																		onKeyUp={(e) => inputfocus(e)}
																		id="opt-0"
																		inputMode="numeric"
																		pattern="[0-9]*"
																	/>
																	<input
																		name="otp2"
																		type="number"
																		autoComplete="off"
																		className={cssClasses.otpInput}
																		value={emailState.otp2}
																		onChange={(e) => optEmailChange("otp2", e)}
																		tabIndex="2"
																		maxLength="1"
																		onKeyUp={(e) => inputfocus(e)}
																		id="opt-1"
																		inputMode="numeric"
																		pattern="[0-9]*"
																	/>
																	<input
																		name="otp3"
																		type="number"
																		autoComplete="off"
																		className={cssClasses.otpInput}
																		value={emailState.otp3}
																		onChange={(e) => optEmailChange("otp3", e)}
																		tabIndex="3"
																		maxLength="1"
																		onKeyUp={(e) => inputfocus(e)}
																		id="opt-2"
																		inputMode="numeric"
																		pattern="[0-9]*"
																	/>
																	<input
																		name="otp4"
																		type="number"
																		autoComplete="off"
																		className={cssClasses.otpInput}
																		value={emailState.otp4}
																		onChange={(e) => optEmailChange("otp4", e)}
																		tabIndex="4"
																		maxLength="1"
																		onKeyUp={(e) => inputfocus(e)}
																		id="opt-3"
																		inputMode="numeric"
																		pattern="[0-9]*"
																	/>
																	<div>
																		<Button
																			tabIndex={5}
																			style={{
																				color: "#ffffff",
																				backgroundColor: "#155EEF",
																				fontSize: "1.4rem",
																				lineHeight: "2rem",
																			}}
																			btnName={"Submit OTP"}
																			clicked={submitEmailOtp}
																		/>
																	</div>
																</div>
															)}
														</div>
													</div>
													<div
														style={{
															width: "100%",
															display: "flex",
															gap: "1.6rem",
														}}
													>
														<div className={cssClasses.inputWrapper} style={{ width: "50%" }}>
															<Typography sx={{ ...labelStyle }}>
																Add Aadhar Card <span style={{ color: "red" }}>*</span>{" "}
															</Typography>{" "}
															<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
																{agreementKYC.aadharFileUrl.url1 && (
																	<Box className={cssClasses.uploadDocumentCard}>
																		<img
																			src={
																				agreementKYC.aadharFileUrl.type === "pdf" ? DocumentPDFIcon : ImgIcon
																			}
																			alt="Pdf"
																			width={"40rem"}
																			height={"40rem"}
																		/>
																		<div className={cssClasses.uploadLabel} style={{ color: "#000000" }}>
																			<p>
																				{typeof agreementKYC.aadharFileUrl.url1 === "string"
																					? agreementKYC.aadharFileUrl.url1?.split("/").pop()
																					: agreementKYC.aadharFileUrl.url1.name}
																			</p>
																		</div>

																		<div
																			style={{
																				display: "flex",
																				flexDirection: "row",
																				gap: "2rem",
																				marginTop: "1rem",
																			}}
																		>
																			<div
																				onClick={() =>
																					handleOpenPreviewModal({
																						value: agreementKYC.aadharFileUrl.url1,
																						type: agreementKYC.aadharFileUrl.type,
																					})
																				}
																				id="PDF"
																				className={cssClasses.uploadLabel}
																				style={{
																					cursor: "pointer",
																					textDecorationLine: "underline",
																				}}
																			>
																				<p>Preview</p>
																			</div>
																			<div
																				onClick={(e) => DeleteDoc(i, "deleteAadharFileUrl1", e, false)}
																				className={cssClasses.uploadLabel}
																				style={{
																					cursor: addBtnDisable ? "default" : "pointer",
																					textDecorationLine: "underline",
																					opacity: addBtnDisable ? "0.5" : "1",
																				}}
																			>
																				<p>Delete</p>
																			</div>
																		</div>
																	</Box>
																)}
																{agreementKYC.aadharFileUrl.url2 && agreementKYC.aadharFileUrl.type !== "pdf" && (
																	<Box className={cssClasses.uploadDocumentCard}>
																		<img
																			src={
																				agreementKYC.aadharFileUrl.type === "pdf" ? DocumentPDFIcon : ImgIcon
																			}
																			alt="Pdf"
																			width={"40rem"}
																			height={"40rem"}
																		/>
																		<div className={cssClasses.uploadLabel} style={{ color: "#000000" }}>
																			<p>
																				{typeof agreementKYC.aadharFileUrl.url2 === "string"
																					? agreementKYC.aadharFileUrl?.url2?.split("/").pop()
																					: agreementKYC.aadharFileUrl.url2.name}
																			</p>
																		</div>

																		<div
																			style={{
																				display: "flex",
																				flexDirection: "row",
																				gap: "2rem",
																				marginTop: "1rem",
																			}}
																		>
																			<div
																				onClick={() =>
																					handleOpenPreviewModal({
																						value: agreementKYC.aadharFileUrl.url2,
																						type: agreementKYC.aadharFileUrl.type,
																					})
																				}
																				id="PDF"
																				className={cssClasses.uploadLabel}
																				style={{
																					cursor: "pointer",
																					textDecorationLine: "underline",
																				}}
																			>
																				<p>Preview</p>
																			</div>
																			<div
																				onClick={(e) => DeleteDoc(i, "deleteAadharFileUrl2", e, false)}
																				className={cssClasses.uploadLabel}
																				style={{
																					cursor: addBtnDisable ? "default" : "pointer",
																					textDecorationLine: "underline",
																					opacity: addBtnDisable ? "0.5" : "1",
																				}}
																			>
																				<p>Delete</p>
																			</div>
																		</div>
																	</Box>
																)}
															</div>
															{!agreementKYC.aadharFileUrl.url1 && (
																<Box
																	className={cssClasses.uploadDocumentCard}
																	sx={{ opacity: addBtnDisable ? "0.5" : "1" }}
																>
																	<div
																		className={cssClasses.uploadLabel}
																		style={{
																			cursor: addBtnDisable ? "default" : "pointer",
																			textDecorationLine: "underline",
																		}}
																	>
																		<p
																			onClick={(e) =>
																				selectFiles(
																					i,
																					"aadharFileUrl",
																					e,
																					false,
																					agreementKYC.aadharFileUrl.type
																				)
																			}
																		>
																			<AddIcon
																				style={{
																					width: "45px",
																					height: "35px",
																				}}
																			/>
																		</p>
																	</div>
																</Box>
															)}
															{!agreementKYC.aadharFileUrl.url2 && agreementKYC.aadharFileUrl.type !== "pdf" && (
																<Box
																	className={cssClasses.uploadDocumentCard}
																	sx={{ opacity: addBtnDisable ? "0.5" : "1", marginTop: "1rem" }}
																>
																	<div
																		className={cssClasses.uploadLabel}
																		style={{
																			cursor: addBtnDisable ? "default" : "pointer",
																			textDecorationLine: "underline",
																		}}
																	>
																		<p
																			onClick={(e) =>
																				selectFiles(
																					i,
																					"aadharFileUrl",
																					e,
																					false,
																					agreementKYC.aadharFileUrl.type
																				)
																			}
																		>
																			<AddIcon
																				style={{
																					width: "45px",
																					height: "35px",
																				}}
																			/>
																		</p>
																	</div>
																</Box>
															)}
															<p
																style={{
																	color: "#d32f2f",
																	fontSize: "1.4rem",
																	lineHeight: "1.66",
																}}
															>
																{helperText[i].aadharFileUrl}
															</p>
														</div>
														<div className={cssClasses.inputWrapper} style={{ width: "50%" }}>
															<Typography sx={{ ...labelStyle }}>
																Add PAN Card <span style={{ color: "red" }}>*</span>{" "}
															</Typography>{" "}
															{agreementKYC.panFileUrl?.url && (
																<Box className={cssClasses.uploadDocumentCard}>
																	<img
																		src={agreementKYC.panFileUrl.type === "pdf" ? DocumentPDFIcon : ImgIcon}
																		alt="Pdf"
																		width={"40rem"}
																		height={"40rem"}
																	/>
																	<div className={cssClasses.uploadLabel} style={{ color: "#000000" }}>
																		<p>
																			{typeof agreementKYC.panFileUrl.url === "string"
																				? agreementKYC.panFileUrl.url?.split("/").pop()
																				: agreementKYC.panFileUrl.url?.name}
																		</p>
																	</div>

																	<div
																		style={{
																			display: "flex",
																			flexDirection: "row",
																			gap: "2rem",
																			marginTop: "1rem",
																		}}
																	>
																		<div
																			onClick={() =>
																				handleOpenPreviewModal({
																					value: agreementKYC.panFileUrl.url,
																					type: agreementKYC.panFileUrl.type,
																				})
																			}
																			id="PDF"
																			className={cssClasses.uploadLabel}
																			style={{
																				cursor: "pointer",
																				textDecorationLine: "underline",
																			}}
																		>
																			<p>Preview</p>
																		</div>
																		<div
																			onClick={(e) => DeleteDoc(i, "deletePanFileUrl", e, false)}
																			className={cssClasses.uploadLabel}
																			style={{
																				cursor: addBtnDisable ? "default" : "pointer",
																				textDecorationLine: "underline",
																				opacity: addBtnDisable ? "0.5" : "1",
																			}}
																		>
																			<p>Delete</p>
																		</div>
																	</div>
																</Box>
															)}
															{!agreementKYC.panFileUrl.url && (
																<Box
																	className={cssClasses.uploadDocumentCard}
																	sx={{ opacity: addBtnDisable ? "0.5" : "1" }}
																>
																	<div
																		className={cssClasses.uploadLabel}
																		style={{
																			cursor: addBtnDisable ? "default" : "pointer",
																			textDecorationLine: "underline",
																		}}
																	>
																		<p
																			onClick={(e) =>
																				selectFiles(i, "panFileUrl", e, false, agreementKYC.panFileUrl.type)
																			}
																		>
																			<AddIcon
																				style={{
																					width: "45px",
																					height: "35px",
																				}}
																			/>
																		</p>
																	</div>
																</Box>
															)}
															<p
																style={{
																	color: "#d32f2f",
																	fontSize: "1.4rem",
																	lineHeight: "1.66",
																}}
															>
																{helperText[i].panFileUrl}
															</p>
														</div>
													</div>
													<div className={cssClasses.poaCheckBox}>
														<Checkbox
															color="default"
															checked={agreementKYC.poa}
															onChange={(e) => {
																handleAgreementChange(i, "poa", e.target.checked);
															}}
															sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
															inputProps={{ "aria-label": "controlled" }}
														/>
														<span>POA</span>
													</div>
													{agreementKYC.poa && (
														<div className={cssClasses.poaContent}>
															<Divider />
															<div className={cssClasses.cardBodyHeader}>
																<div>POA</div>
															</div>
															<div className={cssClasses.inputFieldsContent}>
																<div className={cssClasses.inputWrapper}>
																	<DropDown
																		list={salutationList}
																		label={"Salutation"}
																		placeHolder={"salutation"}
																		mandatory={true}
																		selectedValue={agreementKYC.poaData.salutation}
																		helperText={helperText[i].poaData.salutation}
																		onChangeSelect={(e) => {
																			handleAgreementChange(i, "salutation", e, true);
																		}}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		}}
																	/>
																</div>
																<div className={cssClasses.inputWrapper}>
																	<CustomInput
																		placeholder={"First Name"}
																		label={"First Name"}
																		inputType={"text"}
																		mandatory={true}
																		value={agreementKYC.poaData.firstName}
																		helperText={helperText[i].poaData.firstName}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			textTransform: "uppercase"
																		}}
																		handleChange={(e) => {
																			handleAgreementChange(i, "firstName", e, true);
																		}}
																	/>
																</div>
																<div className={cssClasses.inputWrapper}>
																	<CustomInput
																		placeholder={"Middle Name"}
																		label={"Middle Name"}
																		inputType={"text"}
																		mandatory={false}
																		value={agreementKYC.poaData.middleName}
																		helperText={helperText[i].poaData.middleName}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			textTransform: "uppercase"
																		}}
																		handleChange={(e) => {
																			handleAgreementChange(i, "middleName", e, true);
																		}}
																	/>
																</div>
																<div className={cssClasses.inputWrapper}>
																	<CustomInput
																		placeholder={"Last Name"}
																		label={"Last Name"}
																		inputType={"text"}
																		mandatory={true}
																		value={agreementKYC.poaData.lastName}
																		helperText={helperText[i].poaData.lastName}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			textTransform: "uppercase"
																		}}
																		handleChange={(e) => {
																			handleAgreementChange(i, "lastName", e, true);
																		}}
																	/>
																</div>
															</div>
															<div className={cssClasses.inputFieldsContent}>
																<div className={cssClasses.inputWrapper} style={{ width: "20%" }}>
																	<CustomInput
																		placeholder={"Age"}
																		label={"Age"}
																		inputType={"number"}
																		mandatory={true}
																		value={agreementKYC.poaData.age}
																		helperText={helperText[i].poaData.age}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		}}
																		handleChange={(e) => {
																			handleAgreementChange(i, "age", e, true);
																		}}
																	/>
																</div>
																<div className={cssClasses.inputWrapper} style={{ width: "30%" }}>
																	<DropDown
																		list={["Male", "Female"]}
																		label={"Gender"}
																		placeHolder={"Gender"}
																		mandatory={true}
																		selectedValue={agreementKYC.poaData.gender}
																		helperText={helperText[i].poaData.gender}
																		onChangeSelect={(e) => {
																			handleAgreementChange(i, "gender", e, true);
																		}}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		}}
																	/>
																</div>
																<div className={cssClasses.inputWrapper} style={{ width: "50%" }}>
																	<DropDown
																		list={OccupationList}
																		label={"Occupation"}
																		placeHolder={"Occupation"}
																		selectedValue={agreementKYC.poaData.occupation}
																		helperText={helperText[i].poaData.occupation}
																		onChangeSelect={(e) => {
																			handleAgreementChange(i, "occupation", e, true);
																		}}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		}}
																	/>
																	{agreementKYC.poaData.occupation === "Other" && (
																		<CustomInput
																			label="Other Occupation"
																			helperText={helperText[i].poaData.otherOccupation}
																			placeholder={"Occupation"}
																			inputType={"text"}
																			mandatory={true}
																			value={agreementKYC.poaData.otherOccupation}
																			style={{
																				background: "#FCFCFD",
																				borderRadius: "0.8rem",
																				border: "1px solid  #D0D5DD",
																				boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			}}
																			handleChange={(e) => {
																				const hasNumbers = /\d/.test(e);
																				if (!hasNumbers) {
																					handleAgreementChange(i, "otherOccupation", e, true);
																				}
																			}}
																		/>
																	)}
																</div>
															</div>
															<div className={cssClasses.inputFieldsContent}>
																<div
																	className={cssClasses.inputWrapper}
																	style={{
																		width: window.innerWidth > 1366 ? "50%" : "100%",
																	}}
																>
																	<CustomInput
																		handleChange={(e) => {
																			handleAgreementChange(i, "aadharNumber", e, true);
																		}}
																		greenTick={aadharSuccessPOA[`aadhar${i}`]}
																		placeholder={"Aadhar Card Number"}
																		label={"Aadhar Card Number"}
																		inputType={"text"}
																		mandatory={true}
																		helperText={helperText[i].poaData.aadharNumber}
																		value={agreementKYC.poaData.aadharNumber}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		}}
																	/>
																</div>
																<div
																	className={cssClasses.inputWrapper}
																	style={{
																		width: window.innerWidth > 1366 ? "50%" : "100%",
																	}}
																>
																	<CustomInput
																		style={{
																			textTransform: "capitalize",
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		}}
																		handleChange={(e) => {
																			handleAgreementChange(i, "panNumber", e, true);
																		}}
																		greenTick={panSuccessPOA[`pan${i}`]}
																		placeholder={"Pan Card Number"}
																		label={"Pan Card Number"}
																		inputType={"text"}
																		mandatory={true}
																		helperText={helperText[i].poaData.panNumber}
																		value={agreementKYC.poaData.panNumber}
																	/>
																</div>
																{panSuccessPOA[`pan${i}`] && (
																	<div
																		className={cssClasses.inputWrapper}
																		style={{
																			width: window.innerWidth > 1366 ? "50%" : "100%",
																		}}
																	>
																		<CustomInput
																			disabled={true}
																			style={{
																				textTransform: "capitalize",
																				background: "#FCFCFD",
																				borderRadius: "0.8rem",
																				border: "1px solid  #D0D5DD",
																				boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			}}
																			handleChange={(e) => {
																				handleAgreementChange(i, "nameAsperPAN", e, true);
																			}}
																			placeholder={"Name as per PAN"}
																			label={"Name as per PAN"}
																			inputType={"text"}
																			mandatory={true}
																			helperText={helperText[i].poaData.nameAsperPAN}
																			value={agreementKYC.poaData.nameAsperPAN}
																		/>
																	</div>
																)}
															</div>
															<div className={cssClasses.inputFieldsContent}>
																<div className={cssClasses.inputWrapper} style={{ width: "100%" }}>
																	<CustomInput
																		handleChange={(e) => {
																			handleAgreementChange(i, "addressLine1", e.toUpperCase(), true);
																		}}
																		placeholder={"Flat/House No. Appartment"}
																		label={"Address Line 1"}
																		inputType={"text"}
																		mandatory={true}
																		helperText={helperText[i].poaData.addressLine1}
																		value={agreementKYC.poaData.addressLine1}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			textTransform: "uppercase",
																		}}
																	/>
																</div>
															</div>
															<div className={cssClasses.inputFieldsContent}>
																<div className={cssClasses.inputWrapper} style={{ width: "100%" }}>
																	<CustomInput
																		handleChange={(e) => {
																			handleAgreementChange(i, "addressLine2", e.toUpperCase(), true);
																		}}
																		placeholder={"Area ,Street ,Sector, Village"}
																		label={"Address Line 2"}
																		inputType={"text"}
																		mandatory={true}
																		helperText={helperText[i].poaData.addressLine2}
																		value={agreementKYC.poaData.addressLine2}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			textTransform: "uppercase",
																		}}
																	/>
																</div>
															</div>
															<div className={cssClasses.inputFieldsContent}>
																<div className={cssClasses.inputWrapper} style={{ width: "100%" }}>
																	<CustomInput
																		handleChange={(e) => {
																			handleAgreementChange(i, "addressLine3", e.toUpperCase(), true);
																		}}
																		placeholder={"Landmark"}
																		label={"Address Line 3"}
																		inputType={"text"}
																		mandatory={true}
																		helperText={helperText[i].poaData.addressLine3}
																		value={agreementKYC.poaData.addressLine3}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			textTransform: "uppercase",
																		}}
																	/>
																</div>
															</div>
															<div className={cssClasses.inputFieldsContent}>
																<div
																	className={cssClasses.inputWrapper}
																	style={{
																		width: window.innerWidth > 1366 ? "50%" : "100%",
																	}}
																>
																	<div className={cssClasses.blockLabel}>
																		Pincode <span style={{ color: "red" }}> *</span>
																	</div>
																	<CustomAutoComplete
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		}}
																		placeholder={"Pincode"}
																		NoOptionsText={"Pincode Not Found"}
																		list={pincodes}
																		disable={false}
																		helperText={helperText[i].poaData.pincode}
																		value={agreementKYC?.poaData?.pincode}
																		InitialValue={(e) => {
																			handleAgreementChange(i, "pincode", e, true);
																		}}
																		// SecondInputValue={pincodeInput1}
																		SecondInputValue={poaPincodeInput[`pin${i}`]}
																		OnInputChange={(e, value) => {
																			var numbers = new RegExp("^[0-9]{1,6}$");
																			if (value) {
																				if (numbers.test(value)) {
																					// setPincodeInput1(value);
																					setPoaPincodeInput({
																						...poaPincodeInput,
																						[`pin${i}`]: value,
																					});
																				}
																			} else {
																				// setPincodeInput1("");
																				setPoaPincodeInput({
																					...poaPincodeInput,
																					[`pin${i}`]: "",
																				});
																				handleAgreementChange(i, "pincode", e, true);
																			}
																		}}
																		filterOptions={createFilterOptions({
																			matchFrom: "start",
																			limit: 10,
																		})}
																		renderOption={(props, option) => {
																			return (
																				<span {...props} style={{ backgroundColor: "#FCFCFD" }}>
																					{option}
																				</span>
																			);
																		}}
																	/>
																</div>
																<div
																	className={cssClasses.inputWrapper}
																	style={{
																		width: window.innerWidth > 1366 ? "50%" : "100%",
																	}}
																>
																	<CustomInput
																		placeholder={"Country"}
																		label={"Country"}
																		inputType={"text"}
																		mandatory={true}
																		disabled={true}
																		value={agreementKYC.poaData.country}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			textTransform: "uppercase",
																		}}
																	/>
																</div>
															</div>
															<div className={cssClasses.inputFieldsContent}>
																<div
																	className={cssClasses.inputWrapper}
																	style={{
																		width: window.innerWidth > 1366 ? "50%" : "100%",
																	}}
																>
																	<CustomInput
																		placeholder={"State"}
																		label={"State"}
																		inputType={"text"}
																		mandatory={true}
																		disabled={true}
																		value={agreementKYC.poaData.state}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			textTransform: "uppercase",
																		}}
																	/>
																</div>
																<div
																	className={cssClasses.inputWrapper}
																	style={{
																		width: window.innerWidth > 1366 ? "50%" : "100%",
																	}}
																>
																	<CustomInput
																		placeholder={"City"}
																		label={"City"}
																		inputType={"text"}
																		mandatory={true}
																		disabled={true}
																		value={agreementKYC.poaData.city}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			textTransform: "uppercase",
																		}}
																	/>
																</div>
															</div>
															<div className={cssClasses.inputFieldsContent}>
																<div
																	className={cssClasses.inputWrapper}
																	style={{
																		width: window.innerWidth > 1366 ? "50%" : "100%",
																	}}
																>
																	<CustomInput
																		handleChange={(e) => {
																			handleAgreementChange(i, "contactNumber", e, true);
																		}}
																		placeholder={"Contact Number"}
																		label={"Contact Number"}
																		inputType={"mobile"}
																		mandatory={true}
																		helperText={helperText[i].poaData.contactNumber}
																		value={agreementKYC.poaData.contactNumber}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		}}
																	/>
																</div>
																<div
																	className={cssClasses.inputWrapper}
																	style={{
																		width: window.innerWidth > 1366 ? "50%" : "100%",
																	}}
																>
																	<CustomInput
																		handleChange={(e) => {
																			handleAgreementChange(i, "email", e, true);
																		}}
																		placeholder={"Email"}
																		label={"Email"}
																		inputType={"text"}
																		mandatory={true}
																		helperText={helperText[i].poaData.email}
																		value={agreementKYC.poaData.email}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		}}
																	/>
																</div>
															</div>
															<div
																style={{
																	width: "100%",
																	display: "flex",
																	gap: "1.6rem",
																}}
															>
																<div className={cssClasses.inputWrapper} style={{ width: "50%" }}>
																	<Typography sx={{ ...labelStyle }}>
																		Add Aadhar Card <span style={{ color: "red" }}>*</span>{" "}
																	</Typography>{" "}
																	<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
																		{agreementKYC.poaData.aadharFileUrl.url1 && (
																			<Box className={cssClasses.uploadDocumentCard}>
																				<img
																					src={
																						agreementKYC.poaData.aadharFileUrl.type === "pdf"
																							? DocumentPDFIcon
																							: ImgIcon
																					}
																					alt="Pdf"
																					width={"40rem"}
																					height={"40rem"}
																				/>
																				<div className={cssClasses.uploadLabel} style={{ color: "#000000" }}>
																					<p>
																						{typeof agreementKYC.poaData.aadharFileUrl.url1 === "string"
																							? agreementKYC.poaData.aadharFileUrl.url1
																								?.split("/")
																								.pop()
																							: agreementKYC.poaData.aadharFileUrl.url1.name}
																					</p>
																				</div>

																				<div
																					style={{
																						display: "flex",
																						flexDirection: "row",
																						gap: "2rem",
																						marginTop: "1rem",
																					}}
																				>
																					<div
																						onClick={() =>
																							handleOpenPreviewModal({
																								value: agreementKYC.poaData.aadharFileUrl.url1,
																								type: agreementKYC.poaData.aadharFileUrl.type,
																							})
																						}
																						id="PDF"
																						className={cssClasses.uploadLabel}
																						style={{
																							cursor: "pointer",
																							textDecorationLine: "underline",
																						}}
																					>
																						<p>Preview</p>
																					</div>
																					<div
																						onClick={(e) => DeleteDoc(i, "deleteAadharFileUrl1", e, true)}
																						className={cssClasses.uploadLabel}
																						style={{
																							cursor: "pointer",
																							textDecorationLine: "underline",
																						}}
																					>
																						<p>Delete</p>
																					</div>
																				</div>
																			</Box>
																		)}
																		{agreementKYC.poaData.aadharFileUrl.url2 &&
																			agreementKYC.poaData.aadharFileUrl.type !== "pdf" && (
																				<Box className={cssClasses.uploadDocumentCard}>
																					<img
																						src={
																							agreementKYC.poaData.aadharFileUrl.type === "pdf"
																								? DocumentPDFIcon
																								: ImgIcon
																						}
																						alt="Pdf"
																						width={"40rem"}
																						height={"40rem"}
																					/>
																					<div
																						className={cssClasses.uploadLabel}
																						style={{ color: "#000000" }}
																					>
																						<p>
																							{typeof agreementKYC.poaData.aadharFileUrl.url2 ===
																								"string"
																								? agreementKYC.poaData.aadharFileUrl.url2
																									?.split("/")
																									.pop()
																								: agreementKYC.poaData.aadharFileUrl.url2.name}
																						</p>
																					</div>

																					<div
																						style={{
																							display: "flex",
																							flexDirection: "row",
																							gap: "2rem",
																							marginTop: "1rem",
																						}}
																					>
																						<div
																							onClick={() =>
																								handleOpenPreviewModal({
																									value: agreementKYC.poaData.aadharFileUrl.url2,
																									type: agreementKYC.poaData.aadharFileUrl.type,
																								})
																							}
																							id="PDF"
																							className={cssClasses.uploadLabel}
																							style={{
																								cursor: "pointer",
																								textDecorationLine: "underline",
																							}}
																						>
																							<p>Preview</p>
																						</div>
																						<div
																							onClick={(e) =>
																								DeleteDoc(i, "deleteAadharFileUrl2", e, true)
																							}
																							className={cssClasses.uploadLabel}
																							style={{
																								cursor: "pointer",
																								textDecorationLine: "underline",
																							}}
																						>
																							<p>Delete</p>
																						</div>
																					</div>
																				</Box>
																			)}
																	</div>
																	{!agreementKYC.poaData.aadharFileUrl.url1 && (
																		<Box className={cssClasses.uploadDocumentCard}>
																			<div
																				className={cssClasses.uploadLabel}
																				style={{
																					cursor: "pointer",
																					textDecorationLine: "underline",
																				}}
																			>
																				<p
																					onClick={(e) =>
																						selectFiles(
																							i,
																							"aadharFileUrl",
																							e,
																							true,
																							agreementKYC.poaData.aadharFileUrl.type
																						)
																					}
																				>
																					<AddIcon
																						style={{
																							width: "45px",
																							height: "35px",
																						}}
																					/>
																				</p>
																			</div>
																		</Box>
																	)}
																	{!agreementKYC.poaData.aadharFileUrl.url2 &&
																		agreementKYC.poaData.aadharFileUrl.type !== "pdf" && (
																			<Box className={cssClasses.uploadDocumentCard} sx={{ marginTop: "1rem" }}>
																				<div
																					className={cssClasses.uploadLabel}
																					style={{
																						cursor: "pointer",
																						textDecorationLine: "underline",
																					}}
																				>
																					<p
																						onClick={(e) =>
																							selectFiles(
																								i,
																								"aadharFileUrl",
																								e,
																								true,
																								agreementKYC.poaData.aadharFileUrl.type
																							)
																						}
																					>
																						<AddIcon
																							style={{
																								width: "45px",
																								height: "35px",
																							}}
																						/>
																					</p>
																				</div>
																			</Box>
																		)}
																	<p
																		style={{
																			color: "#d32f2f",
																			fontSize: "1.4rem",
																			lineHeight: "1.66",
																		}}
																	>
																		{helperText[i].poaData.aadharFileUrl}
																	</p>
																</div>
																<div className={cssClasses.inputWrapper} style={{ width: "50%" }}>
																	<Typography sx={{ ...labelStyle }}>
																		Add PAN Card <span style={{ color: "red" }}>*</span>{" "}
																	</Typography>{" "}
																	{agreementKYC.poaData.panFileUrl.url && (
																		<Box className={cssClasses.uploadDocumentCard}>
																			<img
																				src={
																					agreementKYC.poaData.panFileUrl.type === "pdf"
																						? DocumentPDFIcon
																						: ImgIcon
																				}
																				alt="Pdf"
																				width={"40rem"}
																				height={"40rem"}
																			/>
																			<div className={cssClasses.uploadLabel} style={{ color: "#000000" }}>
																				<p>
																					{typeof agreementKYC.poaData.panFileUrl.url === "string"
																						? agreementKYC.poaData.panFileUrl.url?.split("/").pop()
																						: agreementKYC.poaData.panFileUrl.url.name}
																				</p>
																			</div>

																			<div
																				style={{
																					display: "flex",
																					flexDirection: "row",
																					gap: "2rem",
																					marginTop: "1rem",
																				}}
																			>
																				<div
																					onClick={() =>
																						handleOpenPreviewModal({
																							value: agreementKYC.poaData.panFileUrl.url,
																							type: agreementKYC.poaData.panFileUrl.type,
																						})
																					}
																					id="PDF"
																					className={cssClasses.uploadLabel}
																					style={{
																						cursor: "pointer",
																						textDecorationLine: "underline",
																					}}
																				>
																					<p>Preview</p>
																				</div>
																				<div
																					onClick={(e) => DeleteDoc(i, "deletePanFileUrl", e, true)}
																					className={cssClasses.uploadLabel}
																					style={{
																						cursor: "pointer",
																						textDecorationLine: "underline",
																					}}
																				>
																					<p>Delete</p>
																				</div>
																			</div>
																		</Box>
																	)}
																	{!agreementKYC.poaData.panFileUrl.url && (
																		<Box className={cssClasses.uploadDocumentCard}>
																			<div
																				className={cssClasses.uploadLabel}
																				style={{
																					cursor: "pointer",
																					textDecorationLine: "underline",
																				}}
																			>
																				<p
																					onClick={(e) =>
																						selectFiles(
																							i,
																							"panFileUrl",
																							e,
																							true,
																							agreementKYC.poaData.panFileUrl.type
																						)
																					}
																				>
																					<AddIcon
																						style={{
																							width: "45px",
																							height: "35px",
																						}}
																					/>
																				</p>
																			</div>
																		</Box>
																	)}
																	<p
																		style={{
																			color: "#d32f2f",
																			fontSize: "1.4rem",
																			lineHeight: "1.66",
																		}}
																	>
																		{helperText[i].poaData.panFileUrl}
																	</p>
																</div>
															</div>
														</div>
													)}
												</div>
											)
									)}

									{agreementKYCs.length > 1 &&
										agreementKYCs.map(
											(agreementKYC, i) =>
												i !== 0 && (
													<Accordion key={i} expanded={expanded === i} onChange={handleAccordianChange(i)}>
														{/* className={cssClasses.accordianWarpper} */}
														<div className={cssClasses.accordianWarpper}>
															<AccordionSummary aria-controls="panel1bh-content">
																<Typography
																	className={
																		expanded === i ? cssClasses.cardBodyHeader : cssClasses.ApplicantCountText
																	}
																	sx={{ width: "33%", flexShrink: 0 }}
																>
																	{`Applicant - ${i + 1}`}
																</Typography>
															</AccordionSummary>
															<div>
																<DeleteIcon
																	color={addBtnDisable ? "disabled" : "primary"}
																	style={{
																		width: "2.4rem",
																		height: "2.4rem",
																		cursor: "pointer",
																	}}
																	onClick={() => {
																		handleDeleteApplicant(i);
																		if (agreementKYC.applicantId !== "")
																			setDeleteUsers([...deleteUsers, agreementKYC.applicantId]);
																		let arrayDelete = [...filesToDelete];
																		if (typeof agreementKYC?.aadharFileUrl?.url1 === "string") {
																			arrayDelete.push(agreementKYC.aadharFileUrl.url1);
																		}
																		if (typeof agreementKYC?.aadharFileUrl?.url2 === "string") {
																			arrayDelete.push(agreementKYC.aadharFileUrl.url2);
																		}
																		if (typeof agreementKYC?.panFileUrl?.url === "string") {
																			arrayDelete.push(agreementKYC.panFileUrl.url);
																		}
																		if (typeof agreementKYC?.loanSanctionUrl?.url === "string") {
																			arrayDelete.push(agreementKYC.loanSanctionUrl.url);
																		}
																		if (agreementKYC.poa) {
																			if (typeof agreementKYC.poaData?.aadharFileUrl?.url1 === "string") {
																				arrayDelete.push(agreementKYC.poaData.aadharFileUrl.url1);
																			}
																			if (typeof agreementKYC.poaData?.aadharFileUrl?.url2 === "string") {
																				arrayDelete.push(agreementKYC.poaData.aadharFileUrl.url2);
																			}
																			if (typeof agreementKYC.poaData?.panFileUrl?.url === "string") {
																				arrayDelete.push(agreementKYC.poaData.panFileUrl.url);
																			}
																		}

																		setFilesToDelete(arrayDelete);
																		setAddBtnDisable(false);
																		setAddApplicantDisable(false);
																	}}
																/>
															</div>
														</div>
														<AccordionDetails>
															<div className={cssClasses.inputFieldsContent}>
																<div className={cssClasses.inputWrapper}>
																	<DropDown
																		disable={addBtnDisable}
																		list={salutationList}
																		label={"Salutation"}
																		placeHolder={"salutation"}
																		mandatory={true}
																		selectedValue={agreementKYC.salutation}
																		helperText={helperText[i].salutation}
																		onChangeSelect={(e) => {
																			handleAgreementChange(i, "salutation", e, false);
																		}}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		}}
																	/>
																</div>
																<div className={cssClasses.inputWrapper}>
																	<CustomInput
																		disabled={addBtnDisable}
																		placeholder={"First Name"}
																		label={"First Name"}
																		inputType={"text"}
																		mandatory={true}
																		value={agreementKYC.firstName}
																		helperText={helperText[i].firstName}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			textTransform: "uppercase"
																		}}
																		handleChange={(e) => {
																			handleAgreementChange(i, "firstName", e, false);
																		}}
																	/>
																</div>
																<div className={cssClasses.inputWrapper}>
																	<CustomInput
																		disabled={addBtnDisable}
																		placeholder={"Middle Name"}
																		label={"Middle Name"}
																		inputType={"text"}
																		mandatory={false}
																		value={agreementKYC.middleName}
																		helperText={helperText[i].middleName}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			textTransform: "uppercase"
																		}}
																		handleChange={(e) => {
																			handleAgreementChange(i, "middleName", e, false);
																		}}
																	/>
																</div>
																<div className={cssClasses.inputWrapper}>
																	<CustomInput
																		disabled={addBtnDisable}
																		placeholder={"Last Name"}
																		label={"Last Name"}
																		inputType={"text"}
																		mandatory={true}
																		value={agreementKYC.lastName}
																		helperText={helperText[i].lastName}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			textTransform: "uppercase"
																		}}
																		handleChange={(e) => {
																			handleAgreementChange(i, "lastName", e, false);
																		}}
																	/>
																</div>
															</div>
															<div className={cssClasses.inputFieldsContent}>
																<div
																	style={{ position: "relative", width: "30%" }}
																	className={cssClasses.inputWrapper}
																>
																	<div className={cssClasses.blockLabel}>
																		Date of Birth <span style={{ color: "red" }}> *</span>
																	</div>
																	<input
																		className={cssClasses.dateInput}
																		type="date"
																		value={agreementKYC.leadDob}
																		onChange={(e) => handleAgreementChange(i, "leadDob", e.target.value, false)}
																		name="LDOB"
																		disabled={addBtnDisable}
																		onKeyDown={(event) => {
																			event.preventDefault();
																		}}
																		max={get18YearsAgoDate()}
																	/>
																	<p
																		style={{
																			color: "#d32f2f",
																			fontSize: "1.4rem",
																			lineHeight: "1.66",
																		}}
																	>
																		{helperText[i].leadDob}
																	</p>
																</div>
																<div className={cssClasses.inputWrapper} style={{ width: "20%" }}>
																	<CustomInput
																		disabled={addBtnDisable}
																		placeholder={"Age"}
																		label={"Age"}
																		inputType={"number"}
																		mandatory={true}
																		value={agreementKYC.age}
																		helperText={helperText[i].age}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		}}
																		handleChange={(e) => {
																			handleAgreementChange(i, "age", e, false);
																		}}
																	/>
																</div>
																<div className={cssClasses.inputWrapper} style={{ width: "20%" }}>
																	<DropDown
																		disable={addBtnDisable}
																		list={["Male", "Female"]}
																		label={"Gender"}
																		placeHolder={"Gender"}
																		mandatory={true}
																		selectedValue={agreementKYC.gender}
																		helperText={helperText[i].gender}
																		onChangeSelect={(e) => {
																			handleAgreementChange(i, "gender", e, false);
																		}}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		}}
																	/>
																</div>
																<div className={cssClasses.inputWrapper} style={{ width: "30%" }}>
																	<DropDown
																		list={OccupationList}
																		label={"Occupation"}
																		placeHolder={"Occupation"}
																		mandatory={true}
																		selectedValue={agreementKYC.occupation}
																		helperText={helperText[i].occupation}
																		onChangeSelect={(e) => {
																			handleAgreementChange(i, "occupation", e, false);
																		}}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		}}
																	/>
																	{agreementKYC.occupation === "Other" && (
																		<CustomInput
																			label="Other Occupation"
																			mandatory
																			helperText={helperText[i].otherOccupation}
																			placeholder={"Occupation"}
																			inputType={"text"}
																			value={agreementKYC.otherOccupation}
																			style={{
																				background: "#FCFCFD",
																				borderRadius: "0.8rem",
																				border: "1px solid  #D0D5DD",
																				boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			}}
																			handleChange={(e) => {
																				const hasNumbers = /\d/.test(e);
																				if (!hasNumbers) {
																					handleAgreementChange(i, "otherOccupation", e, false);
																				}
																			}}
																		/>
																	)}
																</div>
															</div>
															<div className={cssClasses.inputFieldsContent}>
																<div
																	className={cssClasses.inputWrapper}
																	style={{
																		width: window.innerWidth > 1366 ? "50%" : "100%",
																	}}
																>
																	<CustomInput
																		disabled={addBtnDisable}
																		handleChange={(e) => {
																			handleAgreementChange(i, "aadharNumber", e, false);
																		}}
																		greenTick={aadharSuccess[`aadhar${i}`]}
																		placeholder={"Aadhar Card Number"}
																		label={"Aadhar Card Number"}
																		inputType={"text"}
																		mandatory={true}
																		helperText={helperText[i].aadharNumber}
																		value={agreementKYC.aadharNumber}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		}}
																	/>
																</div>
																<div
																	className={cssClasses.inputWrapper}
																	style={{
																		width: window.innerWidth > 1366 ? "50%" : "100%",
																	}}
																>
																	<CustomInput
																		disabled={addBtnDisable}
																		style={{
																			textTransform: "capitalize",
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		}}
																		handleChange={(e) => {
																			handleAgreementChange(i, "panNumber", e, false);
																		}}
																		greenTick={panSuccess[`pan${i}`]}
																		placeholder={"Pan Card Number"}
																		label={"Pan Card Number"}
																		inputType={"text"}
																		mandatory={true}
																		helperText={helperText[i].panNumber}
																		value={agreementKYC.panNumber}
																	/>
																</div>
																{panSuccess[`pan${i}`] && (
																	<div
																		className={cssClasses.inputWrapper}
																		style={{
																			width: window.innerWidth > 1366 ? "50%" : "100%",
																		}}
																	>
																		<CustomInput
																			disabled={true}
																			style={{
																				textTransform: "capitalize",
																				background: "#FCFCFD",
																				borderRadius: "0.8rem",
																				border: "1px solid  #D0D5DD",
																				boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			}}
																			handleChange={(e) => {
																				handleAgreementChange(i, "nameAsperPAN", e, false);
																			}}
																			placeholder={"Name as per PAN"}
																			label={"Name as per PAN"}
																			inputType={"text"}
																			mandatory={true}
																			helperText={helperText[i].nameAsperPAN}
																			value={agreementKYC.nameAsperPAN}
																		/>
																	</div>
																)}
															</div>
															<div className={cssClasses.addressCheckBox}>
																<div>Address</div>
																<Checkbox
																	color="default"
																	checked={agreementKYC.addressAsPrimaryApplicant}
																	onChange={(e) => {
																		handleAgreementChange(i, "addressAsPrimaryApplicant", e.target.checked, false);
																	}}
																	sx={{ "& .MuiSvgIcon-root": { fontSize: 16 } }}
																	inputProps={{ "aria-label": "controlled" }}
																/>
																<span>Same as Primary Applicant</span>
															</div>
															<div className={cssClasses.inputFieldsContent}>

																<div className={cssClasses.inputWrapper} style={{ width: "100%" }}>
																	<CustomInput
																		handleChange={(e) => {
																			handleAgreementChange(i, "addressLine1", e.toUpperCase(), false);
																		}}
																		placeholder={"Flat/House No. Appartment"}
																		label={"Address Line 1"}
																		inputType={"text"}
																		mandatory={true}
																		helperText={helperText[i].addressLine1}
																		value={agreementKYC.addressLine1}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			textTransform: "uppercase",
																		}}
																	/>
																</div>
															</div>
															<div className={cssClasses.inputFieldsContent}>
																<div className={cssClasses.inputWrapper} style={{ width: "100%" }}>
																	<CustomInput
																		handleChange={(e) => {
																			handleAgreementChange(i, "addressLine2", e.toUpperCase(), false);
																		}}
																		placeholder={"Area ,Street ,Sector, Village"}
																		label={"Address Line 2"}
																		inputType={"text"}
																		mandatory={true}
																		helperText={helperText[i].addressLine2}
																		value={agreementKYC.addressLine2}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			textTransform: "uppercase",
																		}}
																	/>
																</div>
															</div>
															<div className={cssClasses.inputFieldsContent}>
																<div className={cssClasses.inputWrapper} style={{ width: "100%" }}>
																	<CustomInput
																		handleChange={(e) => {
																			handleAgreementChange(i, "addressLine3", e.toUpperCase(), false);
																		}}
																		placeholder={"Landmark"}
																		label={"Address Line 3"}
																		inputType={"text"}
																		mandatory={true}
																		helperText={helperText[i].addressLine3}
																		value={agreementKYC.addressLine3}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			textTransform: "uppercase",
																		}}
																	/>
																</div>
															</div>
															<div className={cssClasses.inputFieldsContent}>
																<div
																	className={cssClasses.inputWrapper}
																	style={{
																		width: window.innerWidth > 1366 ? "50%" : "100%",
																	}}
																>
																	<div className={cssClasses.blockLabel}>
																		Pincode <span style={{ color: "red" }}> *</span>
																	</div>
																	<CustomAutoComplete
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		}}
																		placeholder={"Pincode"}
																		NoOptionsText={"Pincode Not Found"}
																		list={pincodes}
																		disable={false}
																		helperText={helperText[i].pincode}
																		value={agreementKYC?.pincode}
																		InitialValue={(e) => {
																			handleAgreementChange(i, "pincode", e, false);
																		}}
																		SecondInputValue={pincodeInput[`pin${i}`]}
																		OnInputChange={(e, _value) => {
																			let value = agreementKYC.addressAsPrimaryApplicant ? agreementKYCs[0].pincode : _value;
																			if (agreementKYC.addressAsPrimaryApplicant) {
																				helperText[i].pincode = ""
																			}
																			var numbers = new RegExp("^[0-9]{1,6}$");
																			if (value) {
																				if (numbers.test(value)) {
																					setPincodeInput({
																						...pincodeInput,
																						[`pin${i}`]: value,
																					});
																				}
																			} else {
																				setPincodeInput({
																					...pincodeInput,
																					[`pin${i}`]: "",
																				});
																				handleAgreementChange(i, "pincode", e, false);
																			}
																		}}
																		filterOptions={createFilterOptions({
																			matchFrom: "start",
																			limit: 10,
																		})}
																		renderOption={(props, option) => {
																			return (
																				<span {...props} style={{ backgroundColor: "#FCFCFD" }}>
																					{option}
																				</span>
																			);
																		}}
																	/>
																</div>
																<div
																	className={cssClasses.inputWrapper}
																	style={{
																		width: window.innerWidth > 1366 ? "50%" : "100%",
																	}}
																>
																	<CustomInput
																		placeholder={"Country"}
																		label={"Country"}
																		inputType={"text"}
																		mandatory={true}
																		disabled={true}
																		value={agreementKYC.country}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			textTransform: "uppercase",
																		}}
																	/>
																</div>
															</div>
															<div className={cssClasses.inputFieldsContent}>
																<div
																	className={cssClasses.inputWrapper}
																	style={{
																		width: window.innerWidth > 1366 ? "50%" : "100%",
																	}}
																>
																	<CustomInput
																		placeholder={"State"}
																		label={"State"}
																		inputType={"text"}
																		mandatory={true}
																		disabled={true}
																		value={agreementKYC.state}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			textTransform: "uppercase",
																		}}
																	/>
																</div>
																<div
																	className={cssClasses.inputWrapper}
																	style={{
																		width: window.innerWidth > 1366 ? "50%" : "100%",
																	}}
																>
																	<CustomInput
																		placeholder={"City"}
																		label={"City"}
																		inputType={"text"}
																		mandatory={true}
																		disabled={true}
																		value={agreementKYC.city}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																			textTransform: "uppercase",
																		}}
																	/>
																</div>
															</div>
															<div className={cssClasses.inputFieldsContent}>
																<div
																	className={cssClasses.inputWrapper}
																	style={{
																		width: window.innerWidth > 1366 ? "50%" : "100%",
																	}}
																>
																	<CustomInput
																		handleChange={(e) => {
																			handleAgreementChange(i, "contactNumber", e, false);
																		}}
																		placeholder={"Contact Number"}
																		label={"Contact Number"}
																		inputType={"mobile"}
																		mandatory={true}
																		helperText={helperText[i].contactNumber}
																		value={agreementKYC.contactNumber}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		}}
																	/>
																</div>
																<div
																	className={cssClasses.inputWrapper}
																	style={{
																		width: window.innerWidth > 1366 ? "50%" : "100%",
																	}}
																>
																	<CustomInput
																		handleChange={(e) => {
																			handleAgreementChange(i, "email", e, false);
																		}}
																		placeholder={"Email"}
																		label={"Email"}
																		inputType={"text"}
																		mandatory={true}
																		helperText={helperText[i].email}
																		value={agreementKYC.email}
																		style={{
																			background: "#FCFCFD",
																			borderRadius: "0.8rem",
																			border: "1px solid  #D0D5DD",
																			boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																		}}
																	/>
																</div>
															</div>
															<div
																style={{
																	width: "100%",
																	display: "flex",
																	gap: "1.6rem",
																}}
															>
																<div className={cssClasses.inputWrapper} style={{ width: "50%" }}>
																	<Typography sx={{ ...labelStyle }}>
																		Add Aadhar Card <span style={{ color: "red" }}>*</span>{" "}
																	</Typography>{" "}
																	<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
																		{agreementKYC.aadharFileUrl.url1 && (
																			<Box className={cssClasses.uploadDocumentCard}>
																				<img
																					src={
																						agreementKYC.aadharFileUrl.type === "pdf"
																							? DocumentPDFIcon
																							: ImgIcon
																					}
																					alt="Pdf"
																					width={"40rem"}
																					height={"40rem"}
																				/>
																				<div className={cssClasses.uploadLabel} style={{ color: "#000000" }}>
																					<p>
																						{typeof agreementKYC.aadharFileUrl.url1 === "string"
																							? agreementKYC.aadharFileUrl.url1?.split("/").pop()
																							: agreementKYC.aadharFileUrl.url1.name}
																					</p>
																				</div>

																				<div
																					style={{
																						display: "flex",
																						flexDirection: "row",
																						gap: "2rem",
																						marginTop: "1rem",
																					}}
																				>
																					<div
																						onClick={() =>
																							handleOpenPreviewModal({
																								value: agreementKYC.aadharFileUrl.url1,
																								type: agreementKYC.aadharFileUrl.type,
																							})
																						}
																						id="PDF"
																						className={cssClasses.uploadLabel}
																						style={{
																							cursor: "pointer",
																							textDecorationLine: "underline",
																						}}
																					>
																						<p>Preview</p>
																					</div>
																					<div
																						onClick={(e) =>
																							DeleteDoc(i, "deleteAadharFileUrl1", e, false)
																						}
																						className={cssClasses.uploadLabel}
																						style={{
																							cursor: addBtnDisable ? "default" : "pointer",
																							textDecorationLine: "underline",
																							opacity: addBtnDisable ? "0.5" : "1",
																						}}
																					>
																						<p>Delete</p>
																					</div>
																				</div>
																			</Box>
																		)}
																		{agreementKYC.aadharFileUrl.url2 &&
																			agreementKYC.aadharFileUrl.type !== "pdf" && (
																				<Box className={cssClasses.uploadDocumentCard}>
																					<img
																						src={
																							agreementKYC.aadharFileUrl.type === "pdf"
																								? DocumentPDFIcon
																								: ImgIcon
																						}
																						alt="Pdf"
																						width={"40rem"}
																						height={"40rem"}
																					/>
																					<div
																						className={cssClasses.uploadLabel}
																						style={{ color: "#000000" }}
																					>
																						<p>
																							{typeof agreementKYC.aadharFileUrl.url2 === "string"
																								? agreementKYC.aadharFileUrl.url2?.split("/").pop()
																								: agreementKYC.aadharFileUrl.url2.name}
																						</p>
																					</div>

																					<div
																						style={{
																							display: "flex",
																							flexDirection: "row",
																							gap: "2rem",
																							marginTop: "1rem",
																						}}
																					>
																						<div
																							onClick={() =>
																								handleOpenPreviewModal({
																									value: agreementKYC.aadharFileUrl.url2,
																									type: agreementKYC.aadharFileUrl.type,
																								})
																							}
																							id="PDF"
																							className={cssClasses.uploadLabel}
																							style={{
																								cursor: "pointer",
																								textDecorationLine: "underline",
																							}}
																						>
																							<p>Preview</p>
																						</div>
																						<div
																							onClick={(e) =>
																								DeleteDoc(i, "deleteAadharFileUrl2", e, false)
																							}
																							className={cssClasses.uploadLabel}
																							style={{
																								cursor: addBtnDisable ? "default" : "pointer",
																								textDecorationLine: "underline",
																								opacity: addBtnDisable ? "0.5" : "1",
																							}}
																						>
																							<p>Delete</p>
																						</div>
																					</div>
																				</Box>
																			)}
																	</div>
																	{!agreementKYC.aadharFileUrl.url1 && (
																		<Box
																			className={cssClasses.uploadDocumentCard}
																			sx={{
																				opacity: addBtnDisable ? "0.5" : "1",
																			}}
																		>
																			<div
																				className={cssClasses.uploadLabel}
																				style={{
																					cursor: addBtnDisable ? "default" : "pointer",
																					textDecorationLine: "underline",
																				}}
																			>
																				<p
																					onClick={(e) =>
																						selectFiles(
																							i,
																							"aadharFileUrl",
																							e,
																							false,
																							agreementKYC.aadharFileUrl.type
																						)
																					}
																				>
																					<AddIcon
																						style={{
																							width: "45px",
																							height: "35px",
																						}}
																					/>
																				</p>
																			</div>
																		</Box>
																	)}
																	{!agreementKYC.aadharFileUrl.url2 &&
																		agreementKYC.aadharFileUrl.type !== "pdf" && (
																			<Box
																				className={cssClasses.uploadDocumentCard}
																				sx={{
																					opacity: addBtnDisable ? "0.5" : "1",
																					marginTop: "1rem",
																				}}
																			>
																				<div
																					className={cssClasses.uploadLabel}
																					style={{
																						cursor: addBtnDisable ? "default" : "pointer",
																						textDecorationLine: "underline",
																					}}
																				>
																					<p
																						onClick={(e) =>
																							selectFiles(
																								i,
																								"aadharFileUrl",
																								e,
																								false,
																								agreementKYC.aadharFileUrl.type
																							)
																						}
																					>
																						<AddIcon
																							style={{
																								width: "45px",
																								height: "35px",
																							}}
																						/>
																					</p>
																				</div>
																			</Box>
																		)}
																	<p
																		style={{
																			color: "#d32f2f",
																			fontSize: "1.4rem",
																			lineHeight: "1.66",
																		}}
																	>
																		{helperText[i].aadharFileUrl}
																	</p>
																</div>
																<div className={cssClasses.inputWrapper} style={{ width: "50%" }}>
																	<Typography sx={{ ...labelStyle }}>
																		Add PAN Card <span style={{ color: "red" }}>*</span>{" "}
																	</Typography>{" "}
																	{agreementKYC.panFileUrl.url && (
																		<Box className={cssClasses.uploadDocumentCard}>
																			<img
																				src={
																					agreementKYC.panFileUrl.type === "pdf" ? DocumentPDFIcon : ImgIcon
																				}
																				alt="Pdf"
																				width={"40rem"}
																				height={"40rem"}
																			/>
																			<div className={cssClasses.uploadLabel} style={{ color: "#000000" }}>
																				<p>
																					{typeof agreementKYC.panFileUrl.url === "string"
																						? agreementKYC.panFileUrl.url?.split("/").pop()
																						: agreementKYC.panFileUrl.url.name}
																				</p>
																			</div>

																			<div
																				style={{
																					display: "flex",
																					flexDirection: "row",
																					gap: "2rem",
																					marginTop: "1rem",
																				}}
																			>
																				<div
																					onClick={() =>
																						handleOpenPreviewModal({
																							value: agreementKYC.panFileUrl.url,
																							type: agreementKYC.panFileUrl.type,
																						})
																					}
																					id="PDF"
																					className={cssClasses.uploadLabel}
																					style={{
																						cursor: "pointer",
																						textDecorationLine: "underline",
																					}}
																				>
																					<p>Preview</p>
																				</div>
																				<div
																					onClick={(e) => DeleteDoc(i, "deletePanFileUrl", e, false)}
																					className={cssClasses.uploadLabel}
																					style={{
																						cursor: addBtnDisable ? "default" : "pointer",
																						textDecorationLine: "underline",
																						opacity: addBtnDisable ? "0.5" : "1",
																					}}
																				>
																					<p>Delete</p>
																				</div>
																			</div>
																		</Box>
																	)}
																	{!agreementKYC.panFileUrl.url && (
																		<Box
																			className={cssClasses.uploadDocumentCard}
																			sx={{
																				opacity: addBtnDisable ? "0.5" : "1",
																			}}
																		>
																			<div
																				className={cssClasses.uploadLabel}
																				style={{
																					cursor: addBtnDisable ? "default" : "pointer",
																					textDecorationLine: "underline",
																				}}
																			>
																				<p
																					onClick={(e) =>
																						selectFiles(
																							i,
																							"panFileUrl",
																							e,
																							false,
																							agreementKYC.panFileUrl.type
																						)
																					}
																				>
																					<AddIcon
																						style={{
																							width: "45px",
																							height: "35px",
																						}}
																					/>
																				</p>
																			</div>
																		</Box>
																	)}
																	<p
																		style={{
																			color: "#d32f2f",
																			fontSize: "1.4rem",
																			lineHeight: "1.66",
																		}}
																	>
																		{helperText[i].panFileUrl}
																	</p>
																</div>
															</div>
															<div className={cssClasses.poaCheckBox}>
																<Checkbox
																	color="default"
																	checked={agreementKYC.poa}
																	onChange={(e) => {
																		handleAgreementChange(i, "poa", e.target.checked, false);
																	}}
																	sx={{
																		"& .MuiSvgIcon-root": { fontSize: 16 },
																	}}
																	inputProps={{ "aria-label": "controlled" }}
																/>
																<span>POA</span>
															</div>
															{agreementKYC.poa && (
																<div className={cssClasses.poaContent}>
																	<Divider style={{ marginBottom: "0.8rem" }} />
																	<div className={cssClasses.cardBodyHeader}>
																		<div>POA</div>
																	</div>
																	<div className={cssClasses.inputFieldsContent}>
																		<div className={cssClasses.inputWrapper}>
																			<DropDown
																				list={salutationList}
																				label={"Salutation"}
																				placeHolder={"salutation"}
																				mandatory={true}
																				selectedValue={agreementKYC.poaData.salutation}
																				helperText={helperText[i].poaData.salutation}
																				onChangeSelect={(e) => {
																					handleAgreementChange(i, "salutation", e, true);
																				}}
																				style={{
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																				}}
																			/>
																		</div>
																		<div className={cssClasses.inputWrapper}>
																			<CustomInput
																				placeholder={"First Name"}
																				label={"First Name"}
																				inputType={"text"}
																				mandatory={true}
																				value={agreementKYC.poaData.firstName}
																				helperText={helperText[i].poaData.firstName}
																				handleChange={(e) => {
																					handleAgreementChange(i, "firstName", e, true);
																				}}
																				style={{
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																					textTransform: "uppercase"
																				}}
																			/>
																		</div>
																		<div className={cssClasses.inputWrapper}>
																			<CustomInput
																				placeholder={"Middle Name"}
																				label={"Middle Name"}
																				inputType={"text"}
																				mandatory={false}
																				value={agreementKYC.poaData.middleName}
																				helperText={helperText[i].poaData.middleName}
																				style={{
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																					textTransform: "uppercase"
																				}}
																				handleChange={(e) => {
																					handleAgreementChange(i, "middleName", e, true);
																				}}
																			/>
																		</div>
																		<div className={cssClasses.inputWrapper}>
																			<CustomInput
																				placeholder={"Last Name"}
																				label={"Last Name"}
																				inputType={"text"}
																				mandatory={true}
																				value={agreementKYC.poaData.lastName}
																				helperText={helperText[i].poaData.lastName}
																				style={{
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																					textTransform: "uppercase"
																				}}
																				handleChange={(e) => {
																					handleAgreementChange(i, "lastName", e, true);
																				}}
																			/>
																		</div>
																	</div>
																	<div className={cssClasses.inputFieldsContent}>
																		<div className={cssClasses.inputWrapper} style={{ width: "20%" }}>
																			<CustomInput
																				placeholder={"Age"}
																				label={"Age"}
																				inputType={"number"}
																				mandatory={true}
																				value={agreementKYC.poaData.age}
																				helperText={helperText[i].poaData.age}
																				style={{
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																				}}
																				handleChange={(e) => {
																					handleAgreementChange(i, "age", e, true);
																				}}
																			/>
																		</div>
																		<div className={cssClasses.inputWrapper} style={{ width: "30%" }}>
																			<DropDown
																				list={["Male", "Female"]}
																				label={"Gender"}
																				placeHolder={"Gender"}
																				mandatory={true}
																				selectedValue={agreementKYC.poaData.gender}
																				helperText={helperText[i].poaData.gender}
																				onChangeSelect={(e) => {
																					handleAgreementChange(i, "gender", e, true);
																				}}
																				style={{
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																				}}
																			/>
																		</div>
																		<div className={cssClasses.inputWrapper} style={{ width: "50%" }}>
																			<DropDown
																				list={OccupationList}
																				label={"Occupation"}
																				placeHolder={"Occupation"}
																				mandatory={true}
																				selectedValue={agreementKYC.poaData.occupation}
																				helperText={helperText[i].poaData.occupation}
																				onChangeSelect={(e) => {
																					handleAgreementChange(i, "occupation", e, true);
																				}}
																				style={{
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																				}}
																			/>
																			{agreementKYC.poaData.occupation === "Other" && (
																				<CustomInput
																					label="Other Occupation"
																					mandatory
																					placeholder={"Occupation"}
																					inputType={"text"}
																					value={agreementKYC.poaData.otherOccupation}
																					style={{
																						background: "#FCFCFD",
																						borderRadius: "0.8rem",
																						border: "1px solid  #D0D5DD",
																						boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																					}}
																					handleChange={(e) => {
																						const hasNumbers = /\d/.test(e);
																						if (!hasNumbers) {
																							handleAgreementChange(i, "otherOccupation", e, true);
																						}
																					}}
																					helperText={helperText[i].poaData.otherOccupation}
																				/>
																			)}
																		</div>
																	</div>
																	<div className={cssClasses.inputFieldsContent}>
																		<div
																			className={cssClasses.inputWrapper}
																			style={{
																				width: window.innerWidth > 1366 ? "50%" : "100%",
																			}}
																		>
																			<CustomInput
																				handleChange={(e) => {
																					handleAgreementChange(i, "aadharNumber", e, true);
																				}}
																				greenTick={aadharSuccessPOA[`aadhar${i}`]}
																				placeholder={"Aadhar Card Number"}
																				label={"Aadhar Card Number"}
																				inputType={"text"}
																				mandatory={true}
																				helperText={helperText[i].poaData.aadharNumber}
																				value={agreementKYC.poaData.aadharNumber}
																				style={{
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																				}}
																			/>
																		</div>
																		<div
																			className={cssClasses.inputWrapper}
																			style={{
																				width: window.innerWidth > 1366 ? "50%" : "100%",
																			}}
																		>
																			<CustomInput
																				style={{
																					textTransform: "capitalize",
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																				}}
																				handleChange={(e) => {
																					handleAgreementChange(i, "panNumber", e, true);
																				}}
																				greenTick={panSuccessPOA[`pan${i}`]}
																				placeholder={"Pan Card Number"}
																				label={"Pan Card Number"}
																				inputType={"text"}
																				mandatory={true}
																				helperText={helperText[i].poaData.panNumber}
																				value={agreementKYC.poaData.panNumber}
																			/>
																		</div>
																		{panSuccessPOA[`pan${i}`] && (
																			<div
																				className={cssClasses.inputWrapper}
																				style={{
																					width: window.innerWidth > 1366 ? "50%" : "100%",
																				}}
																			>
																				<CustomInput
																					disabled={true}
																					style={{
																						textTransform: "capitalize",
																						background: "#FCFCFD",
																						borderRadius: "0.8rem",
																						border: "1px solid  #D0D5DD",
																						boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																					}}
																					handleChange={(e) => {
																						handleAgreementChange(i, "nameAsperPAN", e, true);
																					}}
																					placeholder={"Name as per PAN"}
																					label={"Name as per PAN"}
																					inputType={"text"}
																					mandatory={true}
																					helperText={helperText[i].poaData.nameAsperPAN}
																					value={agreementKYC.poaData.nameAsperPAN}
																				/>
																			</div>
																		)}
																	</div>
																	<div className={cssClasses.inputFieldsContent}>
																		<div className={cssClasses.inputWrapper} style={{ width: "100%" }}>
																			<CustomInput
																				handleChange={(e) => {
																					handleAgreementChange(i, "addressLine1", e.toUpperCase(), true);
																				}}
																				placeholder={"Flat/House No. Appartment"}
																				label={"Address Line 1"}
																				inputType={"text"}
																				mandatory={true}
																				helperText={helperText[i].poaData.addressLine1}
																				value={agreementKYC.poaData.addressLine1}
																				style={{
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																					textTransform: "uppercase",
																				}}
																			/>
																		</div>
																	</div>
																	<div className={cssClasses.inputFieldsContent}>
																		<div className={cssClasses.inputWrapper} style={{ width: "100%" }}>
																			<CustomInput
																				handleChange={(e) => {
																					handleAgreementChange(i, "addressLine2", e.toUpperCase(), true);
																				}}
																				placeholder={"Area ,Street ,Sector, Village"}
																				label={"Address Line 2"}
																				inputType={"text"}
																				mandatory={true}
																				helperText={helperText[i].poaData.addressLine2}
																				value={agreementKYC.poaData.addressLine2}
																				style={{
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																					textTransform: "uppercase",
																				}}
																			/>
																		</div>
																	</div>
																	<div className={cssClasses.inputFieldsContent}>
																		<div className={cssClasses.inputWrapper} style={{ width: "100%" }}>
																			<CustomInput
																				handleChange={(e) => {
																					handleAgreementChange(i, "addressLine3", e.toUpperCase(), true);
																				}}
																				placeholder={"Landmark"}
																				label={"Address Line 3"}
																				inputType={"text"}
																				mandatory={true}
																				helperText={helperText[i].poaData.addressLine3}
																				value={agreementKYC.poaData.addressLine3}
																				style={{
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																					textTransform: "uppercase",
																				}}
																			/>
																		</div>
																	</div>
																	<div className={cssClasses.inputFieldsContent}>
																		<div
																			className={cssClasses.inputWrapper}
																			style={{
																				width: window.innerWidth > 1366 ? "50%" : "100%",
																			}}
																		>
																			<div className={cssClasses.blockLabel}>
																				Pincode <span style={{ color: "red" }}> *</span>
																			</div>
																			<CustomAutoComplete
																				style={{
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																				}}
																				placeholder={"Pincode"}
																				NoOptionsText={"Pincode Not Found"}
																				list={pincodes}
																				disable={false}
																				helperText={helperText[i].poaData.pincode}
																				value={agreementKYC?.poaData?.pincode}
																				InitialValue={(e) => {
																					handleAgreementChange(i, "pincode", e, true);
																				}}
																				// SecondInputValue={pincodeInput}
																				// SecondInputValue={i == 1? poaPincode : i ==2 ? poaPincode1 : poaPincode2}
																				SecondInputValue={poaPincodeInput[`pin${i}`]}
																				OnInputChange={(e, value) => {
																					var numbers = new RegExp("^[0-9]{1,6}$");
																					if (value) {
																						if (numbers.test(value)) {
																							// setPincodeInput(value);
																							// i == 1? setPoaPincode(value) : i ==2 ? setPoaPincode1(value) : setPoaPincode2(value)
																							setPoaPincodeInput({
																								...poaPincodeInput,
																								[`pin${i}`]: value,
																							});
																						}
																					} else {
																						// setPincodeInput("");
																						// i == 1? setPoaPincode("") : i ==2 ? setPoaPincode1("") : setPoaPincode2("");
																						setPoaPincodeInput({
																							...poaPincodeInput,
																							[`pin${i}`]: "",
																						});
																						handleAgreementChange(i, "pincode", e, true);
																					}
																				}}
																				filterOptions={createFilterOptions({
																					matchFrom: "start",
																					limit: 10,
																				})}
																				renderOption={(props, option) => {
																					return (
																						<span
																							{...props}
																							style={{
																								backgroundColor: "#FCFCFD",
																							}}
																						>
																							{option}
																						</span>
																					);
																				}}
																			/>
																		</div>
																		<div
																			className={cssClasses.inputWrapper}
																			style={{
																				width: window.innerWidth > 1366 ? "50%" : "100%",
																			}}
																		>
																			<CustomInput
																				placeholder={"Country"}
																				label={"Country"}
																				inputType={"text"}
																				mandatory={true}
																				disabled={true}
																				value={agreementKYC.poaData.country}
																				style={{
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																					textTransform: "uppercase",
																				}}
																			/>
																		</div>
																	</div>
																	<div className={cssClasses.inputFieldsContent}>
																		<div
																			className={cssClasses.inputWrapper}
																			style={{
																				width: window.innerWidth > 1366 ? "50%" : "100%",
																			}}
																		>
																			<CustomInput
																				placeholder={"State"}
																				label={"State"}
																				inputType={"text"}
																				mandatory={true}
																				disabled={true}
																				value={agreementKYC.poaData.state}
																				style={{
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																					textTransform: "uppercase",
																				}}
																			/>
																		</div>
																		<div
																			className={cssClasses.inputWrapper}
																			style={{
																				width: window.innerWidth > 1366 ? "50%" : "100%",
																			}}
																		>
																			<CustomInput
																				placeholder={"City"}
																				label={"City"}
																				inputType={"text"}
																				mandatory={true}
																				disabled={true}
																				value={agreementKYC.poaData.city}
																				style={{
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																					textTransform: "uppercase",
																				}}
																			/>
																		</div>
																	</div>
																	<div className={cssClasses.inputFieldsContent}>
																		<div
																			className={cssClasses.inputWrapper}
																			style={{
																				width: window.innerWidth > 1366 ? "50%" : "100%",
																			}}
																		>
																			<CustomInput
																				handleChange={(e) => {
																					handleAgreementChange(i, "contactNumber", e, true);
																				}}
																				placeholder={"Contact Number"}
																				label={"Contact Number"}
																				inputType={"mobile"}
																				mandatory={true}
																				helperText={helperText[i].poaData.contactNumber}
																				value={agreementKYC.poaData.contactNumber}
																				style={{
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																				}}
																			/>
																		</div>
																		<div
																			className={cssClasses.inputWrapper}
																			style={{
																				width: window.innerWidth > 1366 ? "50%" : "100%",
																			}}
																		>
																			<CustomInput
																				handleChange={(e) => {
																					handleAgreementChange(i, "email", e, true);
																				}}
																				placeholder={"Email"}
																				label={"Email"}
																				inputType={"text"}
																				mandatory={true}
																				helperText={helperText[i].poaData.email}
																				value={agreementKYC.poaData.email}
																				style={{
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																				}}
																			/>
																		</div>
																	</div>
																	<div
																		style={{
																			width: "100%",
																			display: "flex",
																			gap: "1.6rem",
																		}}
																	>
																		<div className={cssClasses.inputWrapper} style={{ width: "50%" }}>
																			<Typography sx={{ ...labelStyle }}>
																				Add Aadhar Card <span style={{ color: "red" }}>*</span>{" "}
																			</Typography>{" "}
																			<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
																				{agreementKYC.poaData.aadharFileUrl.url1 && (
																					<Box className={cssClasses.uploadDocumentCard}>
																						<img
																							src={
																								agreementKYC.poaData.aadharFileUrl.type === "pdf"
																									? DocumentPDFIcon
																									: ImgIcon
																							}
																							alt="Pdf"
																							width={"40rem"}
																							height={"40rem"}
																						/>
																						<div
																							className={cssClasses.uploadLabel}
																							style={{ color: "#000000" }}
																						>
																							<p>
																								{typeof agreementKYC.poaData.aadharFileUrl.url1 ===
																									"string"
																									? agreementKYC.poaData.aadharFileUrl.url1
																										?.split("/")
																										.pop()
																									: agreementKYC.poaData.aadharFileUrl.url1.name}
																							</p>
																						</div>

																						<div
																							style={{
																								display: "flex",
																								flexDirection: "row",
																								gap: "2rem",
																								marginTop: "1rem",
																							}}
																						>
																							<div
																								onClick={() =>
																									handleOpenPreviewModal({
																										value: agreementKYC.poaData.aadharFileUrl
																											.url1,
																										type: agreementKYC.poaData.aadharFileUrl.type,
																									})
																								}
																								id="PDF"
																								className={cssClasses.uploadLabel}
																								style={{
																									cursor: "pointer",
																									textDecorationLine: "underline",
																								}}
																							>
																								<p>Preview</p>
																							</div>
																							<div
																								onClick={(e) =>
																									DeleteDoc(i, "deleteAadharFileUrl1", e, true)
																								}
																								className={cssClasses.uploadLabel}
																								style={{
																									cursor: "pointer",
																									textDecorationLine: "underline",
																								}}
																							>
																								<p>Delete</p>
																							</div>
																						</div>
																					</Box>
																				)}
																				{agreementKYC.poaData.aadharFileUrl.url2 &&
																					agreementKYC.poaData.aadharFileUrl.type !== "pdf" && (
																						<Box className={cssClasses.uploadDocumentCard}>
																							<img
																								src={
																									agreementKYC.poaData.aadharFileUrl.type === "pdf"
																										? DocumentPDFIcon
																										: ImgIcon
																								}
																								alt="Pdf"
																								width={"40rem"}
																								height={"40rem"}
																							/>
																							<div
																								className={cssClasses.uploadLabel}
																								style={{ color: "#000000" }}
																							>
																								<p>
																									{typeof agreementKYC.poaData.aadharFileUrl
																										.url2 === "string"
																										? agreementKYC.poaData.aadharFileUrl.url2
																											?.split("/")
																											.pop()
																										: agreementKYC.poaData.aadharFileUrl.url2
																											.name}
																								</p>
																							</div>

																							<div
																								style={{
																									display: "flex",
																									flexDirection: "row",
																									gap: "2rem",
																									marginTop: "1rem",
																								}}
																							>
																								<div
																									onClick={() =>
																										handleOpenPreviewModal({
																											value: agreementKYC.poaData.aadharFileUrl
																												.url2,
																											type: agreementKYC.poaData.aadharFileUrl
																												.type,
																										})
																									}
																									id="PDF"
																									className={cssClasses.uploadLabel}
																									style={{
																										cursor: "pointer",
																										textDecorationLine: "underline",
																									}}
																								>
																									<p>Preview</p>
																								</div>
																								<div
																									onClick={(e) =>
																										DeleteDoc(i, "deleteAadharFileUrl2", e, true)
																									}
																									className={cssClasses.uploadLabel}
																									style={{
																										cursor: "pointer",
																										textDecorationLine: "underline",
																									}}
																								>
																									<p>Delete</p>
																								</div>
																							</div>
																						</Box>
																					)}
																			</div>
																			{!agreementKYC.poaData.aadharFileUrl.url1 && (
																				<Box className={cssClasses.uploadDocumentCard}>
																					<div
																						className={cssClasses.uploadLabel}
																						style={{
																							cursor: "pointer",
																							textDecorationLine: "underline",
																						}}
																					>
																						<p
																							onClick={(e) =>
																								selectFiles(
																									i,
																									"aadharFileUrl",
																									e,
																									true,
																									agreementKYC.poaData.aadharFileUrl.type
																								)
																							}
																						>
																							<AddIcon
																								style={{
																									width: "45px",
																									height: "35px",
																								}}
																							/>
																						</p>
																					</div>
																				</Box>
																			)}
																			{!agreementKYC.poaData.aadharFileUrl.url2 &&
																				agreementKYC.poaData.aadharFileUrl.type !== "pdf" && (
																					<Box
																						className={cssClasses.uploadDocumentCard}
																						sx={{ marginTop: "1rem" }}
																					>
																						<div
																							className={cssClasses.uploadLabel}
																							style={{
																								cursor: "pointer",
																								textDecorationLine: "underline",
																							}}
																						>
																							<p
																								onClick={(e) =>
																									selectFiles(
																										i,
																										"aadharFileUrl",
																										e,
																										true,
																										agreementKYC.poaData.aadharFileUrl.type
																									)
																								}
																							>
																								<AddIcon
																									style={{
																										width: "45px",
																										height: "35px",
																									}}
																								/>
																							</p>
																						</div>
																					</Box>
																				)}
																			<p
																				style={{
																					color: "#d32f2f",
																					fontSize: "1.4rem",
																					lineHeight: "1.66",
																				}}
																			>
																				{helperText[i].poaData.aadharFileUrl}
																			</p>
																		</div>
																		<div className={cssClasses.inputWrapper} style={{ width: "50%" }}>
																			<Typography sx={{ ...labelStyle }}>
																				Add PAN Card <span style={{ color: "red" }}>*</span>{" "}
																			</Typography>{" "}
																			{agreementKYC.poaData.panFileUrl.url && (
																				<Box className={cssClasses.uploadDocumentCard}>
																					<img
																						src={
																							agreementKYC.poaData.panFileUrl.type === "pdf"
																								? DocumentPDFIcon
																								: ImgIcon
																						}
																						alt="Pdf"
																						width={"40rem"}
																						height={"40rem"}
																					/>
																					<div
																						className={cssClasses.uploadLabel}
																						style={{ color: "#000000" }}
																					>
																						<p>
																							{typeof agreementKYC.poaData.panFileUrl.url === "string"
																								? agreementKYC.poaData.panFileUrl.url
																									?.split("/")
																									.pop()
																								: agreementKYC.poaData.panFileUrl.url.name}
																						</p>
																					</div>

																					<div
																						style={{
																							display: "flex",
																							flexDirection: "row",
																							gap: "2rem",
																							marginTop: "1rem",
																						}}
																					>
																						<div
																							onClick={() =>
																								handleOpenPreviewModal({
																									value: agreementKYC.poaData.panFileUrl.url,
																									type: agreementKYC.poaData.panFileUrl.type,
																								})
																							}
																							id="PDF"
																							className={cssClasses.uploadLabel}
																							style={{
																								cursor: "pointer",
																								textDecorationLine: "underline",
																							}}
																						>
																							<p>Preview</p>
																						</div>
																						<div
																							onClick={(e) => DeleteDoc(i, "deletePanFileUrl", e, true)}
																							className={cssClasses.uploadLabel}
																							style={{
																								cursor: "pointer",
																								textDecorationLine: "underline",
																							}}
																						>
																							<p>Delete</p>
																						</div>
																					</div>
																				</Box>
																			)}
																			{!agreementKYC.poaData.panFileUrl.url && (
																				<Box className={cssClasses.uploadDocumentCard}>
																					<div
																						className={cssClasses.uploadLabel}
																						style={{
																							cursor: "pointer",
																							textDecorationLine: "underline",
																						}}
																					>
																						<p
																							onClick={(e) =>
																								selectFiles(
																									i,
																									"panFileUrl",
																									e,
																									true,
																									agreementKYC.poaData.panFileUrl.type
																								)
																							}
																						>
																							<AddIcon
																								style={{
																									width: "45px",
																									height: "35px",
																								}}
																							/>
																						</p>
																					</div>
																				</Box>
																			)}
																			<p
																				style={{
																					color: "#d32f2f",
																					fontSize: "1.4rem",
																					lineHeight: "1.66",
																				}}
																			>
																				{helperText[i].poaData.panFileUrl}
																			</p>
																		</div>
																	</div>
																</div>
															)}
														</AccordionDetails>
													</Accordion>
												)
										)}
									{allotment?.isCrm2 && (
										<div className={cssClasses.inputFieldsMainContent}>
											<Crm2BankBlock value={crm2Bank} onChange={setCrm2Bank} errors={crm2BankErrors} />
										</div>
									)}
									<div className={cssClasses.inputFieldsMainContent}>
										<div className={cssClasses.loanDetailsContent}>
										<div className={cssClasses.selfFundedCardBody}>
												<FormControl
													style={{
														flexDirection: "row",
														alignItems: "center",
														gap: "2rem",
													}}
												>
												<FormLabel id="demo-controlled-radio-buttons-group" className={cssClasses.selfFundedText}>
													Are you opting for loan?
												</FormLabel>
												<RadioGroup
													row
													aria-labelledby="demo-controlled-radio-buttons-group"
													name="controlled-radio-buttons-group"
													value={value}
													onChange={handleChange}
												>
													<FormControlLabel
														className={cssClasses.selfFundedText}
														value="yes"
														control={<Radio color="default" />}
														label={<Typography className={cssClasses.selfFundedText}>Yes</Typography>}
													/>
													<FormControlLabel
														className={cssClasses.selfFundedText}
														value="no"
														control={<Radio color="default" />}
														label={<Typography className={cssClasses.selfFundedText}>No</Typography>}
													/>
												</RadioGroup>
											</FormControl>
											{value === "yes" && (
												<FormControl
													style={{
														flexDirection: "row",
														alignItems: "center",
														gap: "2rem",
													}}
												>
													<FormLabel className={cssClasses.selfFundedText}>Loan Source</FormLabel>
													<RadioGroup
														row
														aria-labelledby="loan-source-radio-buttons-group"
														name="loan-source-radio-buttons-group"
														value={loanSource}
														onChange={(e) => {
															setLoanSource(e.target.value);
															setShowHelperText(false);
														}}
													>
														<FormControlLabel
															className={cssClasses.selfFundedText}
															value="VJ"
															control={<Radio color="default" />}
															label={<Typography className={cssClasses.selfFundedText}>VJ</Typography>}
														/>
														<FormControlLabel
															className={cssClasses.selfFundedText}
															value="Other"
															control={<Radio color="default" />}
															label={<Typography className={cssClasses.selfFundedText}>Other</Typography>}
														/>
													</RadioGroup>
													{showHelperText && !loanSource && (
														<Typography style={{ color: "#d32f2f", fontSize: "1.2rem", marginLeft: "1rem" }}>Please select loan source</Typography>
													)}
												</FormControl>
											)}
											{value === "yes" && loanSource && (
												<FormControl
														style={{
															flexDirection: "row",
															alignItems: "center",
															gap: "2rem",
														}}
													sx={{
														"& .MuiFormGroup-root": {
															width: "100%",
															gap: "1rem",
														},
													}}
												>
													<RadioGroup
														aria-labelledby="demo-controlled-radio-buttons-group"
														name="controlled-radio-buttons-group"
														value={selfFundedValue}
														onChange={handleSelfFundedValueChange}
													>
															{/* <div className={cssClasses.loanOption}>
															<FormControlLabel
																className={cssClasses.selfFundedText}
																value="nbfc"
																control={<Radio color="default" />}
																label={<Typography className={cssClasses.selfFundedText}>NBFC</Typography>}
															/>
															{selfFundedValue === "nbfc" && (
																<DropDown
																	list={nbfcList.map((element, id) => {
																		return {
																			label: element?.nbfcName,
																			value: element?.nbfcId,
																		};
																	})}
																	helperText={showHelperText ? "Please select loan option" : ""}
																	placeHolder={"Select"}
																	selectedValue={loanData}
																	onChangeSelect={(e) => {
																		setLoanData(e);
																	}}
																	style={{
																		background: "#FCFCFD",
																		borderRadius: "0.8rem",
																		border: "1px solid  #D0D5DD",
																		boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																	}}
																/>
															)}
															</div> */}
														<div className={cssClasses.loanOption}>
															<FormControlLabel
																className={cssClasses.selfFundedText}
																value="bank"
																control={<Radio color="default" />}
																label={<Typography className={cssClasses.selfFundedText}>Bank</Typography>}
															/>
															{selfFundedValue === "bank" && (
																	<div style={{ display: "flex", flexDirection: "column", gap: "0.8rem" }}>
																<DropDown
																		list={[...bankList.map((element) => {
																		return {
																			label: element?.bankName,
																			value: element?.bankId,
																		};
																			}), { label: "Other", value: "Other" }]}
																			helperText={(showHelperText && loanData !== "Other") ? "Please select loan option" : ""}
																	placeHolder={"Select"}
																	selectedValue={loanData}
																	onChangeSelect={(e) => {
																		setLoanData(e);
																				if (loanData !== "Other") {
																					setOtherBank("");
																				}
																				setShowHelperText(false);
																	}}
																	style={{
																		background: "#FCFCFD",
																		borderRadius: "0.8rem",
																		border: "1px solid  #D0D5DD",
																		boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																	}}
																/>
																		{loanData === "Other" && (
																			<CustomInput
																				label="Other Bank"
																				mandatory
																				helperText={showHelperText ? "Please enter Bank Name" : ""}
																				placeholder={"Bank Name"}
																				inputType={"text"}
																				value={otherBank}
																				style={{
																					background: "#FCFCFD",
																					borderRadius: "0.8rem",
																					border: "1px solid  #D0D5DD",
																					boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
																				}}
																				handleChange={(e) => {
																					setOtherBank(e);
																					if (e.length === 0) {
																						setShowHelperText(true)
																					} else {
																						setShowHelperText(false);
																					}

																				}}
																			/>
																		)}
																	</div>

															)}
														</div>
													</RadioGroup>
												</FormControl>
											)}
											</div>
											{value === "yes" && <div className={cssClasses.bankDetailsContent}><div className={cssClasses.inputWrapper}>
												<CustomInput
													placeholder={" Banker Name"}
													label={"Banker Name"}
													inputType={"text"}
													mandatory={true}
													value={bankerDetails.name}
													helperText={bankerDetailsHelperText.name}
													style={{
														background: "#FCFCFD",
														borderRadius: "0.8rem",
														border: "1px solid  #D0D5DD",
														boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
													}}
													handleChange={(e) => {
														setBankerDetails((pre) => {
															pre.name = e;
															return { ...pre };
														});
														if (e.length > 0) {
															setBankerDetailsHelperText((pre) => {
																pre.name = "";
																return { ...pre };
															});
														} else {
															setBankerDetailsHelperText((pre) => {
																pre.name = "Please Enter Banker Name";
																return { ...pre };
															});
														}
													}}
												/>
											</div><div
												className={cssClasses.inputWrapper}
												style={{
													width: window.innerWidth > 1366 ? "50%" : "100%",
												}}
											>
													<CustomInput
														handleChange={(e) => {
															setBankerDetails((pre) => {
																pre.contactNumber = e;
																return { ...pre };
															});
															if (e.length > 0) {
																setBankerDetailsHelperText((pre) => {
																	pre.contactNumber = "";
																	return { ...pre };
																});
															} else {
																setBankerDetailsHelperText((pre) => {
																	pre.contactNumber = "Please Enter Banker Contact Number";
																	return { ...pre };
																});
															}
														}}
														placeholder={"Banker Contact Number"}
														label={"Banker Contact Number"}
														inputType={"mobile"}
														mandatory={true}
														helperText={bankerDetailsHelperText.contactNumber}
														value={bankerDetails.contactNumber}
														style={{
															background: "#FCFCFD",
															borderRadius: "0.8rem",
															border: "1px solid  #D0D5DD",
															boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
														}}
													/>
												</div></div>}
										</div>
										{value === "yes" && <div className={cssClasses.inputWrapper} style={{ width: "50%" }}>
											<Typography sx={{ ...labelStyle }}>
												Add Loan Sanction Letter <span style={{ color: "red" }}>*</span>{" "}
											</Typography>{" "}
											<div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
												{agreementKYCs[0].loanSanctionUrl.url && (
													<Box className={cssClasses.uploadDocumentCard}>
														<img
															src={
																agreementKYCs[0].loanSanctionUrl.type === "pdf" ? DocumentPDFIcon : ImgIcon
															}
															alt="Pdf"
															width={"40rem"}
															height={"40rem"}
														/>
														<div className={cssClasses.uploadLabel} style={{ color: "#000000" }}>
															<p>
																{typeof agreementKYCs[0].loanSanctionUrl.url === "string"
																	? agreementKYCs[0].loanSanctionUrl.url?.split("/").pop()
																	: agreementKYCs[0].loanSanctionUrl.url.name}
															</p>
														</div>

														<div
															style={{
																display: "flex",
																flexDirection: "row",
																gap: "2rem",
																marginTop: "1rem",
															}}
														>
															<div
																onClick={() =>
																	handleOpenPreviewModal({
																		value: agreementKYCs[0].loanSanctionUrl.url,
																		type: agreementKYCs[0].loanSanctionUrl.type,
																	})
																}
																id="PDF"
																className={cssClasses.uploadLabel}
																style={{
																	cursor: "pointer",
																	textDecorationLine: "underline",
																}}
															>
																<p>Preview</p>
															</div>
															<div
																onClick={(e) => DeleteDoc(0, "deleteloanSanctionUrl", e, false, true)}
																className={cssClasses.uploadLabel}
																style={{
																	cursor: "pointer",
																	textDecorationLine: "underline",
																	opacity: "1",
																}}
															>
																<p>Delete</p>
															</div>
														</div>
													</Box>
												)}
											</div>
											{!agreementKYCs[0].loanSanctionUrl.url && (
												<Box
													className={cssClasses.uploadDocumentCard}
													sx={{ opacity: "1" }}
												>
													<div
														className={cssClasses.uploadLabel}
														style={{
															cursor: "pointer",
															textDecorationLine: "underline",
														}}
													>
														<p
															onClick={(e) =>
																selectFiles(
																	0,
																	"loanSanctionUrl",
																	e,
																	false,
																	agreementKYCs[0].loanSanctionUrl.type, true
																)
															}
														>
															<AddIcon
																style={{
																	width: "45px",
																	height: "35px",
																}}
															/>
														</p>
													</div>
												</Box>
											)}
											<p
												style={{
													color: "#d32f2f",
													fontSize: "1.4rem",
													lineHeight: "1.66",
												}}
											>
												{helperText[0].loanSanctionUrl}
											</p>
										</div>}
										<div className={cssClasses.selfFundedText}>
											{value === "yes" ? (
												<>
													<span style={{ color: "red" }}>*</span> I would like to put on record that I am availing finance
													for the said Flat from a Bank/Financial Institution and the balance I am paying through
													self-funding. I assure and confirm and consent that if in any case I am unable to pay timely
													payment towards the consideration of the said Flat I shall liable to pay interest on the same and
													further you shall also have due right to cancel the booking of the said Flat after giving
													reasonable opportunity of 15 ( fifteen days ).
												</>
											) : (
												<>
													<span style={{ color: "red" }}>*</span> I would like to put on record that I am not availing any
													finance for the said Flat from any Bank/Financial Institution and I am purchasing the said Flat
													through self funding. I assure and confirm and consent that if in any case I am unable to pay
													timely payment towards the consideration of the said Flat I shall be liable to pay interest on the
													same and further you shall also have due right to cancel the booking of the said Flat after giving
													reasonable opportunity of 15 ( fifteen days ).
												</>
											)}
										</div>
									</div>
								</div>
							</div>
							<div className={cssClasses.wrapperFooter}>
								<Button
									btnName="Save"
									clicked={handleSaveClick}
									style={{
										color: "#fff",
										backgroundColor: "rgb(21, 112, 239)",
										fontSize: "1.4rem",
										lineHeight: "2rem",
										fontFamily: "Inter-Medium !important",
										width: "20%",
									}}
								></Button>
							</div>
						</div>
					</Box>
				</Box>
			</Modal>
			<>
				{openConfirmationModal && (
					<ConfirmationAlert
						close={() => {
							setOpenConfirmationModal(false);
						}}
						open={openConfirmationModal}
						buttonTitle={"No"}
						returnRespButton={"Yes"}
						title={"Warning"}
						subTitle={"Do you want to continue with PAN name?"}
						confirm={(e) => {
							ModalResp(e);
						}}
					/>
				)}
			</>
			<>
				{openChangeReqConfirmationModal && (
					<ConfirmationAlert
						close={() => {
							setOpenChangeReqConfirmationModal(false);
						}}
						open={openChangeReqConfirmationModal}
						buttonTitle={"Cancel"}
						returnRespButton={"Confirm"}
						title={"Warning"}
						subTitle={"Are you sure you want to change the applicant?"}
						confirm={(e) => {
							ChangeModalResp(e);
						}}
					/>
				)}
			</>
			<>
				{showPreviewModal && (
					<PreviewModal
						open={showPreviewModal}
						handleClose={() => {
							setShowPreviewModal(false);
						}}
						value={selectedFile}
					/>
				)}
			</>
			<>
				{showAgreementTerms && (
					<AgreementTermsAndConditions
						open={showAgreementTerms}
						handleClose={() => {
							setShowAgreementTerms(false);
						}}
						onAgree={() => {
							setShowAgreementTerms(false);
							saveForm();
						}}
						companyDetails={companyDetails}
					/>
				)}
			</>
		</>
	);
};

export default AgreementKYC;
